var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 393,
    viewBox: "0 0 1920 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3803 97.5486C76.9966 90.1124 77.1561 77.8961 69.7365 70.2628C62.3169 62.6294 50.1279 62.4696 42.5116 69.9058C34.8953 77.342 34.7358 89.5583 42.1554 97.1916C49.575 104.825 61.764 104.985 69.3803 97.5486Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6125 83.6218L29.1121 83.3295C28.9662 90.1999 31.5916 97.0703 36.6964 102.333C47.0519 112.858 63.9707 113.15 74.472 102.771C79.7227 97.655 82.4939 90.7846 82.4939 83.9142H79.1393",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5303 70.0272C45.3015 76.1667 60.616 83.768 69.6588 70.3196",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4674 92.9773C45.3015 86.3993 62.0744 83.0371 73.0133 92.8311",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8474 107.01L74.6177 102.771",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8886 123.967L95.6205 102.625C95.6205 102.625 92.1201 99.4092 88.3279 103.064C86.5777 101.309 84.5358 101.748 82.6397 103.648C80.5978 105.549 76.5139 109.642 75.2013 110.811C73.8886 112.127 72.8676 114.758 74.6178 116.658C73.1593 118.412 71.1174 121.044 73.8886 123.967Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.26609 189.539C4.98916 185.635 5.66063 178.634 1.76586 173.9C-2.12892 169.166 -9.11506 168.493 -13.8381 172.397C-18.5612 176.3 -19.2327 183.302 -15.3379 188.036C-11.4431 192.769 -4.45698 193.442 0.26609 189.539Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.1859 180.977L-22.2278 180.831C-22.2278 184.777 -20.7693 188.724 -17.8522 191.794C-11.8723 197.933 -2.10022 198.08 4.02556 192.086C7.08845 189.163 8.69282 185.216 8.69282 181.269H6.79674",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.4977 173.083C-12.8933 176.591 -3.99635 180.977 1.25432 173.229",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.2479 186.239C-12.8933 182.439 -3.1212 180.538 3.15044 186.093",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.505 194.425L4.02551 191.94",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.588 204.219L16.1313 191.94C16.1313 191.94 14.0893 190.04 11.9016 192.233C10.8806 191.209 9.71377 191.502 8.54696 192.671C7.38014 193.84 5.04652 196.033 4.31726 196.91C3.588 197.641 3.00459 199.249 4.02555 200.272C3.15044 201.003 1.98363 202.611 3.588 204.219Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.865 195.595L22.9863 210.212L38.1549 181.561L67.1795 166.944L51.865 195.595Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9287 177.615L76.6598 192.671C76.6598 192.671 77.2432 200.126 66.7418 210.359C56.2405 220.591 48.6562 220.006 48.6562 220.006L33.9252 204.95",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4868 209.043L44.8641 227.9",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.948 228.046C50.1148 229.216 50.1148 231.262 48.948 232.432C47.7812 233.601 45.7393 233.601 44.5724 232.432C43.4056 231.262 43.4056 229.216 44.5724 228.046C45.8851 226.731 47.7812 226.731 48.948 228.046Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1147 235.209C50.1147 235.209 50.844 239.156 53.1776 241.495C54.3445 240.325 58.4283 236.378 58.4283 236.378C58.4283 236.378 54.782 233.455 52.1567 233.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5023 109.499L-14.8251 135.204L20.0839 171.119L46.4113 145.414L11.5023 109.499Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5688 111.103L17.5898 109.934L52.5942 145.894L26.195 171.767L25.0282 170.452",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.151995 126.375L-9.04169 135.351L-0.289001 144.356L8.90468 135.38L0.151995 126.375Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44208 123.529L10.8805 116.22",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65082 126.744L14.0893 119.582",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92157 149.987L25.174 131.276",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56781 153.787L28.6744 135.077",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2142 157.442L32.3208 138.731",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7095 15.6046L-13.0452 15.401L-13.3218 65.5402L23.4329 65.7438L23.7095 15.6046Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.195 20.1803H27.7993L27.5076 70.3195L-9.39288 70.1733V68.4192",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91547 19.6319L-8.91949 19.5608L-8.98881 32.1321L3.84616 32.2032L3.91547 19.6319Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25519 19.8879H18.6107",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10938 24.4194L18.6107 24.5656",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.51776 40.4991L18.1731 40.6453",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.51776 45.7616L18.1731 45.9078",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.66357 50.8778L18.1732 51.024",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.991 116.684L70.0966 143.919L106.837 181.718L134.732 154.483L97.991 116.684Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4139 123.676L77.3549 143.26L81.7313 147.763L101.79 128.178L97.4139 123.676Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.364 134.959L88.0957 154.747L107.026 174.223L127.294 154.434L108.364 134.959Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5376 145.163L117.061 164.166",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2458 154.811L112.102 168.99",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 140.047L122.166 159.196",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.141 159.635L112.977 140.193",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9541 164.459L117.79 145.163",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.767 169.429L122.457 150.133",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.375 81.8677L121.582 90.1999L123.478 106.864L139.522 113.588L152.794 103.356L150.461 86.5454L138.647 81.4292",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.48 78.2133C138.501 79.5289 138.209 81.5754 136.896 82.5987C135.584 83.6219 133.542 83.3296 132.521 82.014C131.5 80.6984 131.792 78.6519 133.104 77.6286C134.417 76.6054 136.313 76.7515 137.48 78.2133Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.061 86.3992C117.936 87.4225 117.644 89.0304 116.623 89.9075C115.602 90.7846 113.998 90.4922 113.123 89.469C112.248 88.4457 112.539 86.8378 113.56 85.9607C114.727 85.0836 116.331 85.2298 117.061 86.3992Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.752 124.26C144.918 125.868 144.627 128.06 143.022 129.23C141.418 130.399 139.23 130.107 138.063 128.499C136.896 126.891 137.188 124.698 138.793 123.529C140.397 122.359 142.585 122.652 143.752 124.26Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.026 115.343C171.901 116.512 171.755 118.12 170.588 119.143C169.421 120.02 167.817 119.874 166.796 118.705C165.921 117.535 166.067 115.927 167.234 114.904C168.4 113.881 170.151 114.173 171.026 115.343Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.463 62.1337C165.629 63.5955 165.338 65.7882 163.879 66.8114C162.421 67.9808 160.233 67.6885 159.212 66.2267C158.045 64.7649 158.337 62.5722 159.795 61.549C161.254 60.3796 163.296 60.6719 164.463 62.1337Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.882 97.6551C186.194 99.4092 185.903 101.894 184.153 103.21C182.402 104.525 179.923 104.233 178.61 102.479C177.297 100.725 177.589 98.2398 179.339 96.9242C181.09 95.6086 183.569 95.9009 184.882 97.6551Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.461 86.5455L163.587 76.6053L179.485 82.891L180.798 95.7547",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.794 103.356L168.255 109.934L178.318 102.187",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.275 67.5422L163.587 76.6053",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.644 88.738L121.582 90.1998",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.251 122.944L139.522 113.588",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.255 109.934L168.4 114.027",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3636 34.0674L39.6133 42.2534L47.1976 49.2699L57.2614 46.2002L59.595 35.9677L51.8649 29.0973L44.2806 31.29",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3845 30.2666C43.4055 30.559 44.1348 31.5822 43.843 32.6055C43.5513 33.6287 42.5304 34.3596 41.5094 34.0673C40.4885 33.7749 39.7592 32.7516 40.0509 31.7284C40.3426 30.7051 41.3636 30.1204 42.3845 30.2666Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9671 42.2533C36.8422 42.3995 37.2797 43.2765 37.1339 44.0074C36.988 44.8845 36.1129 45.323 35.3837 45.1769C34.5085 45.0307 34.071 44.1536 34.2168 43.4227C34.3627 42.5457 35.2378 41.9609 35.9671 42.2533Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5331 49.4161C64.6999 49.7085 65.4292 50.8779 65.1375 52.0473C64.8458 53.2168 63.679 53.9477 62.5121 53.6553C61.3453 53.363 60.6161 52.1935 60.9078 51.0241C61.1995 50.0008 62.3663 49.1238 63.5331 49.4161Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8675 34.5059C73.7426 34.652 74.326 35.5291 74.0343 36.4062C73.8885 37.2833 73.0134 37.868 72.1383 37.5756C71.2632 37.4294 70.6797 36.5524 70.9714 35.6753C70.9714 34.7982 71.8466 34.2135 72.8675 34.5059Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8021 11.9944C49.9689 12.2868 50.5523 13.31 50.4064 14.4794C50.1147 15.6489 49.0937 16.2336 47.9269 16.0874C46.7601 15.795 46.1767 14.7718 46.3226 13.6024C46.4684 12.4329 47.6352 11.702 48.8021 11.9944Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2842 20.619C73.5968 20.9113 74.4719 22.2269 74.1802 23.5425C73.8885 24.8581 72.5759 25.7352 71.2632 25.4428C69.9505 25.1505 69.0754 23.8349 69.3671 22.5193C69.8047 21.2037 70.9715 20.3266 72.2842 20.619Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8649 29.0973L54.0527 19.1571L63.9706 15.795L69.8047 21.3498",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.595 35.9678L69.3671 33.0442L71.1173 25.2968",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8229 15.3566L54.0526 19.1572",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2798 43.1304L39.6134 42.2533",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3453 50.1469L57.2614 46.2001",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3672 33.0442L71.1174 34.7983",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.95441 219.714L-14.206 215.036L-26.8951 225.123L-24.1239 241.787L-9.10115 247.488L3.44211 236.963L1.69189 224.684",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58797 221.907C3.00457 223.515 1.25434 224.246 -0.350027 223.661C-1.9544 223.076 -2.68365 221.322 -2.10024 219.714C-1.51684 218.106 0.233381 217.375 1.83775 217.96C3.44212 218.691 4.17138 220.445 3.58797 221.907Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5706 235.94C29.9872 237.694 28.0911 238.425 26.3409 237.84C24.5907 237.255 23.8614 235.355 24.4448 233.601C25.0282 231.847 26.9243 231.116 28.6745 231.701C30.4247 232.432 31.154 234.332 30.5706 235.94Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80887 273.189C10.8906 272.959 12.3927 271.082 12.1638 268.995C11.9349 266.909 10.0617 265.404 7.9799 265.633C5.89812 265.862 4.39608 267.74 4.62499 269.826C4.85391 271.913 6.72709 273.418 8.80887 273.189Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4422 236.963L18.3191 242.664L21.2361 258.89L11.464 266.637",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.10107 247.488L-6.47574 263.421L4.9007 267.807",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0282 236.963L18.319 242.664",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.608 22.6654C157.608 22.6654 142.585 22.9578 140.98 22.9578C139.376 22.9578 137.48 22.2269 135.292 20.6189C133.104 19.0109 126.249 14.6256 118.811 14.7718C111.518 14.9179 97.6625 23.6886 97.9542 40.7915C98.2459 58.0406 112.102 60.818 116.477 60.6718C120.853 60.6718 124.062 58.7715 126.687 60.5256C129.312 62.2798 132.229 65.2033 133.542 65.2033C134.855 65.2033 134.417 60.9642 135.73 60.818C137.042 60.6718 143.168 59.5024 144.918 59.21C146.669 58.9177 147.544 57.8944 147.544 54.9708C147.544 52.0473 148.127 46.3463 150.898 46.3463C153.67 46.3463 158.774 46.2001 158.774 46.2001",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2668 67.9808L103.642 61.8413",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1201 60.9642L97.3707 56.725",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1401 50.5856L92.2659 47.662",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.39 38.599L91.6825 38.3066",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4318 26.6122L92.9952 29.0972",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1201 15.9412L97.6624 20.0342",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.579 8.33997L104.08 13.6024",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.021 48.9775C126.541 49.1236 126.395 52.6319 124.353 52.3396C122.311 52.0472 120.27 54.0937 118.665 53.3628C117.061 52.6319 113.56 54.3861 112.394 52.1934C111.227 50.0007 108.164 51.901 107.726 48.6851C107.435 45.4692 104.809 46.2001 104.809 43.1303C104.809 40.0606 102.476 38.5988 104.372 36.6985C106.122 34.7981 103.497 31.1437 106.559 30.559C109.622 29.9742 107.289 26.9045 109.331 26.6121C111.373 26.3198 113.706 22.373 116.769 23.5424C119.832 24.7118 121.582 21.7883 122.895 23.9809C124.208 26.1736 127.27 22.9577 128.729 26.0274C130.187 29.0972 133.542 28.2201 133.105 31.436C132.813 34.7981 136.022 36.4061 134.563 38.745C133.105 41.0838 135.001 43.8612 132.959 45.0306C131.208 46.0539 133.25 48.6851 129.021 48.9775Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.187 48.2466C123.332 45.0307 122.02 44.1536 119.686 43.8613C117.207 43.5689 116.04 43.2765 115.311 40.6453C114.581 37.8679 114.435 35.2367 112.248 33.9211C110.206 32.6055 107.58 30.4128 107.58 30.4128",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.872 40.6454C109.914 40.0606 111.664 35.3829 113.56 35.3829",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.206 45.0307C112.685 45.1769 115.602 41.8148 115.602 41.8148",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.894 48.3928C117.936 47.9543 118.228 46.2001 119.686 44.5922",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.75 38.5989C124.937 39.6222 119.54 36.2601 121.582 30.4129C123.478 24.5658 117.644 23.3964 117.644 23.3964",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.352 42.6919C117.644 40.9378 119.686 36.6986 122.311 36.6986",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.395 38.745C125.666 40.6453 126.541 44.0074 128.291 46.0539",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.518 26.0276C112.102 28.6588 113.998 31.29 118.227 32.0209",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.104 32.3132C130.333 34.2135 127.27 35.0906 126.541 31.7285",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.194 53.3629C179.194 53.3629 184.007 42.6919 184.736 40.9377C185.174 40.0607 186.341 39.6221 187.945 40.4992C189.841 41.3763 189.403 43.5689 189.403 43.5689C189.403 43.5689 223.095 58.7715 225.575 59.9409C228.054 61.1104 229.659 64.3263 227.762 68.5655C225.866 72.6585 222.366 73.3894 220.178 72.3661C217.99 71.3429 183.715 55.8479 183.715 55.8479C183.715 55.8479 182.694 57.8944 180.361 56.725C178.756 55.9941 178.756 54.24 179.194 53.3629Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.632 51.3163L184.59 55.7016",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.237 54.3861L187.07 56.8711",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.175 53.8014L190.133 58.3329",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.925 57.0173L192.758 59.5024",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.863 56.2864L195.821 60.8179",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.467 59.5023L198.3 61.9874",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7 58.1868C231.7 58.1868 243.369 32.3132 244.535 29.682C245.702 27.0508 243.66 21.3498 238.264 21.3498C232.867 21.3498 204.28 22.2269 204.28 22.2269L190.278 15.9412C190.278 15.9412 190.57 13.7485 188.382 12.7253C186.924 11.9944 185.611 12.8714 185.319 13.6023C185.028 14.3332 180.069 25.1504 179.631 26.3199C179.194 27.1969 179.777 28.2202 181.09 28.8049C183.132 29.682 184.444 27.7816 184.444 27.7816C184.444 27.7816 196.258 33.1903 196.842 33.3364C197.425 33.6288 209.385 47.9543 209.385 47.9543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.279 16.0873L188.237 20.4726",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05 17.2568L192.029 19.7419",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.404 18.8647L194.508 23.3963",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.321 20.1803L198.3 22.5192",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.074 22.2268C223.679 23.5424 227.033 38.5988 222.22 51.4625",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.7265 107.303C-11.7265 107.303 -0.933437 92.5386 0.0875263 91.0769C1.10849 89.6151 0.670932 85.6683 -2.68366 84.9374C-6.03826 84.2065 -24.2697 80.9905 -24.2697 80.9905L-32.2916 75.1434C-32.2916 75.1434 -31.854 73.8278 -33.0209 72.9507C-33.896 72.366 -34.7711 72.6584 -35.0628 73.0969C-35.3545 73.5354 -39.8759 79.6749 -40.4593 80.4058C-40.751 80.8444 -40.6052 81.5753 -39.8759 82.16C-38.7091 83.037 -37.6881 82.0138 -37.6881 82.0138C-37.6881 82.0138 -30.9789 86.9839 -30.5414 87.2762C-30.2497 87.5686 -24.5614 98.2396 -24.5614 98.2396",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.113 207.581C210.552 215.182 210.406 227.315 202.822 234.77C195.237 242.225 183.132 242.079 175.693 234.478C168.255 226.877 168.401 214.744 175.985 207.289C183.569 199.834 195.675 199.98 203.113 207.581Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.067 220.883L162.567 220.591C162.421 227.461 165.046 234.332 170.151 239.594C180.506 250.119 197.425 250.411 207.927 240.033C213.177 234.916 215.948 228.046 215.948 221.176H212.594",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.985 207.289C178.756 213.428 194.071 221.03 203.114 207.581",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.922 230.239C178.756 223.661 195.529 220.299 206.468 230.093",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.156 244.272L208.072 240.033",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.343 261.229L229.075 239.887C229.075 239.887 225.575 236.671 221.782 240.325C220.032 238.571 217.99 239.01 216.094 240.91C214.052 242.81 209.968 246.903 208.656 248.073C207.343 249.388 206.322 252.019 208.072 253.92C206.468 255.674 204.426 258.305 207.343 261.229Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.286 325.138C139.115 320.351 138.348 313.36 133.571 309.522C128.795 305.684 121.819 306.453 117.99 311.24C114.16 316.027 114.928 323.019 119.704 326.857C124.481 330.695 131.457 329.926 135.286 325.138Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.123 318.238L111.081 318.092C111.081 322.039 112.539 325.986 115.456 329.055C121.436 335.195 131.208 335.341 137.334 329.348C140.397 326.424 142.001 322.477 142.001 318.531H140.105",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.811 310.345C120.415 313.853 129.312 318.238 134.563 310.491",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.061 323.501C120.415 319.7 130.187 317.8 136.459 323.354",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.814 331.687L137.48 329.348",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.042 341.481L149.586 329.202C149.586 329.202 147.544 327.301 145.356 329.494C144.335 328.471 143.168 328.763 142.001 329.933C140.835 331.102 138.501 333.295 137.772 334.172C137.042 335.049 136.459 336.511 137.48 337.534C136.605 338.265 135.438 339.873 137.042 341.481Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.576 75.7281H290.187V25.7351L239.576 75.7281ZM281.582 66.6651H262.475L281.582 47.8081V66.6651Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 36.8447H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 41.0839H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 44.8845H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 49.1238H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 53.0706H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 57.3097H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 61.2565H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.499 65.4957H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.249 69.2963H287.853",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.319 332.856L156.295 347.474L171.609 318.823L200.634 304.205L185.319 332.856Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.383 314.876L210.114 329.933C210.114 329.933 210.698 337.388 200.196 347.62C189.695 357.853 182.111 357.268 182.111 357.268L167.38 342.212",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.941 346.305L178.173 365.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.402 365.308C183.569 366.477 183.569 368.524 182.402 369.693C181.236 370.863 179.194 370.863 178.027 369.693C176.86 368.524 176.86 366.477 178.027 365.308C179.34 363.992 181.236 363.992 182.402 365.308Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.569 372.47C183.569 372.47 184.298 376.417 186.632 378.756C187.799 377.587 191.883 373.64 191.883 373.64C191.883 373.64 188.236 370.716 185.611 370.424",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7636 271.607L61.4911 301.135L55.2195 269.415L68.492 239.74L74.7636 271.607Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1174 251.289L91.9743 253.627C91.9743 253.627 97.2249 259.036 95.6206 273.654C94.0162 288.272 87.5987 292.511 87.5987 292.511L66.7419 290.172",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5331 298.066L89.6406 300.989",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8493 298.504C94.5995 298.65 95.7663 300.258 95.4746 301.866C95.3288 303.62 93.7244 304.79 92.12 304.498C90.3698 304.351 89.203 302.743 89.4947 301.135C89.6405 299.527 91.2449 298.212 92.8493 298.504Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3916 303.328C98.3916 303.328 101.454 305.959 104.663 306.252C104.809 304.644 105.538 298.943 105.538 298.943C105.538 298.943 100.871 298.943 98.6833 300.405",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94 246.724L118.613 272.429L153.522 308.344L179.849 282.639L144.94 246.724Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.878 248.365L151.044 247.196L185.903 283.155L159.65 309.029L158.483 307.713",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.59 263.6L124.396 272.577L133.149 281.581L142.342 272.605L133.59 263.6Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.897 260.79L144.335 253.481",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.105 264.152L147.544 256.843",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.376 287.249L158.483 268.538",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.022 291.049L162.129 272.338",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.669 294.704L165.775 275.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.615 181.692L150.457 162.588L124.529 195.521L148.687 214.626L174.615 181.692Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.943 186.093L174.964 186.824L149.002 219.86L124.791 200.711L125.666 199.541",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.381 174.152L151.023 167.542L144.519 175.804L152.877 182.414L159.381 174.152Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.129 176.591L168.984 182",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.795 179.515L166.65 184.924",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.543 181.561L158.045 195.448",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.772 184.924L155.42 198.811",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.146 188.432L152.649 202.319",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.428 253.909L203.534 281.144L240.275 318.943L268.169 291.708L231.428 253.909Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.849 261.107L210.79 280.692L215.166 285.194L235.225 265.61L230.849 261.107Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.801 272.184L221.533 291.973L240.463 311.448L260.731 291.66L241.801 272.184Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.846 282.425L250.369 301.428",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.555 292.072L245.41 306.252",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.097 277.308L255.62 296.458",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.596 296.896L246.286 277.454",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.263 301.72L251.099 282.425",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.076 306.69L255.912 287.395",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3502 321.327L53.4817 323.748L56.7486 376.419L95.617 373.997L92.3502 321.327Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2338 326.303L59.2834 328.045L59.6726 334.318L87.6229 332.577L87.2338 326.303Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3335 341.955L60.092 343.715L61.7753 370.852L90.0168 369.093L88.3335 341.955Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1804 343.235L75.7847 369.839",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7629 350.398L68.9297 370.278",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4729 342.796L83.0773 369.401",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.762 350.69L88.328 348.936",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1995 357.56L88.7655 355.806",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6371 364.431L89.2031 362.677",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.225 250.265L273.852 255.089L285.082 247.78L284.207 233.893L272.247 227.9L261.163 235.501L261.6 245.88",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.704 247.926C260.287 246.757 261.746 246.172 263.059 246.757C264.225 247.342 264.809 248.803 264.225 250.119C263.642 251.288 262.183 251.873 260.871 251.288C259.558 250.558 259.121 249.096 259.704 247.926Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.685 259.621C273.122 258.597 274.289 258.305 275.31 258.744C276.331 259.182 276.623 260.352 276.185 261.375C275.748 262.398 274.581 262.69 273.56 262.252C272.539 261.667 272.101 260.498 272.685 259.621Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.333 227.169C291.062 225.707 292.812 225.123 294.125 225.853C295.584 226.584 296.167 228.338 295.438 229.654C294.708 231.116 292.958 231.701 291.646 230.97C290.187 230.239 289.749 228.485 290.333 227.169Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.435 210.797C275.018 209.774 276.185 209.335 277.352 209.774C278.373 210.359 278.811 211.528 278.373 212.697C277.79 213.721 276.623 214.159 275.456 213.721C274.289 213.136 273.852 211.82 274.435 210.797Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.701 234.039C239.431 232.724 241.035 232.139 242.348 232.87C243.66 233.601 244.244 235.209 243.514 236.525C242.785 237.84 241.181 238.425 239.868 237.694C238.555 237.109 238.118 235.501 238.701 234.039Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.933 206.996C257.662 205.389 259.558 204.804 261.162 205.535C262.767 206.266 263.35 208.166 262.621 209.774C261.892 211.382 259.996 211.967 258.391 211.236C256.787 210.505 256.204 208.604 256.933 206.996Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.162 235.501L249.348 229.654L248.327 216.06L257.079 210.505",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.247 227.9L271.518 214.598L262.475 210.066",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.368 233.747L249.348 229.654",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.143 258.305L273.852 255.089",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.625 230.093L284.207 233.893",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.518 214.598L274.435 212.99",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.735 151.156L174.818 160.219L182.694 169.136L194.508 166.651L198.3 155.395L190.133 146.625L181.236 148.379",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.339 146.917C180.506 147.356 181.09 148.525 180.798 149.695C180.36 150.864 179.194 151.449 178.027 151.156C176.86 150.718 176.277 149.548 176.568 148.379C176.86 147.21 178.173 146.625 179.339 146.917Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.734 159.781C171.609 160.073 172.193 161.096 171.901 161.974C171.609 162.851 170.588 163.435 169.713 163.143C168.838 162.851 168.255 161.827 168.546 160.95C168.838 160.073 169.859 159.489 170.734 159.781Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.363 171.037C202.676 171.475 203.405 172.937 202.967 174.253C202.53 175.568 201.071 176.299 199.759 175.86C198.446 175.422 197.717 173.96 198.154 172.645C198.592 171.329 200.05 170.598 201.363 171.037Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.469 154.957C214.49 155.249 214.927 156.273 214.636 157.296C214.344 158.319 213.323 158.758 212.302 158.465C211.281 158.173 210.844 157.15 211.135 156.126C211.427 155.249 212.448 154.665 213.469 154.957Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.528 126.891C189.841 127.329 190.424 128.645 189.987 129.814C189.549 131.13 188.236 131.715 187.07 131.276C185.757 130.838 185.174 129.522 185.611 128.353C185.903 127.183 187.215 126.452 188.528 126.891Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.49 139.316C215.948 139.754 216.678 141.362 216.24 142.824C215.803 144.286 214.198 145.017 212.74 144.578C211.281 144.14 210.552 142.532 210.989 141.07C211.427 139.608 213.031 138.877 214.49 139.316Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.133 146.625L193.779 135.661L205.447 132.884L211.427 139.754",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3 155.395L209.677 153.057L212.448 144.432",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.403 130.838L193.779 135.661",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.047 160.95L174.818 160.219",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.738 171.621L194.508 166.651",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.677 153.057L211.427 155.249",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.853 351.275L109.768 354.198L105.684 367.939L116.04 378.464L129.896 374.809L133.542 360.922L125.958 353.029",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.104 350.105C126.541 351.567 125.666 353.029 124.207 353.321C122.749 353.76 121.29 352.883 120.999 351.421C120.561 349.959 121.436 348.497 122.895 348.205C124.207 347.766 125.666 348.643 126.104 350.105Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.58 349.667C107.872 350.836 107.143 351.859 106.122 352.152C104.955 352.444 103.934 351.713 103.642 350.69C103.351 349.667 104.08 348.497 105.101 348.205C106.122 347.912 107.289 348.643 107.58 349.667Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.894 388.258C116.332 389.866 115.311 391.474 113.706 391.912C112.102 392.351 110.497 391.328 110.06 389.72C109.622 388.112 110.643 386.504 112.248 386.065C113.852 385.627 115.456 386.65 115.894 388.258Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.105 390.158C140.397 391.328 139.668 392.643 138.501 392.935C137.334 393.228 136.021 392.497 135.73 391.328C135.438 390.158 136.167 388.842 137.334 388.55C138.647 388.258 139.814 388.989 140.105 390.158Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.503 346.451C152.94 348.059 151.919 349.52 150.461 349.959C148.856 350.398 147.398 349.374 146.96 347.912C146.523 346.305 147.544 344.843 149.002 344.404C150.607 343.966 152.211 344.843 152.503 346.451Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.732 380.949C157.17 382.703 156.149 384.603 154.399 385.042C152.649 385.48 150.753 384.457 150.315 382.703C149.877 380.949 150.898 379.048 152.649 378.61C154.545 378.025 156.295 379.195 156.732 380.949Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.542 360.922L147.106 357.414L157.462 367.647L154.253 378.171",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.896 374.809L139.814 385.042L150.169 382.264",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.148 349.959L147.106 357.414",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.143 351.859L109.768 354.198",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.706 386.065L116.04 378.464",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.814 385.042L138.501 388.258",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.416 157.588C287.416 157.588 273.268 157.734 271.664 157.88C270.06 157.88 268.309 157.15 266.267 155.688C264.225 154.226 257.662 149.987 250.661 150.133C243.66 150.279 230.68 158.465 230.971 174.691C231.263 190.917 244.39 193.548 248.473 193.548C252.557 193.548 255.62 191.648 258.246 193.402C260.725 195.156 263.496 197.787 264.663 197.787C265.83 197.787 265.538 193.84 266.851 193.694C268.163 193.548 273.852 192.379 275.602 192.232C277.206 192.086 278.081 191.063 278.081 188.286C278.081 185.508 278.665 180.1 281.29 180.1C283.915 180.1 288.729 179.953 288.729 179.953",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.284 200.418L236.514 194.571",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.575 193.84L230.534 189.747",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.741 183.9L225.72 181.123",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.282 172.645L224.991 172.352",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.178 161.243L226.304 163.581",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.429 151.156L230.68 155.103",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.451 144.14L236.805 149.11",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.433 182.585C258.1 182.731 257.954 186.093 256.058 185.801C254.162 185.508 252.12 187.409 250.661 186.678C249.203 185.947 245.848 187.701 244.827 185.508C243.806 183.462 240.743 185.216 240.451 182.146C240.16 179.076 237.826 179.807 237.68 176.884C237.68 173.96 235.493 172.644 237.243 170.744C238.993 168.844 236.368 165.482 239.285 164.897C242.202 164.312 240.014 161.389 241.91 161.243C243.806 161.096 245.994 157.296 248.911 158.319C251.828 159.342 253.432 156.711 254.745 158.758C256.058 160.804 258.975 157.734 260.287 160.658C261.6 163.581 264.809 162.704 264.517 165.774C264.225 168.844 267.288 170.452 265.83 172.645C264.371 174.837 266.121 177.468 264.225 178.492C262.475 179.661 264.517 182.146 260.433 182.585Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.891 181.708C255.037 178.638 253.87 177.761 251.536 177.468C249.203 177.176 248.182 176.884 247.452 174.399C246.723 171.767 246.577 169.282 244.535 167.967C242.639 166.651 240.16 164.751 240.16 164.751",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.451 174.545C242.347 173.96 243.952 169.575 245.702 169.575",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.639 178.784C244.973 178.93 247.744 175.714 247.744 175.714",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.89 182C249.786 181.561 250.078 179.953 251.536 178.345",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.162 172.645C256.641 173.522 251.536 170.452 253.432 164.897C255.328 159.342 249.64 158.173 249.64 158.173",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.348 176.591C249.494 174.983 251.536 170.89 254.016 170.89",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.954 172.791C257.225 174.691 258.1 177.761 259.704 179.661",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.952 160.658C244.39 163.143 246.286 165.628 250.224 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.225 166.651C261.6 168.405 258.683 169.282 257.954 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7382 372.909C38.7382 372.909 36.6963 359.022 36.4046 357.414C36.1129 355.952 36.6963 354.052 37.8631 351.859C39.0299 349.667 42.2386 342.65 41.2177 335.78C40.1967 328.909 30.4246 317.215 14.5268 319.554C-1.37108 321.893 -2.2462 335.195 -1.66279 339.142C-1.07938 343.235 1.1084 346.012 -0.204268 348.643C-1.51694 351.275 -3.85057 354.344 -3.70472 355.514C-3.55886 356.683 0.233285 355.806 0.670841 357.122C0.962544 358.291 2.85862 363.846 3.29617 365.454C3.73373 367.062 4.75469 367.647 7.52588 367.354C10.2971 367.062 15.5477 366.77 15.9853 369.401C16.4228 372.032 17.0063 376.71 17.0063 376.71",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.72552 316.776L-0.0582638 321.162",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17133 309.906L7.67177 315.315",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1102 306.836L16.1312 313.561",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4867 307.275L24.8823 313.707",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9881 311.222L33.9252 316.776",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0098 318.092L40.4884 322.039",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8806 349.667C10.4431 347.328 7.08848 347.766 7.23434 345.866C7.38019 343.966 5.1924 342.212 5.62996 340.75C6.06751 339.142 4.02559 336.072 5.92167 334.903C7.81774 333.587 5.62996 330.956 8.54699 330.225C11.464 329.494 10.4431 327.301 13.3601 326.863C16.2771 326.424 17.2981 324.232 19.34 325.547C21.382 327.009 24.299 324.085 25.32 326.863C26.3409 329.64 28.8204 327.009 29.258 328.909C29.6955 330.81 33.7794 332.418 33.0501 335.341C32.3209 338.265 35.2379 339.58 33.3418 341.042C31.4457 342.504 34.8003 344.989 32.175 346.743C29.5497 348.497 30.7165 351.421 27.6536 351.567C24.5907 351.713 23.4239 354.929 21.0903 353.76C18.7566 352.59 16.423 354.783 15.1103 353.029C13.9435 351.128 11.7557 353.467 10.8806 349.667Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8806 344.112C13.7976 343.966 14.5269 342.504 14.5269 340.311C14.5269 337.972 14.6727 336.949 17.0063 335.78C19.4858 334.756 21.9653 334.172 22.8404 332.125C23.8614 330.079 25.4657 327.448 25.4657 327.448",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1312 328.909C16.8604 330.663 21.5277 331.687 21.6735 333.441",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1932 331.687C12.3391 334.026 15.8395 336.218 15.8395 336.218",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85962 337.242C10.443 338.996 12.1933 339.142 13.9435 340.311",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5068 348.936C19.0483 344.55 21.5278 339.142 27.0702 340.311C32.6125 341.481 33.1959 335.78 33.1959 335.78",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.256 337.972C16.8604 337.972 21.0901 339.288 21.3818 341.919",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0692 345.866C18.1731 345.427 15.2561 346.597 13.5059 348.497",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1331 330.517C27.7994 331.394 25.6117 333.441 25.4658 337.388",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9243 351.275C24.8824 348.936 23.7156 346.158 26.6326 344.989",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.559 386.942C266.559 386.942 254.745 380.364 253.432 379.633C252.12 378.902 250.369 378.756 248.036 379.049C245.702 379.487 238.264 379.926 232.575 376.71C226.741 373.494 219.595 360.776 227.033 347.328C234.471 333.879 246.577 337.534 250.078 339.434C253.432 341.335 255.328 344.258 258.099 343.966C261.017 343.673 264.517 342.65 265.538 343.235C266.559 343.82 264.517 346.889 265.538 347.62C266.559 348.351 270.789 351.859 272.101 352.737C273.414 353.614 273.56 354.929 272.393 357.122C271.226 359.461 269.184 364.138 271.372 365.454C273.56 366.623 277.644 368.962 277.644 368.962",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.576 326.278L240.451 333.149",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.971 328.909L233.305 334.61",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.782 334.61L225.429 339.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.511 343.381L221.053 346.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.01 353.76L218.136 354.491",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.865 364.577L217.99 363.7",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.511 374.079L220.47 371.447",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.183 354.052C253.286 352.883 254.745 349.959 252.995 349.374C251.245 348.79 250.369 346.305 248.911 346.158C247.307 346.158 245.265 343.235 243.514 344.404C241.764 345.72 240.014 342.796 238.41 345.281C236.805 347.62 235.055 346.012 233.742 348.497C232.43 350.982 229.95 351.128 230.679 353.467C231.263 355.806 227.616 357.414 229.804 359.314C231.992 361.069 228.783 362.53 230.388 363.554C231.846 364.577 232.138 368.816 234.909 369.108C237.826 369.547 237.972 372.471 240.014 371.301C241.91 370.132 243.077 373.932 245.556 372.178C248.036 370.278 250.224 372.471 251.39 369.693C252.557 366.916 255.766 367.062 255.62 364.577C255.474 362.092 258.1 360.63 256.933 358.876C255.474 357.268 258.391 356.099 255.183 354.052Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.078 352.152C248.911 354.783 247.452 354.929 245.41 354.198C243.369 353.321 242.348 353.175 240.597 354.929C238.847 356.683 237.534 358.876 235.347 359.022C233.159 359.168 230.242 359.753 230.242 359.753",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.763 351.713C236.076 353.029 235.492 357.56 236.951 358.291",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.555 349.082C240.597 349.959 241.472 353.906 241.472 353.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.389 348.936C245.848 350.105 245.265 351.713 245.848 353.613",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.245 362.53C247.89 359.753 242.202 360.045 241.327 365.6C240.451 371.009 235.201 369.547 235.201 369.547",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.223 354.052C242.639 355.514 242.493 359.753 244.681 360.922",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.619 361.069C248.911 359.168 250.953 356.976 253.141 356.099",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.554 364.869C233.159 362.969 235.784 361.8 239.285 362.969",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.244 368.962C249.932 366.331 247.744 364.285 245.702 366.623",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.14 130.838C246.14 130.838 247.306 120.751 247.598 119.143C247.744 118.412 248.619 117.681 250.078 117.828C251.974 118.12 251.974 120.02 251.974 120.02C251.974 120.02 283.915 123.967 286.249 124.26C288.583 124.552 290.77 126.891 290.333 130.838C289.895 134.784 287.124 136.1 284.936 135.954C282.894 135.661 250.515 131.715 250.515 131.715C250.515 131.715 250.078 133.615 247.89 133.323C246.431 133.176 245.994 131.715 246.14 130.838Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.682 127.183L251.245 131.422",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87 129.376L253.578 131.715",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.079 127.914L256.495 132.153",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.266 130.107L258.975 132.446",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.329 128.499L261.892 132.738",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.517 130.691L264.225 133.03",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.916 121.336C290.916 121.336 293.979 96.9241 294.271 94.4391C294.562 91.954 291.354 87.7149 286.978 89.1767C282.457 90.6384 259.12 98.6783 259.12 98.6783L245.848 97.0703C245.848 97.0703 245.556 95.17 243.514 94.8776C242.202 94.7314 241.327 95.7547 241.181 96.4856C241.035 97.2165 239.868 107.449 239.722 108.618C239.576 109.349 240.306 110.226 241.618 110.373C243.514 110.665 244.098 108.765 244.098 108.765C244.098 108.765 255.328 110.08 255.912 110.226C256.495 110.226 270.059 119.143 270.059 119.143",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.702 97.0703L245.265 101.309",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.473 97.3627L248.182 99.7015",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.682 97.8011L251.099 102.04",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.307 98.0935L254.016 100.432",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.706 94.0005C275.456 94.5852 282.019 106.279 281.29 118.12",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3489 234.478C89.3489 234.478 93.7244 228.485 94.4537 227.461C94.7454 227.023 95.6205 226.877 96.4956 227.608C97.6624 228.485 96.9332 229.8 96.9332 229.8C96.9332 229.8 116.186 243.98 117.644 245.003C119.103 246.026 119.686 248.365 117.936 250.704C116.186 253.043 113.852 253.043 112.685 252.019C111.373 251.142 91.9742 236.817 91.9742 236.817C91.9742 236.817 91.0991 237.986 89.7864 236.963C88.7655 236.086 88.9113 235.063 89.3489 234.478Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3079 234.186L92.4119 236.817",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8914 236.378L93.8704 237.84",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5167 236.525L95.6206 239.156",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1 238.717L97.079 240.179",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.725 238.863L98.8293 241.495",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.309 241.202L100.288 242.518",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.728 244.564C121.728 244.564 132.521 229.8 133.542 228.339C134.563 226.877 134.125 222.93 130.771 222.199C127.416 221.468 109.185 218.252 109.185 218.252L101.163 212.405C101.163 212.405 101.6 211.089 100.434 210.212C99.5586 209.628 98.6835 209.92 98.3918 210.359C98.1 210.797 93.5786 216.937 92.9952 217.667C92.7035 218.106 92.8494 218.837 93.5786 219.422C94.7455 220.299 95.7664 219.275 95.7664 219.275C95.7664 219.275 102.476 224.246 102.913 224.538C103.205 224.83 108.893 235.501 108.893 235.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.309 212.551L99.4127 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.913 213.721L101.892 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.809 215.182L102.913 217.667",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.414 216.352L105.393 217.668",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.561 220.591C121.436 221.614 121.582 231.554 116.769 239.01",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22 95.3161L216.823 127.622L223.97 128.937L229.513 96.3393L226.741 88.738L222.22 95.3161Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.513 96.3393C229.513 96.3393 226.304 97.9473 222.074 95.1699",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.699 122.651L224.699 123.967",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9279 306.836L36.2589 279.793L30.2789 283.886L48.8021 311.222L56.2406 314.73L54.9279 306.836Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8021 311.222C48.8021 311.222 49.9689 307.86 54.9279 306.836",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1759 284.033L33.3419 287.833",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.479 345.281L287.999 294.996L276.769 295.434L279.102 346.012L285.811 356.537L290.479 345.281Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.102 346.012C279.102 346.012 283.332 342.504 290.479 345.281",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.291 302.89L277.498 303.036",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.787 46.6387L279.54 23.1039L274.435 17.9877L251.39 41.5224L249.348 49.416L256.787 46.6387Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39 41.5223C251.39 41.5223 254.891 41.9609 256.787 46.6386",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.039 26.7583L271.08 21.6421",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.8 97.5486C456.416 90.1124 456.576 77.8961 449.156 70.2628C441.737 62.6294 429.548 62.4696 421.931 69.9058C414.315 77.342 414.156 89.5583 421.575 97.1916C428.995 104.825 441.184 104.985 448.8 97.5486Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.032 83.6218L408.532 83.3295C408.386 90.1999 411.011 97.0703 416.116 102.333C426.472 112.858 443.391 113.15 453.892 102.771C459.143 97.655 461.914 90.7846 461.914 83.9142H458.559",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.95 70.0272C424.721 76.1667 440.036 83.768 449.079 70.3196",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.887 92.9773C424.721 86.3993 441.494 83.0371 452.433 92.8311",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.267 107.01L454.038 102.771",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.308 123.967L475.04 102.625C475.04 102.625 471.54 99.4092 467.748 103.064C465.998 101.309 463.956 101.748 462.06 103.648C460.018 105.549 455.934 109.642 454.621 110.811C453.308 112.127 452.288 114.758 454.038 116.658C452.579 118.412 450.537 121.044 453.308 123.967Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.686 189.539C384.409 185.635 385.08 178.634 381.186 173.9C377.291 169.166 370.305 168.493 365.582 172.397C360.859 176.3 360.187 183.302 364.082 188.036C367.977 192.769 374.963 193.442 379.686 189.539Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.234 180.977L357.192 180.831C357.192 184.777 358.651 188.724 361.568 191.794C367.548 197.933 377.32 198.08 383.445 192.086C386.508 189.163 388.113 185.216 388.113 181.269H386.217",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.922 173.083C366.527 176.591 375.424 180.977 380.674 173.229",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.172 186.239C366.527 182.439 376.299 180.538 382.57 186.093",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.925 194.425L383.445 191.94",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.008 204.219L395.551 191.94C395.551 191.94 393.509 190.04 391.321 192.233C390.3 191.209 389.134 191.502 387.967 192.671C386.8 193.84 384.466 196.033 383.737 196.91C383.008 197.641 382.424 199.249 383.445 200.272C382.57 201.003 381.403 202.611 383.008 204.219Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.809 320.577L296.226 353.467L303.518 353.76L304.248 320.723L300.456 313.561L296.809 320.577Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.248 320.723C304.248 320.723 301.331 322.77 296.809 320.723",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.372 348.351L303.373 348.643",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.748 364.285L337.502 335.195L308.915 305.813L307.748 364.285ZM327.147 334.756L315.916 345.72L316.353 323.647L327.147 334.756Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.853 314.438L313.874 313.561",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.312 317.946L316.208 316.046",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.52 319.262L318.541 318.385",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.979 322.77L320.875 320.87",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.188 324.085L323.063 323.208",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.646 327.594L325.542 325.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.855 328.763L327.73 327.886",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.313 332.418L330.209 330.371",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.522 333.587L332.397 332.71",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.285 195.595L402.406 210.212L417.575 181.561L446.599 166.944L431.285 195.595Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.349 177.615L456.08 192.671C456.08 192.671 456.663 200.126 446.162 210.359C435.66 220.591 428.076 220.006 428.076 220.006L413.345 204.95",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.907 209.043L424.284 227.9",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.368 228.046C429.535 229.216 429.535 231.262 428.368 232.432C427.201 233.601 425.159 233.601 423.992 232.432C422.825 231.262 422.825 229.216 423.992 228.046C425.305 226.731 427.201 226.731 428.368 228.046Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.535 235.209C429.535 235.209 430.264 239.156 432.598 241.495C433.764 240.325 437.848 236.378 437.848 236.378C437.848 236.378 434.202 233.455 431.577 233.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.729 134.346L307.456 163.874L301.331 132.007L314.457 102.479L320.729 134.346Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.083 114.027L337.94 116.366C337.94 116.366 343.19 121.774 341.586 136.392C339.981 151.01 333.564 155.249 333.564 155.249L312.707 152.91",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.498 160.804L335.606 163.728",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.96 161.243C340.711 161.389 341.877 162.997 341.586 164.605C341.44 166.359 339.835 167.528 338.231 167.236C336.481 167.09 335.314 165.482 335.606 163.874C335.752 162.266 337.21 160.95 338.96 161.243Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.357 166.067C344.357 166.067 347.42 168.698 350.629 168.99C350.774 167.382 351.504 161.681 351.504 161.681C351.504 161.681 346.836 161.681 344.649 163.143",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.922 109.499L364.595 135.204L399.504 171.119L425.831 145.414L390.922 109.499Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.989 111.103L397.009 109.934L432.014 145.894L405.615 171.767L404.448 170.452",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.572 126.375L370.378 135.351L379.131 144.356L388.324 135.38L379.572 126.375Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.862 123.529L390.3 116.22",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.071 126.744L393.509 119.582",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.341 149.987L404.594 131.276",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.988 153.787L408.094 135.077",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.634 157.442L411.741 138.731",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.129 15.6046L366.375 15.401L366.098 65.5402L402.853 65.7438L403.129 15.6046Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.615 20.1803H407.219L406.927 70.3195L370.027 70.1733V68.4192",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.335 19.6319L370.5 19.5608L370.431 32.1321L383.266 32.2032L383.335 19.6319Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.675 19.8879H398.03",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.529 24.4194L398.03 24.5656",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.902 40.4991L397.593 40.6453",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.902 45.7616L397.593 45.9078",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.756 50.8778L397.593 51.024",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.411 116.684L449.516 143.919L486.257 181.718L514.152 154.483L477.411 116.684Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.834 123.676L456.775 143.26L461.151 147.763L481.21 128.178L476.834 123.676Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.783 134.959L467.516 154.747L486.446 174.223L506.714 154.434L487.783 134.959Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.957 145.163L496.481 164.166",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.666 154.811L491.521 168.99",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.062 140.047L501.585 159.196",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.561 159.635L492.397 140.193",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.374 164.459L497.21 145.163",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.187 169.429L501.877 150.133",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.312 184.064L299.444 186.486L302.711 239.156L341.579 236.734L338.312 184.064Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.342 189.031L305.392 190.773L305.781 197.047L333.731 195.305L333.342 189.031Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.296 204.692L306.055 206.452L307.738 233.59L335.979 231.83L334.296 204.692Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.146 205.973L321.896 232.578",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.728 212.99L314.895 232.87",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.438 205.535L329.043 231.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.727 213.428L334.293 211.674",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.165 220.299L334.731 218.545",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.602 227.169L335.168 225.415",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.795 81.8677L501.002 90.1999L502.898 106.864L518.942 113.588L532.214 103.356L529.881 86.5454L518.067 81.4292",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.9 78.2133C517.921 79.5289 517.629 81.5754 516.316 82.5987C515.004 83.6219 512.962 83.3296 511.941 82.014C510.92 80.6984 511.211 78.6519 512.524 77.6286C513.837 76.6054 515.733 76.7515 516.9 78.2133Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48 86.3992C497.356 87.4225 497.064 89.0304 496.043 89.9075C495.022 90.7846 493.418 90.4922 492.542 89.469C491.667 88.4457 491.959 86.8378 492.98 85.9607C494.147 85.0836 495.751 85.2298 496.48 86.3992Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.171 124.26C524.338 125.868 524.046 128.06 522.442 129.23C520.838 130.399 518.65 130.107 517.483 128.499C516.316 126.891 516.608 124.698 518.212 123.529C519.817 122.359 522.004 122.652 523.171 124.26Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.446 115.343C551.321 116.512 551.175 118.12 550.008 119.143C548.841 120.02 547.237 119.874 546.216 118.705C545.341 117.535 545.487 115.927 546.653 114.904C547.82 113.881 549.57 114.173 550.446 115.343Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.882 62.1337C545.049 63.5955 544.757 65.7882 543.299 66.8114C541.84 67.9808 539.653 67.6885 538.632 66.2267C537.465 64.7649 537.757 62.5722 539.215 61.549C540.674 60.3796 542.716 60.6719 543.882 62.1337Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.302 97.6551C565.614 99.4092 565.323 101.894 563.572 103.21C561.822 104.525 559.343 104.233 558.03 102.479C556.717 100.725 557.009 98.2398 558.759 96.9242C560.509 95.6086 562.989 95.9009 564.302 97.6551Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.881 86.5455L543.007 76.6053L558.905 82.891L560.218 95.7547",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.214 103.356L547.674 109.934L557.738 102.187",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.695 67.5422L543.007 76.6053",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.064 88.738L501.002 90.1998",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.671 122.944L518.942 113.588",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.674 109.934L547.82 114.027",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.783 34.0674L419.033 42.2534L426.617 49.2699L436.681 46.2002L439.015 35.9677L431.285 29.0973L423.7 31.29",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.804 30.2666C422.825 30.559 423.554 31.5822 423.263 32.6055C422.971 33.6287 421.95 34.3596 420.929 34.0673C419.908 33.7749 419.179 32.7516 419.471 31.7284C419.762 30.7051 420.783 30.1204 421.804 30.2666Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.387 42.2533C416.262 42.3995 416.699 43.2765 416.554 44.0074C416.408 44.8845 415.533 45.323 414.803 45.1769C413.928 45.0307 413.491 44.1536 413.637 43.4227C413.782 42.5457 414.658 41.9609 415.387 42.2533Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.953 49.4161C444.12 49.7085 444.849 50.8779 444.557 52.0473C444.266 53.2168 443.099 53.9477 441.932 53.6553C440.765 53.363 440.036 52.1935 440.328 51.0241C440.619 50.0008 441.786 49.1238 442.953 49.4161Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.287 34.5059C453.162 34.652 453.746 35.5291 453.454 36.4062C453.308 37.2833 452.433 37.868 451.558 37.5756C450.683 37.4294 450.1 36.5524 450.391 35.6753C450.391 34.7982 451.266 34.2135 452.287 34.5059Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.222 11.9944C429.389 12.2868 429.972 13.31 429.826 14.4794C429.534 15.6489 428.513 16.2336 427.347 16.0874C426.18 15.795 425.596 14.7718 425.742 13.6024C425.888 12.4329 427.055 11.702 428.222 11.9944Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.704 20.619C453.017 20.9113 453.892 22.2269 453.6 23.5425C453.308 24.8581 451.996 25.7352 450.683 25.4428C449.37 25.1505 448.495 23.8349 448.787 22.5193C449.224 21.2037 450.391 20.3266 451.704 20.619Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.285 29.0973L433.472 19.1571L443.39 15.795L449.224 21.3498",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.015 35.9678L448.787 33.0442L450.537 25.2968",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.243 15.3566L433.472 19.1572",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7 43.1304L419.033 42.2533",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.765 50.1469L436.681 46.2001",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.787 33.0442L450.537 34.7983",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.465 219.714L365.214 215.036L352.525 225.123L355.296 241.787L370.319 247.488L382.862 236.963L381.112 224.684",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.008 221.907C382.424 223.515 380.674 224.246 379.07 223.661C377.466 223.076 376.736 221.322 377.32 219.714C377.903 218.106 379.653 217.375 381.258 217.96C382.862 218.691 383.591 220.445 383.008 221.907Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.089 209.482C365.652 210.651 364.193 211.382 363.026 210.797C361.859 210.359 361.13 208.897 361.714 207.727C362.151 206.558 363.61 205.827 364.776 206.412C365.943 206.85 366.527 208.312 366.089 209.482Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.733 250.704C348.003 252.458 346.107 253.335 344.357 252.75C342.607 252.019 341.732 250.119 342.315 248.365C343.044 246.611 344.941 245.734 346.691 246.318C348.441 246.903 349.316 248.95 348.733 250.704Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.881 268.391C369.444 269.707 367.839 270.438 366.527 269.853C365.214 269.415 364.485 267.807 365.068 266.491C365.506 265.176 367.11 264.445 368.423 265.029C369.735 265.614 370.465 267.076 369.881 268.391Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.99 235.94C409.407 237.694 407.511 238.425 405.761 237.84C404.011 237.255 403.281 235.355 403.865 233.601C404.448 231.847 406.344 231.116 408.094 231.701C409.845 232.432 410.574 234.332 409.99 235.94Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.229 273.189C390.311 272.959 391.813 271.082 391.584 268.995C391.355 266.909 389.482 265.404 387.4 265.633C385.318 265.862 383.816 267.74 384.045 269.826C384.274 271.913 386.147 273.418 388.229 273.189Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.862 236.963L397.739 242.664L400.656 258.89L390.884 266.637",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.319 247.488L372.944 263.421L384.321 267.807",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.448 236.963L397.739 242.664",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.339 211.236L365.214 215.036",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.003 247.196L355.296 241.787",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.944 263.421L369.59 265.614",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.027 22.6654C537.027 22.6654 522.005 22.9578 520.4 22.9578C518.796 22.9578 516.9 22.2269 514.712 20.6189C512.524 19.0109 505.669 14.6256 498.231 14.7718C490.938 14.9179 477.082 23.6886 477.374 40.7915C477.666 58.0406 491.522 60.818 495.897 60.6718C500.273 60.6718 503.481 58.7715 506.107 60.5256C508.732 62.2798 511.649 65.2033 512.962 65.2033C514.274 65.2033 513.837 60.9642 515.15 60.818C516.462 60.6718 522.588 59.5024 524.338 59.21C526.089 58.9177 526.964 57.8944 526.964 54.9708C526.964 52.0473 527.547 46.3463 530.318 46.3463C533.089 46.3463 538.194 46.2001 538.194 46.2001",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.687 67.9808L483.062 61.8413",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.54 60.9642L476.791 56.725",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.56 50.5856L471.686 47.662",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.81 38.599L471.102 38.3066",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.852 26.6122L472.415 29.0972",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.54 15.9412L477.082 20.0342",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.999 8.33997L483.5 13.6024",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.44 48.9775C505.961 49.1236 505.815 52.6319 503.773 52.3396C501.731 52.0472 499.689 54.0937 498.085 53.3628C496.481 52.6319 492.98 54.3861 491.813 52.1934C490.646 50.0007 487.584 51.901 487.146 48.6851C486.854 45.4692 484.229 46.2001 484.229 43.1303C484.229 40.0606 481.895 38.5988 483.791 36.6985C485.542 34.7981 482.916 31.1437 485.979 30.559C489.042 29.9742 486.709 26.9045 488.75 26.6121C490.792 26.3198 493.126 22.373 496.189 23.5424C499.252 24.7118 501.002 21.7883 502.315 23.9809C503.627 26.1736 506.69 22.9577 508.149 26.0274C509.607 29.0972 512.962 28.2201 512.524 31.436C512.233 34.7981 515.441 36.4061 513.983 38.745C512.524 41.0838 514.42 43.8612 512.378 45.0306C510.628 46.0539 512.67 48.6851 508.44 48.9775Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.606 48.2466C502.752 45.0307 501.44 44.1536 499.106 43.8613C496.626 43.5689 495.46 43.2765 494.73 40.6453C494.001 37.8679 493.855 35.2367 491.667 33.9211C489.626 32.6055 487 30.4128 487 30.4128",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.292 40.6454C489.334 40.0606 491.084 35.3829 492.98 35.3829",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.626 45.0307C492.105 45.1769 495.022 41.8148 495.022 41.8148",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.314 48.3928C497.356 47.9543 497.647 46.2001 499.106 44.5922",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.17 38.5989C504.357 39.6222 498.96 36.2601 501.002 30.4129C502.898 24.5658 497.064 23.3964 497.064 23.3964",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.772 42.6919C497.064 40.9378 499.106 36.6986 501.731 36.6986",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.815 38.745C505.086 40.6453 505.961 44.0074 507.711 46.0539",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.938 26.0276C491.522 28.6588 493.418 31.29 497.647 32.0209",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.524 32.3132C509.753 34.2135 506.69 35.0906 505.961 31.7285",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.213 47.6619C358.213 47.6619 348.149 38.1603 347.128 37.1371C345.961 36.1138 345.232 34.3597 344.94 32.0208C344.649 29.682 342.753 22.2269 337.94 17.6953C332.981 13.0176 318.395 10.0941 307.748 21.496C296.955 32.8979 304.248 43.7151 307.165 46.3463C310.082 49.1237 313.436 50.0008 314.02 52.7782C314.603 55.7017 314.749 59.3562 315.624 60.2333C316.499 60.9642 318.833 58.0406 319.854 58.7715C320.875 59.5024 325.542 62.5721 326.855 63.5954C328.167 64.6186 329.334 64.4724 331.23 62.5721C333.126 60.6718 337.064 57.3097 338.961 59.0639C340.857 60.818 344.211 64.0339 344.211 64.0339",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.121 40.0607L297.976 38.8912",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.975 30.9976L297.101 31.4361",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.601 20.1804L299.581 22.2269",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.164 11.4097L304.977 15.795",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.207 4.68542L311.832 10.5326",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.562 1.32336L320.729 7.60904",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.918 1.76184L328.897 7.60898",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.771 46.6387C321.021 45.1769 318.687 47.5158 317.666 45.9078C316.499 44.2998 313.874 44.446 313.291 42.8381C312.707 41.3763 309.207 40.2068 309.936 38.1603C310.665 35.9677 307.311 35.2368 309.207 32.8979C310.957 30.5591 308.915 29.3896 310.811 27.3431C312.707 25.2966 312.124 22.9578 314.603 22.8116C317.083 22.6654 317.52 18.5724 320 20.1804C322.479 21.7884 322.771 18.2801 324.375 19.3033C325.834 20.4728 329.918 19.3033 331.23 21.9345C332.543 24.5657 335.46 23.8349 334.877 26.1737C334.293 28.5126 338.523 28.3664 337.356 31.29C336.335 34.2135 339.106 35.8215 336.773 37.7218C334.439 39.6221 335.606 42.8381 333.126 43.4228C330.647 44.0075 330.064 47.0772 328.022 46.4925C326.126 46.054 325.834 49.1237 322.771 46.6387Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.562 42.3995C321.75 40.4992 321.458 39.0374 320 37.2832C318.541 35.5291 317.958 34.652 319.271 32.3132C320.437 29.9743 322.188 28.074 321.604 25.8813C321.167 23.6886 320.729 20.6189 320.729 20.6189",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.312 27.6355C316.062 28.5125 320.146 26.6122 321.312 27.7816",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.999 32.0209C314.457 33.775 318.541 33.3365 318.541 33.3365",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.457 37.8679C316.062 38.8912 317.374 37.8679 319.416 37.8679",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.918 40.3529C326.126 37.8679 324.813 32.3131 329.772 29.6819C334.731 27.1969 331.668 22.5192 331.668 22.5192",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.125 35.0905C320.437 34.0673 324.521 32.6055 326.271 34.3596",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.584 38.3064C325.834 39.1835 324.375 41.8147 324.23 44.2997",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.98 20.3265C324.667 22.373 324.229 25.2966 326.563 28.5125",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.043 38.3064C332.981 37.7217 330.501 36.4061 331.96 33.7749",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.774 312.976C350.774 312.976 339.981 306.983 338.815 306.252C337.648 305.521 336.043 305.375 333.856 305.813C331.668 306.106 324.959 306.69 319.562 303.62C314.311 300.697 307.602 289.003 314.457 276.577C321.312 264.152 332.543 267.514 335.606 269.269C338.815 271.023 340.419 273.654 343.044 273.362C345.67 273.069 348.878 272.192 349.899 272.631C350.774 273.069 348.878 275.993 349.899 276.724C350.774 277.455 354.712 280.67 356.025 281.401C357.192 282.278 357.338 283.302 356.317 285.494C355.296 287.687 353.4 291.926 355.442 293.096C357.484 294.265 361.13 296.312 361.13 296.312",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.834 257.282L326.709 263.421",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.958 259.621L320.146 264.737",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.498 264.883L312.999 269.415",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.664 272.923L308.769 275.847",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.601 282.425L306.29 283.155",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.456 292.365L306.144 291.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.81 301.135L308.332 298.65",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.273 282.717C338.523 281.547 339.835 279.062 338.231 278.478C336.627 277.893 335.898 275.554 334.439 275.554C332.98 275.554 331.084 272.777 329.48 273.946C327.876 275.116 326.271 272.484 324.813 274.677C323.354 276.87 321.75 275.408 320.583 277.601C319.416 279.793 317.228 279.94 317.666 282.132C318.249 284.325 314.895 285.787 316.937 287.541C318.979 289.149 316.062 290.464 317.374 291.488C318.833 292.511 318.979 296.312 321.604 296.604C324.229 296.896 324.375 299.674 326.271 298.65C328.021 297.481 329.042 301.135 331.376 299.381C333.564 297.627 335.752 299.674 336.773 297.189C337.794 294.704 340.856 294.85 340.711 292.511C340.565 290.172 342.898 288.856 341.877 287.395C340.565 285.64 343.19 284.617 340.273 282.717Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.606 280.963C334.585 283.302 333.126 283.594 331.376 282.863C329.48 282.132 328.605 281.84 326.855 283.594C325.25 285.202 324.084 287.248 322.042 287.395C320 287.541 317.374 288.126 317.374 288.126",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.458 280.524C322.771 281.694 322.187 285.933 323.5 286.518",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.959 278.185C326.855 279.062 327.584 282.571 327.584 282.571",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.355 278.039C331.668 279.062 331.23 280.524 331.668 282.278",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.773 290.464C333.71 287.833 328.459 288.272 327.584 293.242C326.709 298.212 322.042 296.896 322.042 296.896",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.188 282.717C328.605 284.033 328.459 287.979 330.501 289.003",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.293 289.149C334.585 287.395 336.481 285.348 338.523 284.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.541 292.657C320 290.903 322.333 289.88 325.688 290.903",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.627 296.458C335.314 293.973 333.418 292.218 331.668 294.265",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.614 53.3629C558.614 53.3629 563.427 42.6919 564.156 40.9377C564.593 40.0607 565.76 39.6221 567.365 40.4992C569.261 41.3763 568.823 43.5689 568.823 43.5689C568.823 43.5689 602.515 58.7715 604.994 59.9409C607.474 61.1104 609.078 64.3263 607.182 68.5655C605.286 72.6585 601.786 73.3894 599.598 72.3661C597.41 71.3429 563.135 55.8479 563.135 55.8479C563.135 55.8479 562.114 57.8944 559.78 56.725C558.176 55.9941 558.176 54.24 558.614 53.3629Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.052 51.3163L564.01 55.7016",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.656 54.3861L566.49 56.8711",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.594 53.8014L569.552 58.3329",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.345 57.0173L572.178 59.5024",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.283 56.2864L575.241 60.8179",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.887 59.5023L577.72 61.9874",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.12 58.1868C611.12 58.1868 622.788 32.3132 623.955 29.682C625.122 27.0508 623.08 21.3498 617.683 21.3498C612.287 21.3498 583.7 22.2269 583.7 22.2269L569.698 15.9412C569.698 15.9412 569.99 13.7485 567.802 12.7253C566.344 11.9944 565.031 12.8714 564.739 13.6023C564.448 14.3332 559.489 25.1504 559.051 26.3199C558.613 27.1969 559.197 28.2202 560.51 28.8049C562.551 29.682 563.864 27.7816 563.864 27.7816C563.864 27.7816 575.678 33.1903 576.262 33.3364C576.845 33.6288 588.805 47.9543 588.805 47.9543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.698 16.0873L567.656 20.4726",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.469 17.2568L571.449 19.7419",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.824 18.8647L573.928 23.3963",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.741 20.1803L577.72 22.5192",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.494 22.2268C603.098 23.5424 606.453 38.5988 601.64 51.4625",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.314 97.2165C335.314 97.2165 339.69 91.2232 340.419 90.1999C340.711 89.7614 341.586 89.6152 342.461 90.3461C343.628 91.2232 342.899 92.5388 342.899 92.5388C342.899 92.5388 362.151 106.718 363.61 107.741C365.068 108.765 365.651 111.103 363.901 113.442C362.151 115.781 359.817 115.781 358.651 114.758C357.338 113.881 337.94 99.5553 337.94 99.5553C337.94 99.5553 337.064 100.725 335.752 99.7015C334.731 98.8245 335.023 97.8012 335.314 97.2165Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.273 96.9241L338.377 99.5553",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.857 99.1167L339.836 100.578",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.482 99.2629L341.586 101.894",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.065 101.456L343.044 102.917",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.691 101.602L344.795 104.233",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.274 103.794L346.253 105.256",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.693 107.303C367.693 107.303 378.486 92.5386 379.507 91.0769C380.528 89.6151 380.091 85.6683 376.736 84.9374C373.382 84.2065 355.15 80.9905 355.15 80.9905L347.128 75.1434C347.128 75.1434 347.566 73.8278 346.399 72.9507C345.524 72.366 344.649 72.6584 344.357 73.0969C344.065 73.5354 339.544 79.6749 338.961 80.4058C338.669 80.8444 338.815 81.5753 339.544 82.16C340.711 83.037 341.732 82.0138 341.732 82.0138C341.732 82.0138 348.441 86.9839 348.878 87.2762C349.17 87.5686 354.858 98.2396 354.858 98.2396",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.274 75.2897L345.378 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.879 76.4591L347.858 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.775 77.9208L349.024 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.525 79.0902L351.504 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.527 83.3295C367.402 84.3527 367.548 94.2929 362.734 101.748",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.831 69.8811L321.458 98.0936L327.73 94.5853L311.249 65.9343L304.102 61.8413L304.831 69.8811Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.249 65.9343C311.249 65.9343 309.936 69.2964 304.831 69.735",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.833 93.7082L325.105 90.3461",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.533 207.581C589.972 215.182 589.826 227.315 582.242 234.77C574.657 242.225 562.552 242.079 555.113 234.478C547.675 226.877 547.82 214.744 555.405 207.289C562.989 199.834 575.095 199.98 582.533 207.581Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.487 220.883L541.986 220.591C541.841 227.461 544.466 234.332 549.571 239.594C559.926 250.119 576.845 250.411 587.346 240.033C592.597 234.916 595.368 228.046 595.368 221.176H592.014",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.405 207.289C558.176 213.428 573.49 221.03 582.533 207.581",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.342 230.239C558.176 223.661 574.949 220.299 585.888 230.093",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.576 244.272L587.492 240.033",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.763 261.229L608.495 239.887C608.495 239.887 604.994 236.671 601.202 240.325C599.452 238.571 597.41 239.01 595.514 240.91C593.472 242.81 589.388 246.903 588.076 248.073C586.763 249.388 585.742 252.019 587.492 253.92C585.888 255.674 583.846 258.305 586.763 261.229Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.706 325.138C518.535 320.351 517.768 313.36 512.991 309.522C508.215 305.684 501.239 306.453 497.409 311.24C493.58 316.027 494.348 323.019 499.124 326.857C503.901 330.695 510.877 329.926 514.706 325.138Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.543 318.238L490.501 318.092C490.501 322.039 491.959 325.986 494.876 329.055C500.856 335.195 510.628 335.341 516.754 329.348C519.817 326.424 521.421 322.477 521.421 318.531H519.525",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.231 310.345C499.835 313.853 508.732 318.238 513.983 310.491",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.481 323.501C499.835 319.7 509.607 317.8 515.879 323.354",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.233 331.687L516.9 329.348",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.462 341.481L529.006 329.202C529.006 329.202 526.964 327.301 524.776 329.494C523.755 328.471 522.588 328.763 521.421 329.933C520.254 331.102 517.921 333.295 517.192 334.172C516.462 335.049 515.879 336.511 516.9 337.534C516.025 338.265 514.858 339.873 516.462 341.481Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.996 75.7281H669.607V25.7351L618.996 75.7281ZM661.001 66.6651H641.895L661.001 47.8081V66.6651Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 36.8447H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 41.0839H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 44.8845H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 49.1238H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 53.0706H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 57.3097H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 61.2565H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.918 65.4957H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.669 69.2963H667.273",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.686 383.434H362.297V333.441L311.686 383.434ZM353.692 374.225H334.585L353.692 355.368V374.225Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 344.404H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 348.643H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 352.444H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 356.829H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 360.63H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 364.869H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 368.816H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 373.055H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.505 376.856H359.963",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.739 332.856L535.715 347.474L551.029 318.823L580.054 304.205L564.739 332.856Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.803 314.876L589.534 329.933C589.534 329.933 590.117 337.388 579.616 347.62C569.115 357.853 561.53 357.268 561.53 357.268L546.799 342.212",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.361 346.305L557.593 365.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.822 365.308C562.989 366.477 562.989 368.524 561.822 369.693C560.655 370.863 558.614 370.863 557.447 369.693C556.28 368.524 556.28 366.477 557.447 365.308C558.759 363.992 560.655 363.992 561.822 365.308Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.989 372.47C562.989 372.47 563.718 376.417 566.052 378.756C567.219 377.587 571.303 373.64 571.303 373.64C571.303 373.64 567.656 370.716 565.031 370.424",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.183 271.607L440.911 301.135L434.639 269.415L447.912 239.74L454.183 271.607Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.537 251.289L471.394 253.627C471.394 253.627 476.645 259.036 475.04 273.654C473.436 288.272 467.019 292.511 467.019 292.511L446.162 290.172",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.953 298.066L469.06 300.989",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.269 298.504C474.019 298.65 475.186 300.258 474.894 301.866C474.749 303.62 473.144 304.79 471.54 304.498C469.79 304.351 468.623 302.743 468.914 301.135C469.06 299.527 470.665 298.212 472.269 298.504Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.811 303.328C477.811 303.328 480.874 305.959 484.083 306.252C484.229 304.644 484.958 298.943 484.958 298.943C484.958 298.943 480.291 298.943 478.103 300.405",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.36 246.724L498.032 272.429L532.941 308.344L559.269 282.639L524.36 246.724Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.297 248.365L530.464 247.196L565.323 283.155L539.069 309.029L537.902 307.713",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.009 263.6L503.816 272.577L512.568 281.581L521.762 272.605L513.009 263.6Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.316 260.79L523.755 253.481",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.525 264.152L526.964 256.843",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.796 287.249L537.902 268.538",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.442 291.049L541.549 272.338",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.088 294.704L545.195 275.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.035 181.692L529.876 162.588L503.949 195.521L528.107 214.626L554.035 181.692Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.363 186.093L554.384 186.824L528.422 219.86L504.211 200.711L505.086 199.541",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.801 174.152L530.443 167.542L523.939 175.804L532.297 182.414L538.801 174.152Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.549 176.591L548.404 182",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.215 179.515L546.07 184.924",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.963 181.561L537.465 195.448",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.192 184.924L534.84 198.811",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.566 188.432L532.068 202.319",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.848 253.909L582.954 281.144L619.695 318.943L647.589 291.708L610.848 253.909Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.269 261.107L590.21 280.692L594.586 285.194L614.645 265.61L610.269 261.107Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.221 272.184L600.953 291.973L619.883 311.448L640.151 291.66L621.221 272.184Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.266 282.425L629.789 301.428",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.974 292.072L624.83 306.252",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.517 277.308L635.04 296.458",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.015 296.896L625.705 277.454",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.683 301.72L630.518 282.425",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.496 306.69L635.332 287.395",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.77 321.327L432.901 323.748L436.168 376.419L475.037 373.997L471.77 321.327Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.654 326.303L438.703 328.045L439.092 334.318L467.043 332.577L466.654 326.303Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.753 341.955L439.512 343.715L441.195 370.852L469.437 369.093L467.753 341.955Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.6 343.235L455.205 369.839",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.183 350.398L448.349 370.278",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.893 342.796L462.497 369.401",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.182 350.69L467.748 348.936",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.619 357.56L468.185 355.806",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.057 364.431L468.623 362.677",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.645 250.265L653.271 255.089L664.502 247.78L663.627 233.893L651.667 227.9L640.582 235.501L641.02 245.88",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.124 247.926C639.707 246.757 641.166 246.172 642.478 246.757C643.645 247.342 644.229 248.803 643.645 250.119C643.062 251.288 641.603 251.873 640.291 251.288C638.978 250.558 638.54 249.096 639.124 247.926Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.105 259.621C652.542 258.597 653.709 258.305 654.73 258.744C655.751 259.182 656.043 260.352 655.605 261.375C655.167 262.398 654.001 262.69 652.98 262.252C651.959 261.667 651.521 260.498 652.105 259.621Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.753 227.169C670.482 225.707 672.232 225.123 673.545 225.853C675.003 226.584 675.587 228.338 674.857 229.654C674.128 231.116 672.378 231.701 671.065 230.97C669.607 230.239 669.169 228.485 669.753 227.169Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.855 210.797C654.438 209.774 655.605 209.335 656.772 209.774C657.793 210.359 658.23 211.528 657.793 212.697C657.209 213.721 656.042 214.159 654.876 213.721C653.709 213.136 653.271 211.82 653.855 210.797Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.121 234.039C618.85 232.724 620.455 232.139 621.767 232.87C623.08 233.601 623.663 235.209 622.934 236.525C622.205 237.84 620.601 238.425 619.288 237.694C617.975 237.109 617.538 235.501 618.121 234.039Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.353 206.996C637.082 205.389 638.978 204.804 640.582 205.535C642.187 206.266 642.77 208.166 642.041 209.774C641.311 211.382 639.415 211.967 637.811 211.236C636.207 210.505 635.623 208.604 636.353 206.996Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.582 235.501L628.768 229.654L627.747 216.06L636.498 210.505",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.667 227.9L650.938 214.598L641.895 210.066",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.788 233.747L628.768 229.654",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.563 258.305L653.271 255.089",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.044 230.093L663.627 233.893",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.938 214.598L653.855 212.99",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.155 151.156L554.238 160.219L562.114 169.136L573.928 166.651L577.72 155.395L569.552 146.625L560.655 148.379",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.759 146.917C559.926 147.356 560.51 148.525 560.218 149.695C559.78 150.864 558.613 151.449 557.447 151.156C556.28 150.718 555.696 149.548 555.988 148.379C556.28 147.21 557.592 146.625 558.759 146.917Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.154 159.781C551.029 160.073 551.613 161.096 551.321 161.974C551.029 162.851 550.008 163.435 549.133 163.143C548.258 162.851 547.675 161.827 547.966 160.95C548.258 160.073 549.279 159.489 550.154 159.781Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.783 171.037C582.096 171.475 582.825 172.937 582.387 174.253C581.95 175.568 580.491 176.299 579.179 175.86C577.866 175.422 577.137 173.96 577.574 172.645C578.012 171.329 579.47 170.598 580.783 171.037Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.889 154.957C593.91 155.249 594.347 156.273 594.055 157.296C593.764 158.319 592.743 158.758 591.722 158.465C590.701 158.173 590.263 157.15 590.555 156.126C590.847 155.249 591.868 154.665 592.889 154.957Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.948 126.891C569.261 127.329 569.844 128.645 569.406 129.814C568.969 131.13 567.656 131.715 566.489 131.276C565.177 130.838 564.593 129.522 565.031 128.353C565.323 127.183 566.635 126.452 567.948 126.891Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.91 139.316C595.368 139.754 596.097 141.362 595.66 142.824C595.222 144.286 593.618 145.017 592.159 144.578C590.701 144.14 589.972 142.532 590.409 141.07C590.847 139.608 592.451 138.877 593.91 139.316Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.552 146.625L573.199 135.661L584.867 132.884L590.847 139.754",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.72 155.395L589.097 153.057L591.868 144.432",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.823 130.838L573.199 135.661",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.467 160.95L554.238 160.219",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.158 171.621L573.928 166.651",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.097 153.057L590.847 155.249",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.273 351.275L489.188 354.198L485.104 367.939L495.46 378.464L509.315 374.809L512.962 360.922L505.377 353.029",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.523 350.105C505.961 351.567 505.086 353.029 503.627 353.321C502.169 353.76 500.71 352.883 500.419 351.421C499.981 349.959 500.856 348.497 502.315 348.205C503.627 347.766 505.086 348.643 505.523 350.105Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 349.667C487.292 350.836 486.563 351.859 485.542 352.152C484.375 352.444 483.354 351.713 483.062 350.69C482.77 349.667 483.5 348.497 484.521 348.205C485.542 347.912 486.708 348.643 487 349.667Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.314 388.258C495.751 389.866 494.73 391.474 493.126 391.912C491.522 392.351 489.917 391.328 489.48 389.72C489.042 388.112 490.063 386.504 491.667 386.065C493.272 385.627 494.876 386.65 495.314 388.258Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.525 390.158C519.817 391.328 519.088 392.643 517.921 392.935C516.754 393.228 515.441 392.497 515.15 391.328C514.858 390.158 515.587 388.842 516.754 388.55C518.067 388.258 519.233 388.989 519.525 390.158Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.923 346.451C532.36 348.059 531.339 349.52 529.881 349.959C528.276 350.398 526.818 349.374 526.38 347.912C525.943 346.305 526.964 344.843 528.422 344.404C530.026 343.966 531.631 344.843 531.923 346.451Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.152 380.949C536.59 382.703 535.569 384.603 533.819 385.042C532.068 385.48 530.172 384.457 529.735 382.703C529.297 380.949 530.318 379.048 532.068 378.61C533.965 378.025 535.715 379.195 536.152 380.949Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.962 360.922L526.526 357.414L536.881 367.647L533.673 378.171",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.315 374.809L519.233 385.042L529.589 382.264",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.568 349.959L526.526 357.414",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.563 351.859L489.188 354.198",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.126 386.065L495.46 378.464",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.233 385.042L517.921 388.258",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.836 157.588C666.836 157.588 652.688 157.734 651.084 157.88C649.479 157.88 647.729 157.15 645.687 155.688C643.645 154.226 637.082 149.987 630.081 150.133C623.08 150.279 610.099 158.465 610.391 174.691C610.683 190.917 623.809 193.548 627.893 193.548C631.977 193.548 635.04 191.648 637.665 193.402C640.145 195.156 642.916 197.787 644.083 197.787C645.25 197.787 644.958 193.84 646.271 193.694C647.583 193.548 653.271 192.379 655.022 192.232C656.626 192.086 657.501 191.063 657.501 188.286C657.501 185.508 658.085 180.1 660.71 180.1C663.335 180.1 668.148 179.953 668.148 179.953",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.704 200.418L615.933 194.571",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.994 193.84L609.953 189.747",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.16 183.9L605.14 181.123",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.702 172.645L604.411 172.352",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.598 161.243L605.724 163.581",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.849 151.156L610.099 155.103",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.87 144.14L616.225 149.11",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.853 182.585C637.519 182.731 637.373 186.093 635.477 185.801C633.581 185.508 631.539 187.409 630.081 186.678C628.622 185.947 625.268 187.701 624.247 185.508C623.226 183.462 620.163 185.216 619.871 182.146C619.58 179.076 617.246 179.807 617.1 176.884C617.1 173.96 614.912 172.644 616.663 170.744C618.413 168.844 615.787 165.482 618.704 164.897C621.621 164.312 619.434 161.389 621.33 161.243C623.226 161.096 625.414 157.296 628.331 158.319C631.248 159.342 632.852 156.711 634.165 158.758C635.477 160.804 638.394 157.734 639.707 160.658C641.02 163.581 644.229 162.704 643.937 165.774C643.645 168.844 646.708 170.452 645.249 172.645C643.791 174.837 645.541 177.468 643.645 178.492C641.895 179.661 643.937 182.146 639.853 182.585Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.311 181.708C634.456 178.638 633.29 177.761 630.956 177.468C628.622 177.176 627.601 176.884 626.872 174.399C626.143 171.767 625.997 169.282 623.955 167.967C622.059 166.651 619.58 164.751 619.58 164.751",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.871 174.545C621.767 173.96 623.372 169.575 625.122 169.575",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.059 178.784C624.393 178.93 627.164 175.714 627.164 175.714",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.31 182C629.206 181.561 629.497 179.953 630.956 178.345",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.582 172.645C636.061 173.522 630.956 170.452 632.852 164.897C634.748 159.342 629.06 158.173 629.06 158.173",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.768 176.591C628.914 174.983 630.956 170.89 633.436 170.89",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.374 172.791C636.644 174.691 637.519 177.761 639.124 179.661",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.372 160.658C623.809 163.143 625.705 165.628 629.643 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.645 166.651C641.02 168.405 638.103 169.282 637.373 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.158 372.909C418.158 372.909 416.116 359.022 415.824 357.414C415.533 355.952 416.116 354.052 417.283 351.859C418.45 349.667 421.658 342.65 420.638 335.78C419.617 328.909 409.844 317.215 393.947 319.554C378.049 321.893 377.174 335.195 377.757 339.142C378.34 343.235 380.528 346.012 379.216 348.643C377.903 351.275 375.569 354.344 375.715 355.514C375.861 356.683 379.653 355.806 380.091 357.122C380.382 358.291 382.278 363.846 382.716 365.454C383.154 367.062 384.175 367.647 386.946 367.354C389.717 367.062 394.968 366.77 395.405 369.401C395.843 372.032 396.426 376.71 396.426 376.71",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.152 324.232L375.424 327.594",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.694 316.776L379.362 321.162",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.591 309.906L387.092 315.315",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.53 306.836L395.551 313.561",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.907 307.275L404.302 313.707",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.408 311.222L413.345 316.776",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.43 318.092L419.908 322.039",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3 349.667C389.863 347.328 386.508 347.766 386.654 345.866C386.8 343.966 384.612 342.212 385.05 340.75C385.487 339.142 383.445 336.072 385.342 334.903C387.238 333.587 385.05 330.956 387.967 330.225C390.884 329.494 389.863 327.301 392.78 326.863C395.697 326.424 396.718 324.232 398.76 325.547C400.802 327.009 403.719 324.085 404.74 326.863C405.761 329.64 408.24 327.009 408.678 328.909C409.115 330.81 413.199 332.418 412.47 335.341C411.741 338.265 414.658 339.58 412.762 341.042C410.866 342.504 414.22 344.989 411.595 346.743C408.97 348.497 410.136 351.421 407.073 351.567C404.011 351.713 402.844 354.929 400.51 353.76C398.176 352.59 395.843 354.783 394.53 353.029C393.363 351.128 391.176 353.467 390.3 349.667Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3 344.112C393.217 343.966 393.947 342.504 393.947 340.311C393.947 337.972 394.093 336.949 396.426 335.78C398.906 334.756 401.385 334.172 402.26 332.125C403.281 330.079 404.886 327.448 404.886 327.448",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.551 328.909C396.28 330.663 400.948 331.687 401.093 333.441",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.613 331.687C391.759 334.026 395.259 336.218 395.259 336.218",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.279 337.242C389.863 338.996 391.613 339.142 393.363 340.311",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.927 348.936C398.468 344.55 400.948 339.142 406.49 340.311C412.032 341.481 412.616 335.78 412.616 335.78",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.676 337.972C396.28 337.972 400.51 339.288 400.802 341.919",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.489 345.866C397.593 345.427 394.676 346.597 392.926 348.497",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.553 330.517C407.219 331.394 405.032 333.441 404.886 337.388",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.344 351.275C404.302 348.936 403.135 346.158 406.052 344.989",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.979 386.942C645.979 386.942 634.165 380.364 632.852 379.633C631.539 378.902 629.789 378.756 627.455 379.049C625.122 379.487 617.683 379.926 611.995 376.71C606.161 373.494 599.014 360.776 606.453 347.328C613.891 333.879 625.997 337.534 629.497 339.434C632.852 341.335 634.748 344.258 637.519 343.966C640.436 343.673 643.937 342.65 644.958 343.235C645.979 343.82 643.937 346.889 644.958 347.62C645.979 348.351 650.208 351.859 651.521 352.737C652.834 353.614 652.98 354.929 651.813 357.122C650.646 359.461 648.604 364.138 650.792 365.454C652.98 366.623 657.063 368.962 657.063 368.962",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.996 326.278L619.871 333.149",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.391 328.909L612.725 334.61",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.202 334.61L604.848 339.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.93 343.381L600.473 346.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.43 353.76L597.556 354.491",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.284 364.577L597.41 363.7",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.93 374.079L599.889 371.447",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.602 354.052C632.706 352.883 634.165 349.959 632.414 349.374C630.664 348.79 629.789 346.305 628.331 346.158C626.726 346.158 624.684 343.235 622.934 344.404C621.184 345.72 619.434 342.796 617.829 345.281C616.225 347.62 614.475 346.012 613.162 348.497C611.849 350.982 609.37 351.128 610.099 353.467C610.683 355.806 607.036 357.414 609.224 359.314C611.412 361.069 608.203 362.53 609.807 363.554C611.266 364.577 611.558 368.816 614.329 369.108C617.246 369.547 617.392 372.471 619.434 371.301C621.33 370.132 622.497 373.932 624.976 372.178C627.455 370.278 629.643 372.471 630.81 369.693C631.977 366.916 635.186 367.062 635.04 364.577C634.894 362.092 637.519 360.63 636.352 358.876C634.894 357.268 637.811 356.099 634.602 354.052Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.497 352.152C628.331 354.783 626.872 354.929 624.83 354.198C622.788 353.321 621.767 353.175 620.017 354.929C618.267 356.683 616.954 358.876 614.766 359.022C612.579 359.168 609.662 359.753 609.662 359.753",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.183 351.713C615.496 353.029 614.912 357.56 616.371 358.291",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.975 349.082C620.017 349.959 620.892 353.906 620.892 353.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.809 348.936C625.268 350.105 624.684 351.713 625.268 353.613",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.664 362.53C627.31 359.753 621.621 360.045 620.746 365.6C619.871 371.009 614.621 369.547 614.621 369.547",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.642 354.052C622.059 355.514 621.913 359.753 624.101 360.922",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.039 361.069C628.331 359.168 630.373 356.976 632.56 356.099",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.974 364.869C612.579 362.969 615.204 361.8 618.704 362.969",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.664 368.962C629.352 366.331 627.164 364.285 625.122 366.623",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.559 130.838C625.559 130.838 626.726 120.751 627.018 119.143C627.164 118.412 628.039 117.681 629.497 117.828C631.394 118.12 631.394 120.02 631.394 120.02C631.394 120.02 663.335 123.967 665.669 124.26C668.002 124.552 670.19 126.891 669.753 130.838C669.315 134.784 666.544 136.1 664.356 135.954C662.314 135.661 629.935 131.715 629.935 131.715C629.935 131.715 629.497 133.615 627.31 133.323C625.851 133.176 625.414 131.715 625.559 130.838Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.102 127.183L630.664 131.422",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.29 129.376L632.998 131.715",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.498 127.914L635.915 132.153",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.686 130.107L638.394 132.446",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.749 128.499L641.311 132.738",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.937 130.691L643.645 133.03",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.336 121.336C670.336 121.336 673.399 96.9241 673.691 94.4391C673.982 91.954 670.774 87.7149 666.398 89.1767C661.877 90.6384 638.54 98.6783 638.54 98.6783L625.268 97.0703C625.268 97.0703 624.976 95.17 622.934 94.8776C621.621 94.7314 620.746 95.7547 620.601 96.4856C620.455 97.2165 619.288 107.449 619.142 108.618C618.996 109.349 619.725 110.226 621.038 110.373C622.934 110.665 623.518 108.765 623.518 108.765C623.518 108.765 634.748 110.08 635.332 110.226C635.915 110.226 649.479 119.143 649.479 119.143",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.122 97.0703L624.684 101.309",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.893 97.3627L627.601 99.7015",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.102 97.8011L630.518 102.04",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.727 98.0935L633.435 100.432",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.126 94.0005C654.876 94.5852 661.439 106.279 660.71 118.12",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.769 234.478C468.769 234.478 473.144 228.485 473.874 227.461C474.165 227.023 475.04 226.877 475.915 227.608C477.082 228.485 476.353 229.8 476.353 229.8C476.353 229.8 495.605 243.98 497.064 245.003C498.523 246.026 499.106 248.365 497.356 250.704C495.605 253.043 493.272 253.043 492.105 252.019C490.792 251.142 471.394 236.817 471.394 236.817C471.394 236.817 470.519 237.986 469.206 236.963C468.185 236.086 468.331 235.063 468.769 234.478Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.728 234.186L471.832 236.817",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.311 236.378L473.29 237.84",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.936 236.525L475.04 239.156",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.52 238.717L476.499 240.179",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.145 238.863L478.249 241.495",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.729 241.202L479.708 242.518",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.148 244.564C501.148 244.564 511.941 229.8 512.962 228.339C513.983 226.877 513.545 222.93 510.191 222.199C506.836 221.468 488.605 218.252 488.605 218.252L480.583 212.405C480.583 212.405 481.02 211.089 479.853 210.212C478.978 209.628 478.103 209.92 477.812 210.359C477.52 210.797 472.998 216.937 472.415 217.667C472.123 218.106 472.269 218.837 472.998 219.422C474.165 220.299 475.186 219.275 475.186 219.275C475.186 219.275 481.895 224.246 482.333 224.538C482.625 224.83 488.313 235.501 488.313 235.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.729 212.551L478.832 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.333 213.721L481.312 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.229 215.182L482.333 217.667",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.833 216.352L484.812 217.668",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.981 220.591C500.856 221.614 501.002 231.554 496.189 239.01",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.64 95.3161L596.243 127.622L603.39 128.937L608.932 96.3393L606.161 88.738L601.64 95.3161Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.932 96.3393C608.932 96.3393 605.724 97.9473 601.494 95.1699",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.118 122.651L604.119 123.967",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.348 306.836L415.679 279.793L409.699 283.886L428.222 311.222L435.66 314.73L434.348 306.836Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.222 311.222C428.222 311.222 429.389 307.86 434.348 306.836",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.596 284.033L412.762 287.833",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.898 345.281L667.419 294.996L656.188 295.434L658.522 346.012L665.231 356.537L669.898 345.281Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.522 346.012C658.522 346.012 662.752 342.504 669.898 345.281",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.711 302.89L656.918 303.036",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.207 46.6387L658.96 23.1039L653.855 17.9877L630.81 41.5224L628.768 49.416L636.207 46.6387Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.81 41.5223C630.81 41.5223 634.311 41.9609 636.207 46.6386",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.459 26.7583L650.5 21.6421",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828.22 97.5486C835.836 90.1124 835.996 77.8961 828.576 70.2628C821.157 62.6294 808.968 62.4696 801.351 69.9058C793.735 77.342 793.576 89.5583 800.995 97.1916C808.415 104.825 820.604 104.985 828.22 97.5486Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.452 83.6218L787.952 83.3295C787.806 90.1999 790.431 97.0703 795.536 102.333C805.892 112.858 822.81 113.15 833.312 102.771C838.562 97.655 841.334 90.7846 841.334 83.9142H837.979",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.37 70.0272C804.141 76.1667 819.456 83.768 828.499 70.3196",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.307 92.9773C804.141 86.3993 820.914 83.0371 831.853 92.8311",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.687 107.01L833.457 102.771",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.728 123.967L854.46 102.625C854.46 102.625 850.96 99.4092 847.168 103.064C845.417 101.309 843.375 101.748 841.479 103.648C839.437 105.549 835.354 109.642 834.041 110.811C832.728 112.127 831.707 114.758 833.458 116.658C831.999 118.412 829.957 121.044 832.728 123.967Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.106 189.539C763.829 185.635 764.5 178.634 760.606 173.9C756.711 169.166 749.725 168.493 745.002 172.397C740.278 176.3 739.607 183.302 743.502 188.036C747.397 192.769 754.383 193.442 759.106 189.539Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.654 180.977L736.612 180.831C736.612 184.777 738.07 188.724 740.987 191.794C746.967 197.933 756.739 198.08 762.865 192.086C765.928 189.163 767.533 185.216 767.533 181.269H765.636",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.342 173.083C745.946 176.591 754.843 180.977 760.094 173.229",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.592 186.239C745.946 182.439 755.718 180.538 761.99 186.093",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.345 194.425L762.865 191.94",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.428 204.219L774.971 191.94C774.971 191.94 772.929 190.04 770.741 192.233C769.72 191.209 768.553 191.502 767.387 192.671C766.22 193.84 763.886 196.033 763.157 196.91C762.428 197.641 761.844 199.249 762.865 200.272C761.99 201.003 760.823 202.611 762.428 204.219Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.229 320.577L675.646 353.467L682.938 353.76L683.668 320.723L679.875 313.561L676.229 320.577Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.668 320.723C683.668 320.723 680.751 322.77 676.229 320.723",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.791 348.351L682.792 348.643",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.168 364.285L716.922 335.195L688.335 305.813L687.168 364.285ZM706.566 334.756L695.336 345.72L695.773 323.647L706.566 334.756Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.273 314.438L693.294 313.561",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.731 317.946L695.627 316.046",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.94 319.262L697.961 318.385",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.399 322.77L700.295 320.87",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.607 324.085L702.482 323.208",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.066 327.594L704.962 325.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.275 328.763L707.15 327.886",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.733 332.418L709.629 330.371",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.942 333.587L711.817 332.71",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.705 195.595L781.826 210.212L796.995 181.561L826.019 166.944L810.705 195.595Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.768 177.615L835.499 192.671C835.499 192.671 836.083 200.126 825.582 210.359C815.08 220.591 807.496 220.006 807.496 220.006L792.765 204.95",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.326 209.043L803.704 227.9",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.788 228.046C808.954 229.216 808.954 231.262 807.788 232.432C806.621 233.601 804.579 233.601 803.412 232.432C802.245 231.262 802.245 229.216 803.412 228.046C804.725 226.731 806.621 226.731 807.788 228.046Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.954 235.209C808.954 235.209 809.684 239.156 812.017 241.495C813.184 240.325 817.268 236.378 817.268 236.378C817.268 236.378 813.622 233.455 810.996 233.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.149 134.346L686.876 163.874L680.751 132.007L693.877 102.479L700.149 134.346Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.503 114.027L717.359 116.366C717.359 116.366 722.61 121.774 721.006 136.392C719.401 151.01 712.984 155.249 712.984 155.249L692.127 152.91",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.918 160.804L715.026 163.728",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.38 161.243C720.131 161.389 721.297 162.997 721.006 164.605C720.86 166.359 719.255 167.528 717.651 167.236C715.901 167.09 714.734 165.482 715.026 163.874C715.172 162.266 716.63 160.95 718.38 161.243Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.777 166.067C723.777 166.067 726.84 168.698 730.049 168.99C730.194 167.382 730.924 161.681 730.924 161.681C730.924 161.681 726.256 161.681 724.069 163.143",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.342 109.499L744.015 135.204L778.924 171.119L805.251 145.414L770.342 109.499Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.409 111.103L776.429 109.934L811.434 145.894L785.035 171.767L783.868 170.452",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.992 126.375L749.798 135.351L758.551 144.356L767.744 135.38L758.992 126.375Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.282 123.529L769.72 116.22",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.491 126.744L772.929 119.582",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.761 149.987L784.014 131.276",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.408 153.787L787.514 135.077",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.054 157.442L791.161 138.731",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.549 15.6046L745.795 15.401L745.518 65.5402L782.273 65.7438L782.549 15.6046Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.035 20.1803H786.639L786.347 70.3195L749.447 70.1733V68.4192",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.755 19.6319L749.92 19.5608L749.851 32.1321L762.686 32.2032L762.755 19.6319Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.095 19.8879H777.45",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.949 24.4194L777.45 24.5656",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.322 40.4991L777.013 40.6453",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.322 45.7616L777.013 45.9078",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.176 50.8778L777.013 51.024",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.831 116.684L828.936 143.919L865.677 181.718L893.572 154.483L856.831 116.684Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.254 123.676L836.195 143.26L840.571 147.763L860.63 128.178L856.254 123.676Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.203 134.959L846.935 154.747L865.866 174.223L886.134 154.434L867.203 134.959Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.377 145.163L875.901 164.166",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.086 154.811L870.941 168.99",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.482 140.047L881.005 159.196",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.981 159.635L871.817 140.193",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.794 164.459L876.63 145.163",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.607 169.429L881.297 150.133",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.732 184.064L678.864 186.486L682.131 239.156L720.999 236.734L717.732 184.064Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.762 189.031L684.811 190.773L685.201 197.047L713.151 195.305L712.762 189.031Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.716 204.692L685.474 206.452L687.158 233.59L715.399 231.83L713.716 204.692Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.565 205.973L701.316 232.578",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.148 212.99L694.315 232.87",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.858 205.535L708.462 231.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.147 213.428L713.713 211.674",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.585 220.299L714.151 218.545",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.022 227.169L714.588 225.415",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.215 81.8677L880.422 90.1999L882.318 106.864L898.362 113.588L911.634 103.356L909.301 86.5454L897.487 81.4292",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.32 78.2133C897.341 79.5289 897.049 81.5754 895.736 82.5987C894.424 83.6219 892.382 83.3296 891.361 82.014C890.34 80.6984 890.631 78.6519 891.944 77.6286C893.257 76.6054 895.153 76.7515 896.32 78.2133Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.9 86.3992C876.776 87.4225 876.484 89.0304 875.463 89.9075C874.442 90.7846 872.838 90.4922 871.962 89.469C871.087 88.4457 871.379 86.8378 872.4 85.9607C873.567 85.0836 875.171 85.2298 875.9 86.3992Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.591 124.26C903.758 125.868 903.466 128.06 901.862 129.23C900.258 130.399 898.07 130.107 896.903 128.499C895.736 126.891 896.028 124.698 897.632 123.529C899.237 122.359 901.424 122.652 902.591 124.26Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.866 115.343C930.741 116.512 930.595 118.12 929.428 119.143C928.261 120.02 926.657 119.874 925.636 118.705C924.761 117.535 924.907 115.927 926.073 114.904C927.24 113.881 928.99 114.173 929.866 115.343Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.302 62.1337C924.469 63.5955 924.177 65.7882 922.719 66.8114C921.26 67.9808 919.073 67.6885 918.052 66.2267C916.885 64.7649 917.177 62.5722 918.635 61.549C920.094 60.3796 922.135 60.6719 923.302 62.1337Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.722 97.6551C945.034 99.4092 944.742 101.894 942.992 103.21C941.242 104.525 938.763 104.233 937.45 102.479C936.137 100.725 936.429 98.2398 938.179 96.9242C939.929 95.6086 942.409 95.9009 943.722 97.6551Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.3 86.5455L922.427 76.6053L938.325 82.891L939.638 95.7547",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.634 103.356L927.094 109.934L937.158 102.187",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.114 67.5422L922.427 76.6053",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.484 88.738L880.422 90.1998",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.091 122.944L898.362 113.588",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.094 109.934L927.24 114.027",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.203 34.0674L798.453 42.2534L806.037 49.2699L816.101 46.2002L818.435 35.9677L810.705 29.0973L803.12 31.29",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.224 30.2666C802.245 30.559 802.974 31.5822 802.683 32.6055C802.391 33.6287 801.37 34.3596 800.349 34.0673C799.328 33.7749 798.599 32.7516 798.891 31.7284C799.182 30.7051 800.203 30.1204 801.224 30.2666Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.807 42.2533C795.682 42.3995 796.119 43.2765 795.974 44.0074C795.828 44.8845 794.953 45.323 794.223 45.1769C793.348 45.0307 792.911 44.1536 793.057 43.4227C793.202 42.5457 794.077 41.9609 794.807 42.2533Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.373 49.4161C823.54 49.7085 824.269 50.8779 823.977 52.0473C823.685 53.2168 822.519 53.9477 821.352 53.6553C820.185 53.363 819.456 52.1935 819.747 51.0241C820.039 50.0008 821.206 49.1238 822.373 49.4161Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.707 34.5059C832.582 34.652 833.166 35.5291 832.874 36.4062C832.728 37.2833 831.853 37.868 830.978 37.5756C830.103 37.4294 829.519 36.5524 829.811 35.6753C829.811 34.7982 830.686 34.2135 831.707 34.5059Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.642 11.9944C808.809 12.2868 809.392 13.31 809.246 14.4794C808.954 15.6489 807.933 16.2336 806.767 16.0874C805.6 15.795 805.016 14.7718 805.162 13.6024C805.308 12.4329 806.475 11.702 807.642 11.9944Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.124 20.619C832.437 20.9113 833.312 22.2269 833.02 23.5425C832.728 24.8581 831.416 25.7352 830.103 25.4428C828.79 25.1505 827.915 23.8349 828.207 22.5193C828.644 21.2037 829.811 20.3266 831.124 20.619Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.705 29.0973L812.892 19.1571L822.81 15.795L828.644 21.3498",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.435 35.9678L828.207 33.0442L829.957 25.2968",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.663 15.3566L812.892 19.1572",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.119 43.1304L798.453 42.2533",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.185 50.1469L816.101 46.2001",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.207 33.0442L829.957 34.7983",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.885 219.714L744.634 215.036L731.945 225.123L734.716 241.787L749.739 247.488L762.282 236.963L760.532 224.684",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.428 221.907C761.844 223.515 760.094 224.246 758.49 223.661C756.885 223.076 756.156 221.322 756.739 219.714C757.323 218.106 759.073 217.375 760.677 217.96C762.282 218.691 763.011 220.445 762.428 221.907Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.509 209.482C745.071 210.651 743.613 211.382 742.446 210.797C741.279 210.359 740.55 208.897 741.133 207.727C741.571 206.558 743.029 205.827 744.196 206.412C745.363 206.85 745.946 208.312 745.509 209.482Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.152 250.704C727.423 252.458 725.527 253.335 723.777 252.75C722.027 252.019 721.152 250.119 721.735 248.365C722.464 246.611 724.36 245.734 726.111 246.318C727.861 246.903 728.736 248.95 728.152 250.704Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.301 268.391C748.863 269.707 747.259 270.438 745.946 269.853C744.634 269.415 743.905 267.807 744.488 266.491C744.925 265.176 746.53 264.445 747.843 265.029C749.155 265.614 749.884 267.076 749.301 268.391Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.41 235.94C788.827 237.694 786.931 238.425 785.181 237.84C783.43 237.255 782.701 235.355 783.285 233.601C783.868 231.847 785.764 231.116 787.514 231.701C789.264 232.432 789.994 234.332 789.41 235.94Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.649 273.189C769.73 272.959 771.232 271.082 771.003 268.995C770.775 266.909 768.901 265.404 766.82 265.633C764.738 265.862 763.236 267.74 763.465 269.826C763.694 271.913 765.567 273.418 767.649 273.189Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.282 236.963L777.159 242.664L780.076 258.89L770.304 266.637",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.739 247.488L752.364 263.421L763.74 267.807",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.868 236.963L777.159 242.664",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.759 211.236L744.634 215.036",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.423 247.196L734.716 241.787",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.364 263.421L749.009 265.614",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.447 22.6654C916.447 22.6654 901.425 22.9578 899.82 22.9578C898.216 22.9578 896.32 22.2269 894.132 20.6189C891.944 19.0109 885.089 14.6256 877.651 14.7718C870.358 14.9179 856.502 23.6886 856.794 40.7915C857.086 58.0406 870.942 60.818 875.317 60.6718C879.693 60.6718 882.901 58.7715 885.527 60.5256C888.152 62.2798 891.069 65.2033 892.382 65.2033C893.694 65.2033 893.257 60.9642 894.57 60.818C895.882 60.6718 902.008 59.5024 903.758 59.21C905.508 58.9177 906.384 57.8944 906.384 54.9708C906.384 52.0473 906.967 46.3463 909.738 46.3463C912.509 46.3463 917.614 46.2001 917.614 46.2001",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.107 67.9808L862.482 61.8413",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.96 60.9642L856.21 56.725",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.98 50.5856L851.106 47.662",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.23 38.599L850.522 38.3066",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.272 26.6122L851.835 29.0972",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.96 15.9412L856.502 20.0342",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.419 8.33997L862.92 13.6024",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.86 48.9775C885.381 49.1236 885.235 52.6319 883.193 52.3396C881.151 52.0472 879.109 54.0937 877.505 53.3628C875.901 52.6319 872.4 54.3861 871.233 52.1934C870.066 50.0007 867.004 51.901 866.566 48.6851C866.274 45.4692 863.649 46.2001 863.649 43.1303C863.649 40.0606 861.315 38.5988 863.211 36.6985C864.962 34.7981 862.336 31.1437 865.399 30.559C868.462 29.9742 866.128 26.9045 868.17 26.6121C870.212 26.3198 872.546 22.373 875.609 23.5424C878.672 24.7118 880.422 21.7883 881.735 23.9809C883.047 26.1736 886.11 22.9577 887.569 26.0274C889.027 29.0972 892.382 28.2201 891.944 31.436C891.653 34.7981 894.861 36.4061 893.403 38.745C891.944 41.0838 893.84 43.8612 891.798 45.0306C890.048 46.0539 892.09 48.6851 887.86 48.9775Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.026 48.2466C882.172 45.0307 880.859 44.1536 878.526 43.8613C876.046 43.5689 874.88 43.2765 874.15 40.6453C873.421 37.8679 873.275 35.2367 871.087 33.9211C869.046 32.6055 866.42 30.4128 866.42 30.4128",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.712 40.6454C868.754 40.0606 870.504 35.3829 872.4 35.3829",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.045 45.0307C871.525 45.1769 874.442 41.8148 874.442 41.8148",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.734 48.3928C876.776 47.9543 877.067 46.2001 878.526 44.5922",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.59 38.5989C883.777 39.6222 878.38 36.2601 880.422 30.4129C882.318 24.5658 876.484 23.3964 876.484 23.3964",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.192 42.6919C876.484 40.9378 878.526 36.6986 881.151 36.6986",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.235 38.745C884.506 40.6453 885.381 44.0074 887.131 46.0539",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.358 26.0276C870.941 28.6588 872.838 31.29 877.067 32.0209",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.944 32.3132C889.173 34.2135 886.11 35.0906 885.381 31.7285",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.633 47.6619C737.633 47.6619 727.569 38.1603 726.548 37.1371C725.381 36.1138 724.652 34.3597 724.36 32.0208C724.069 29.682 722.173 22.2269 717.359 17.6953C712.4 13.0176 697.815 10.0941 687.168 21.496C676.375 32.8979 683.668 43.7151 686.585 46.3463C689.502 49.1237 692.856 50.0008 693.44 52.7782C694.023 55.7017 694.169 59.3562 695.044 60.2333C695.919 60.9642 698.253 58.0406 699.274 58.7715C700.295 59.5024 704.962 62.5721 706.275 63.5954C707.587 64.6186 708.754 64.4724 710.65 62.5721C712.546 60.6718 716.484 57.3097 718.38 59.0639C720.276 60.818 723.631 64.0339 723.631 64.0339",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.541 40.0607L677.396 38.8912",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.395 30.9976L676.521 31.4361",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.02 20.1804L679 22.2269",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.584 11.4097L684.397 15.795",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.627 4.68542L691.252 10.5326",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.982 1.32336L700.149 7.60904",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.338 1.76184L708.317 7.60898",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.191 46.6387C700.441 45.1769 698.107 47.5158 697.086 45.9078C695.919 44.2998 693.294 44.446 692.71 42.8381C692.127 41.3763 688.627 40.2068 689.356 38.1603C690.085 35.9677 686.731 35.2368 688.627 32.8979C690.377 30.5591 688.335 29.3896 690.231 27.3431C692.127 25.2966 691.544 22.9578 694.023 22.8116C696.503 22.6654 696.94 18.5724 699.42 20.1804C701.899 21.7884 702.191 18.2801 703.795 19.3033C705.254 20.4728 709.338 19.3033 710.65 21.9345C711.963 24.5657 714.88 23.8349 714.297 26.1737C713.713 28.5126 717.943 28.3664 716.776 31.29C715.755 34.2135 718.526 35.8215 716.193 37.7218C713.859 39.6221 715.026 42.8381 712.546 43.4228C710.067 44.0075 709.483 47.0772 707.442 46.4925C705.545 46.054 705.254 49.1237 702.191 46.6387Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.982 42.3995C701.17 40.4992 700.878 39.0374 699.42 37.2832C697.961 35.5291 697.378 34.652 698.69 32.3132C699.857 29.9743 701.607 28.074 701.024 25.8813C700.587 23.6886 700.149 20.6189 700.149 20.6189",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.731 27.6355C695.482 28.5125 699.566 26.6122 700.732 27.7816",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.419 32.0209C693.877 33.775 697.961 33.3365 697.961 33.3365",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.877 37.8679C695.482 38.8912 696.794 37.8679 698.836 37.8679",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.338 40.3529C705.545 37.8679 704.233 32.3131 709.192 29.6819C714.151 27.1969 711.088 22.5192 711.088 22.5192",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.545 35.0905C699.857 34.0673 703.941 32.6055 705.691 34.3596",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.004 38.3064C705.254 39.1835 703.795 41.8147 703.649 44.2997",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.4 20.3265C704.087 22.373 703.649 25.2966 705.983 28.5125",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.463 38.3064C712.4 37.7217 709.921 36.4061 711.379 33.7749",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.194 312.976C730.194 312.976 719.401 306.983 718.235 306.252C717.068 305.521 715.463 305.375 713.276 305.813C711.088 306.106 704.379 306.69 698.982 303.62C693.731 300.697 687.022 289.003 693.877 276.577C700.732 264.152 711.963 267.514 715.026 269.269C718.235 271.023 719.839 273.654 722.464 273.362C725.09 273.069 728.298 272.192 729.319 272.631C730.194 273.069 728.298 275.993 729.319 276.724C730.194 277.455 734.132 280.67 735.445 281.401C736.612 282.278 736.758 283.302 735.737 285.494C734.716 287.687 732.82 291.926 734.862 293.096C736.904 294.265 740.55 296.312 740.55 296.312",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.254 257.282L706.129 263.421",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.378 259.621L699.566 264.737",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.918 264.883L692.419 269.415",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.084 272.923L688.189 275.847",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.021 282.425L685.71 283.155",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.875 292.365L685.564 291.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.23 301.135L687.752 298.65",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 282.717C717.943 281.547 719.255 279.062 717.651 278.478C716.047 277.893 715.317 275.554 713.859 275.554C712.4 275.554 710.504 272.777 708.9 273.946C707.296 275.116 705.691 272.484 704.233 274.677C702.774 276.87 701.17 275.408 700.003 277.601C698.836 279.793 696.648 279.94 697.086 282.132C697.669 284.325 694.315 285.787 696.357 287.541C698.399 289.149 695.482 290.464 696.794 291.488C698.253 292.511 698.399 296.312 701.024 296.604C703.649 296.896 703.795 299.674 705.691 298.65C707.441 297.481 708.462 301.135 710.796 299.381C712.984 297.627 715.172 299.674 716.193 297.189C717.214 294.704 720.276 294.85 720.131 292.511C719.985 290.172 722.318 288.856 721.297 287.395C719.985 285.64 722.61 284.617 719.693 282.717Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.026 280.963C714.005 283.302 712.546 283.594 710.796 282.863C708.9 282.132 708.025 281.84 706.275 283.594C704.67 285.202 703.503 287.248 701.462 287.395C699.42 287.541 696.794 288.126 696.794 288.126",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.878 280.524C702.191 281.694 701.607 285.933 702.92 286.518",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.379 278.185C706.275 279.062 707.004 282.571 707.004 282.571",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.775 278.039C711.088 279.062 710.65 280.524 711.088 282.278",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.193 290.464C713.13 287.833 707.879 288.272 707.004 293.242C706.129 298.212 701.462 296.896 701.462 296.896",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.608 282.717C708.025 284.033 707.879 287.979 709.921 289.003",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.713 289.149C714.005 287.395 715.901 285.348 717.943 284.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.961 292.657C699.42 290.903 701.753 289.88 705.108 290.903",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.047 296.458C714.734 293.973 712.838 292.218 711.088 294.265",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.033 53.3629C938.033 53.3629 942.847 42.6919 943.576 40.9377C944.013 40.0607 945.18 39.6221 946.784 40.4992C948.681 41.3763 948.243 43.5689 948.243 43.5689C948.243 43.5689 981.935 58.7715 984.414 59.9409C986.894 61.1104 988.498 64.3263 986.602 68.5655C984.706 72.6585 981.206 73.3894 979.018 72.3661C976.83 71.3429 942.555 55.8479 942.555 55.8479C942.555 55.8479 941.534 57.8944 939.2 56.725C937.596 55.9941 937.596 54.24 938.033 53.3629Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.472 51.3163L943.43 55.7016",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.076 54.3861L945.909 56.8711",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.014 53.8014L948.972 58.3329",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.764 57.0173L951.598 59.5024",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.702 56.2864L954.661 60.8179",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.307 59.5023L957.14 61.9874",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.54 58.1868C990.54 58.1868 1002.21 32.3132 1003.37 29.682C1004.54 27.0508 1002.5 21.3498 997.103 21.3498C991.707 21.3498 963.12 22.2269 963.12 22.2269L949.118 15.9412C949.118 15.9412 949.41 13.7485 947.222 12.7253C945.763 11.9944 944.451 12.8714 944.159 13.6023C943.867 14.3332 938.908 25.1504 938.471 26.3199C938.033 27.1969 938.617 28.2202 939.929 28.8049C941.971 29.682 943.284 27.7816 943.284 27.7816C943.284 27.7816 955.098 33.1903 955.681 33.3364C956.265 33.6288 968.225 47.9543 968.225 47.9543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.118 16.0873L947.076 20.4726",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.889 17.2568L950.868 19.7419",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.244 18.8647L953.348 23.3963",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.161 20.1803L957.14 22.5192",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.914 22.2268C982.518 23.5424 985.873 38.5988 981.06 51.4625",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.734 97.2165C714.734 97.2165 719.11 91.2232 719.839 90.1999C720.131 89.7614 721.006 89.6152 721.881 90.3461C723.048 91.2232 722.318 92.5388 722.318 92.5388C722.318 92.5388 741.571 106.718 743.029 107.741C744.488 108.765 745.071 111.103 743.321 113.442C741.571 115.781 739.237 115.781 738.07 114.758C736.758 113.881 717.359 99.5553 717.359 99.5553C717.359 99.5553 716.484 100.725 715.172 99.7015C714.151 98.8245 714.442 97.8012 714.734 97.2165Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 96.9241L717.797 99.5553",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.277 99.1167L719.256 100.578",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.902 99.2629L721.006 101.894",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.485 101.456L722.464 102.917",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.111 101.602L724.215 104.233",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.694 103.794L725.673 105.256",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.113 107.303C747.113 107.303 757.906 92.5386 758.927 91.0769C759.948 89.6151 759.511 85.6683 756.156 84.9374C752.801 84.2065 734.57 80.9905 734.57 80.9905L726.548 75.1434C726.548 75.1434 726.986 73.8278 725.819 72.9507C724.944 72.366 724.069 72.6584 723.777 73.0969C723.485 73.5354 718.964 79.6749 718.38 80.4058C718.089 80.8444 718.235 81.5753 718.964 82.16C720.131 83.037 721.152 82.0138 721.152 82.0138C721.152 82.0138 727.861 86.9839 728.298 87.2762C728.59 87.5686 734.278 98.2396 734.278 98.2396",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.694 75.2897L724.798 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.298 76.4591L727.277 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.194 77.9208L728.444 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.945 79.0902L730.924 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.946 83.3295C746.822 84.3527 746.967 94.2929 742.154 101.748",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.251 69.8811L700.878 98.0936L707.15 94.5853L690.669 65.9343L683.522 61.8413L684.251 69.8811Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.669 65.9343C690.669 65.9343 689.356 69.2964 684.251 69.735",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.253 93.7082L704.525 90.3461",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.953 207.581C969.392 215.182 969.246 227.315 961.661 234.77C954.077 242.225 941.971 242.079 934.533 234.478C927.095 226.877 927.24 214.744 934.825 207.289C942.409 199.834 954.515 199.98 961.953 207.581Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.907 220.883L921.406 220.591C921.26 227.461 923.886 234.332 928.991 239.594C939.346 250.119 956.265 250.411 966.766 240.033C972.017 234.916 974.788 228.046 974.788 221.176H971.434",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.825 207.289C937.596 213.428 952.91 221.03 961.953 207.581",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.762 230.239C937.596 223.661 954.369 220.299 965.308 230.093",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.996 244.272L966.912 240.033",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.183 261.229L987.915 239.887C987.915 239.887 984.414 236.671 980.622 240.325C978.872 238.571 976.83 239.01 974.934 240.91C972.892 242.81 968.808 246.903 967.496 248.073C966.183 249.388 965.162 252.019 966.912 253.92C965.308 255.674 963.266 258.305 966.183 261.229Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.126 325.138C897.955 320.351 897.187 313.36 892.411 309.522C887.635 305.684 880.659 306.453 876.829 311.24C873 316.027 873.768 323.019 878.544 326.857C883.32 330.695 890.297 329.926 894.126 325.138Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.962 318.238L869.921 318.092C869.921 322.039 871.379 325.986 874.296 329.055C880.276 335.195 890.048 335.341 896.174 329.348C899.237 326.424 900.841 322.477 900.841 318.531H898.945",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.651 310.345C879.255 313.853 888.152 318.238 893.403 310.491",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.9 323.501C879.255 319.7 889.027 317.8 895.299 323.354",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.653 331.687L896.32 329.348",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.882 341.481L908.425 329.202C908.425 329.202 906.383 327.301 904.196 329.494C903.175 328.471 902.008 328.763 900.841 329.933C899.674 331.102 897.341 333.295 896.611 334.172C895.882 335.049 895.299 336.511 896.32 337.534C895.445 338.265 894.278 339.873 895.882 341.481Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.416 75.7281H1049.03V25.7351L998.416 75.7281ZM1040.42 66.6651H1021.31L1040.42 47.8081V66.6651Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 36.8447H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 41.0839H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 44.8845H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 49.1238H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 53.0706H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 57.3097H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 61.2565H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.34 65.4957H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 69.2963H1046.69",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.106 383.434H741.717V333.441L691.106 383.434ZM733.111 374.225H714.005L733.111 355.368V374.225Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 344.404H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 348.643H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 352.444H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 356.829H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 360.63H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 364.869H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 368.816H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.174 373.055H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.925 376.856H739.383",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.159 332.856L915.135 347.474L930.449 318.823L959.474 304.205L944.159 332.856Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.223 314.876L968.954 329.933C968.954 329.933 969.537 337.388 959.036 347.62C948.535 357.853 940.95 357.268 940.95 357.268L926.219 342.212",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.781 346.305L937.012 365.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.242 365.308C942.409 366.477 942.409 368.524 941.242 369.693C940.075 370.863 938.033 370.863 936.867 369.693C935.7 368.524 935.7 366.477 936.867 365.308C938.179 363.992 940.075 363.992 941.242 365.308Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.409 372.47C942.409 372.47 943.138 376.417 945.472 378.756C946.639 377.587 950.722 373.64 950.722 373.64C950.722 373.64 947.076 370.716 944.451 370.424",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.603 271.607L820.331 301.135L814.059 269.415L827.332 239.74L833.603 271.607Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.957 251.289L850.814 253.627C850.814 253.627 856.065 259.036 854.46 273.654C852.856 288.272 846.438 292.511 846.438 292.511L825.582 290.172",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.373 298.066L848.48 300.989",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.689 298.504C853.439 298.65 854.606 300.258 854.314 301.866C854.169 303.62 852.564 304.79 850.96 304.498C849.21 304.351 848.043 302.743 848.334 301.135C848.48 299.527 850.085 298.212 851.689 298.504Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.231 303.328C857.231 303.328 860.294 305.959 863.503 306.252C863.649 304.644 864.378 298.943 864.378 298.943C864.378 298.943 859.711 298.943 857.523 300.405",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.779 246.724L877.452 272.429L912.361 308.344L938.688 282.639L903.779 246.724Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.717 248.365L909.884 247.196L944.742 283.155L918.489 309.029L917.322 307.713",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.429 263.6L883.236 272.577L891.988 281.581L901.182 272.605L892.429 263.6Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.736 260.79L903.175 253.481",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.945 264.152L906.383 256.843",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.216 287.249L917.322 268.538",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.862 291.049L920.969 272.338",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.508 294.704L924.615 275.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.454 181.692L909.296 162.588L883.369 195.521L907.527 214.626L933.454 181.692Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.783 186.093L933.804 186.824L907.842 219.86L883.631 200.711L884.506 199.541",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.221 174.152L909.863 167.542L903.359 175.804L911.717 182.414L918.221 174.152Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.969 176.591L927.824 182",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.635 179.515L925.49 184.924",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.383 181.561L916.885 195.448",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.611 184.924L914.259 198.811",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.986 188.432L911.488 202.319",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.268 253.909L962.374 281.144L999.115 318.943L1027.01 291.708L990.268 253.909Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.689 261.107L969.63 280.692L974.006 285.194L994.065 265.61L989.689 261.107Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.64 272.184L980.373 291.973L999.303 311.448L1019.57 291.66L1000.64 272.184Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.686 282.425L1009.21 301.428",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.394 292.072L1004.25 306.252",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.937 277.308L1014.46 296.458",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.435 296.896L1005.13 277.454",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.102 301.72L1009.94 282.425",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.916 306.69L1014.75 287.395",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.19 321.327L812.321 323.748L815.588 376.419L854.457 373.997L851.19 321.327Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.073 326.303L818.123 328.045L818.512 334.318L846.463 332.577L846.073 326.303Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.173 341.955L818.932 343.715L820.615 370.852L848.856 369.093L847.173 341.955Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.02 343.235L834.624 369.839",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.602 350.398L827.769 370.278",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.312 342.796L841.917 369.401",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.602 350.69L847.168 348.936",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.039 357.56L847.605 355.806",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.477 364.431L848.043 362.677",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.06 250.265L1032.69 255.089L1043.92 247.78L1043.05 233.893L1031.09 227.9L1020 235.501L1020.44 245.88",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.54 247.926C1019.13 246.757 1020.59 246.172 1021.9 246.757C1023.06 247.342 1023.65 248.803 1023.06 250.119C1022.48 251.288 1021.02 251.873 1019.71 251.288C1018.4 250.558 1017.96 249.096 1018.54 247.926Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.52 259.621C1031.96 258.597 1033.13 258.305 1034.15 258.744C1035.17 259.182 1035.46 260.352 1035.02 261.375C1034.59 262.398 1033.42 262.69 1032.4 262.252C1031.38 261.667 1030.94 260.498 1031.52 259.621Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.17 227.169C1049.9 225.707 1051.65 225.123 1052.96 225.853C1054.42 226.584 1055.01 228.338 1054.28 229.654C1053.55 231.116 1051.8 231.701 1050.49 230.97C1049.03 230.239 1048.59 228.485 1049.17 227.169Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.27 210.797C1033.86 209.774 1035.02 209.335 1036.19 209.774C1037.21 210.359 1037.65 211.528 1037.21 212.697C1036.63 213.721 1035.46 214.159 1034.3 213.721C1033.13 213.136 1032.69 211.82 1033.27 210.797Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.541 234.039C998.27 232.724 999.875 232.139 1001.19 232.87C1002.5 233.601 1003.08 235.209 1002.35 236.525C1001.62 237.84 1000.02 238.425 998.708 237.694C997.395 237.109 996.957 235.501 997.541 234.039Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.77 206.996C1016.5 205.389 1018.4 204.804 1020 205.535C1021.61 206.266 1022.19 208.166 1021.46 209.774C1020.73 211.382 1018.84 211.967 1017.23 211.236C1015.63 210.505 1015.04 208.604 1015.77 206.996Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 235.501L1008.19 229.654L1007.17 216.06L1015.92 210.505",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.09 227.9L1030.36 214.598L1021.31 210.066",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.21 233.747L1008.19 229.654",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.98 258.305L1032.69 255.089",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.46 230.093L1043.05 233.893",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.36 214.598L1033.27 212.99",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.575 151.156L933.658 160.219L941.534 169.136L953.348 166.651L957.14 155.395L948.972 146.625L940.075 148.379",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.179 146.917C939.346 147.356 939.929 148.525 939.638 149.695C939.2 150.864 938.033 151.449 936.866 151.156C935.7 150.718 935.116 149.548 935.408 148.379C935.7 147.21 937.012 146.625 938.179 146.917Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.574 159.781C930.449 160.073 931.032 161.096 930.741 161.974C930.449 162.851 929.428 163.435 928.553 163.143C927.678 162.851 927.094 161.827 927.386 160.95C927.678 160.073 928.699 159.489 929.574 159.781Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.203 171.037C961.515 171.475 962.245 172.937 961.807 174.253C961.37 175.568 959.911 176.299 958.598 175.86C957.286 175.422 956.556 173.96 956.994 172.645C957.432 171.329 958.89 170.598 960.203 171.037Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.309 154.957C973.329 155.249 973.767 156.273 973.475 157.296C973.184 158.319 972.163 158.758 971.142 158.465C970.121 158.173 969.683 157.15 969.975 156.126C970.267 155.249 971.288 154.665 972.309 154.957Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.368 126.891C948.68 127.329 949.264 128.645 948.826 129.814C948.389 131.13 947.076 131.715 945.909 131.276C944.597 130.838 944.013 129.522 944.451 128.353C944.742 127.183 946.055 126.452 947.368 126.891Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.329 139.316C974.788 139.754 975.517 141.362 975.08 142.824C974.642 144.286 973.038 145.017 971.579 144.578C970.121 144.14 969.391 142.532 969.829 141.07C970.267 139.608 971.871 138.877 973.329 139.316Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.972 146.625L952.618 135.661L964.287 132.884L970.267 139.754",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.14 155.395L968.516 153.057L971.288 144.432",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.243 130.838L952.618 135.661",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.887 160.95L933.658 160.219",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.577 171.621L953.348 166.651",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.516 153.057L970.267 155.249",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.692 351.275L868.608 354.198L864.524 367.939L874.879 378.464L888.735 374.809L892.382 360.922L884.797 353.029",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.943 350.105C885.381 351.567 884.506 353.029 883.047 353.321C881.589 353.76 880.13 352.883 879.838 351.421C879.401 349.959 880.276 348.497 881.734 348.205C883.047 347.766 884.506 348.643 884.943 350.105Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.42 349.667C866.712 350.836 865.982 351.859 864.961 352.152C863.795 352.444 862.774 351.713 862.482 350.69C862.19 349.667 862.92 348.497 863.941 348.205C864.961 347.912 866.128 348.643 866.42 349.667Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.734 388.258C875.171 389.866 874.15 391.474 872.546 391.912C870.941 392.351 869.337 391.328 868.9 389.72C868.462 388.112 869.483 386.504 871.087 386.065C872.692 385.627 874.296 386.65 874.734 388.258Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.945 390.158C899.237 391.328 898.507 392.643 897.341 392.935C896.174 393.228 894.861 392.497 894.569 391.328C894.278 390.158 895.007 388.842 896.174 388.55C897.486 388.258 898.653 388.989 898.945 390.158Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.342 346.451C911.78 348.059 910.759 349.52 909.3 349.959C907.696 350.398 906.238 349.374 905.8 347.912C905.362 346.305 906.383 344.843 907.842 344.404C909.446 343.966 911.051 344.843 911.342 346.451Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.572 380.949C916.01 382.703 914.989 384.603 913.238 385.042C911.488 385.48 909.592 384.457 909.155 382.703C908.717 380.949 909.738 379.048 911.488 378.61C913.384 378.025 915.135 379.195 915.572 380.949Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.382 360.922L905.946 357.414L916.301 367.647L913.093 378.171",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.735 374.809L898.653 385.042L909.009 382.264",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.988 349.959L905.946 357.414",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.982 351.859L868.608 354.198",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.546 386.065L874.879 378.464",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.653 385.042L897.341 388.258",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.26 157.588C1046.26 157.588 1032.11 157.734 1030.5 157.88C1028.9 157.88 1027.15 157.15 1025.11 155.688C1023.06 154.226 1016.5 149.987 1009.5 150.133C1002.5 150.279 989.519 158.465 989.811 174.691C990.102 190.917 1003.23 193.548 1007.31 193.548C1011.4 193.548 1014.46 191.648 1017.09 193.402C1019.56 195.156 1022.34 197.787 1023.5 197.787C1024.67 197.787 1024.38 193.84 1025.69 193.694C1027 193.548 1032.69 192.379 1034.44 192.232C1036.05 192.086 1036.92 191.063 1036.92 188.286C1036.92 185.508 1037.5 180.1 1040.13 180.1C1042.75 180.1 1047.57 179.953 1047.57 179.953",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.123 200.418L995.353 194.571",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.414 193.84L989.373 189.747",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.58 183.9L984.56 181.123",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.122 172.645L983.831 172.352",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.018 161.243L985.144 163.581",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.268 151.156L989.519 155.103",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.29 144.14L995.645 149.11",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.27 182.585C1016.94 182.731 1016.79 186.093 1014.9 185.801C1013 185.508 1010.96 187.409 1009.5 186.678C1008.04 185.947 1004.69 187.701 1003.67 185.508C1002.65 183.462 999.583 185.216 999.291 182.146C998.999 179.076 996.666 179.807 996.52 176.884C996.52 173.96 994.332 172.644 996.082 170.744C997.833 168.844 995.207 165.482 998.124 164.897C1001.04 164.312 998.854 161.389 1000.75 161.243C1002.65 161.096 1004.83 157.296 1007.75 158.319C1010.67 159.342 1012.27 156.711 1013.58 158.758C1014.9 160.804 1017.81 157.734 1019.13 160.658C1020.44 163.581 1023.65 162.704 1023.36 165.774C1023.07 168.844 1026.13 170.452 1024.67 172.645C1023.21 174.837 1024.96 177.468 1023.07 178.492C1021.31 179.661 1023.36 182.146 1019.27 182.585Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.73 181.708C1013.88 178.638 1012.71 177.761 1010.38 177.468C1008.04 177.176 1007.02 176.884 1006.29 174.399C1005.56 171.767 1005.42 169.282 1003.37 167.967C1001.48 166.651 998.999 164.751 998.999 164.751",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.291 174.545C1001.19 173.96 1002.79 169.575 1004.54 169.575",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.48 178.784C1003.81 178.93 1006.58 175.714 1006.58 175.714",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.73 182C1008.63 181.561 1008.92 179.953 1010.38 178.345",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 172.645C1015.48 173.522 1010.38 170.452 1012.27 164.897C1014.17 159.342 1008.48 158.173 1008.48 158.173",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.19 176.591C1008.33 174.983 1010.38 170.89 1012.86 170.89",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.79 172.791C1016.06 174.691 1016.94 177.761 1018.54 179.661",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.79 160.658C1003.23 163.143 1005.13 165.628 1009.06 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.07 166.651C1020.44 168.405 1017.52 169.282 1016.79 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.578 372.909C797.578 372.909 795.536 359.022 795.244 357.414C794.953 355.952 795.536 354.052 796.703 351.859C797.87 349.667 801.078 342.65 800.057 335.78C799.036 328.909 789.264 317.215 773.366 319.554C757.469 321.893 756.594 335.195 757.177 339.142C757.76 343.235 759.948 346.012 758.635 348.643C757.323 351.275 754.989 354.344 755.135 355.514C755.281 356.683 759.073 355.806 759.511 357.122C759.802 358.291 761.698 363.846 762.136 365.454C762.573 367.062 763.594 367.647 766.366 367.354C769.137 367.062 774.387 366.77 774.825 369.401C775.263 372.032 775.846 376.71 775.846 376.71",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.572 324.232L754.843 327.594",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.114 316.776L758.781 321.162",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.011 309.906L766.511 315.315",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.95 306.836L774.971 313.561",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.326 307.275L783.722 313.707",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.828 311.222L792.765 316.776",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.85 318.092L799.328 322.039",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.72 349.667C769.283 347.328 765.928 347.766 766.074 345.866C766.22 343.966 764.032 342.212 764.47 340.75C764.907 339.142 762.865 336.072 764.761 334.903C766.657 333.587 764.47 330.956 767.387 330.225C770.304 329.494 769.283 327.301 772.2 326.863C775.117 326.424 776.138 324.232 778.18 325.547C780.222 327.009 783.139 324.085 784.16 326.863C785.181 329.64 787.66 327.009 788.098 328.909C788.535 330.81 792.619 332.418 791.89 335.341C791.161 338.265 794.078 339.58 792.181 341.042C790.285 342.504 793.64 344.989 791.015 346.743C788.389 348.497 789.556 351.421 786.493 351.567C783.43 351.713 782.264 354.929 779.93 353.76C777.596 352.59 775.263 354.783 773.95 353.029C772.783 351.128 770.595 353.467 769.72 349.667Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.72 344.112C772.637 343.966 773.367 342.504 773.367 340.311C773.367 337.972 773.512 336.949 775.846 335.78C778.325 334.756 780.805 334.172 781.68 332.125C782.701 330.079 784.305 327.448 784.305 327.448",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.971 328.909C775.7 330.663 780.367 331.687 780.513 333.441",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.033 331.687C771.179 334.026 774.679 336.218 774.679 336.218",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.699 337.242C769.283 338.996 771.033 339.142 772.783 340.311",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.347 348.936C777.888 344.55 780.367 339.142 785.91 340.311C791.452 341.481 792.036 335.78 792.036 335.78",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.096 337.972C775.7 337.972 779.93 339.288 780.222 341.919",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.909 345.866C777.013 345.427 774.096 346.597 772.346 348.497",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.973 330.517C786.639 331.394 784.451 333.441 784.305 337.388",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.764 351.275C783.722 348.936 782.555 346.158 785.472 344.989",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.4 386.942C1025.4 386.942 1013.58 380.364 1012.27 379.633C1010.96 378.902 1009.21 378.756 1006.88 379.049C1004.54 379.487 997.103 379.926 991.415 376.71C985.581 373.494 978.434 360.776 985.873 347.328C993.311 333.879 1005.42 337.534 1008.92 339.434C1012.27 341.335 1014.17 344.258 1016.94 343.966C1019.86 343.673 1023.36 342.65 1024.38 343.235C1025.4 343.82 1023.36 346.889 1024.38 347.62C1025.4 348.351 1029.63 351.859 1030.94 352.737C1032.25 353.614 1032.4 354.929 1031.23 357.122C1030.07 359.461 1028.02 364.138 1030.21 365.454C1032.4 366.623 1036.48 368.962 1036.48 368.962",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.416 326.278L999.291 333.149",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.811 328.909L992.144 334.61",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.622 334.61L984.268 339.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.35 343.381L979.893 346.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.85 353.76L976.976 354.491",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.704 364.577L976.83 363.7",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.35 374.079L979.309 371.447",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.02 354.052C1012.13 352.883 1013.58 349.959 1011.83 349.374C1010.08 348.79 1009.21 346.305 1007.75 346.158C1006.15 346.158 1004.1 343.235 1002.35 344.404C1000.6 345.72 998.854 342.796 997.249 345.281C995.645 347.62 993.895 346.012 992.582 348.497C991.269 350.982 988.79 351.128 989.519 353.467C990.102 355.806 986.456 357.414 988.644 359.314C990.832 361.069 987.623 362.53 989.227 363.554C990.686 364.577 990.978 368.816 993.749 369.108C996.666 369.547 996.812 372.471 998.854 371.301C1000.75 370.132 1001.92 373.932 1004.4 372.178C1006.88 370.278 1009.06 372.471 1010.23 369.693C1011.4 366.916 1014.61 367.062 1014.46 364.577C1014.31 362.092 1016.94 360.63 1015.77 358.876C1014.31 357.268 1017.23 356.099 1014.02 354.052Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.92 352.152C1007.75 354.783 1006.29 354.929 1004.25 354.198C1002.21 353.321 1001.19 353.175 999.437 354.929C997.687 356.683 996.374 358.876 994.186 359.022C991.999 359.168 989.082 359.753 989.082 359.753",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.603 351.713C994.916 353.029 994.332 357.56 995.791 358.291",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.395 349.082C999.437 349.959 1000.31 353.906 1000.31 353.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.23 348.936C1004.69 350.105 1004.1 351.713 1004.69 353.613",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.08 362.53C1006.73 359.753 1001.04 360.045 1000.17 365.6C999.291 371.009 994.04 369.547 994.04 369.547",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.06 354.052C1001.48 355.514 1001.33 359.753 1003.52 360.922",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.46 361.069C1007.75 359.168 1009.79 356.976 1011.98 356.099",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.394 364.869C991.999 362.969 994.624 361.8 998.124 362.969",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.08 368.962C1008.77 366.331 1006.58 364.285 1004.54 366.623",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.98 130.838C1004.98 130.838 1006.15 120.751 1006.44 119.143C1006.58 118.412 1007.46 117.681 1008.92 117.828C1010.81 118.12 1010.81 120.02 1010.81 120.02C1010.81 120.02 1042.75 123.967 1045.09 124.26C1047.42 124.552 1049.61 126.891 1049.17 130.838C1048.73 134.784 1045.96 136.1 1043.78 135.954C1041.73 135.661 1009.35 131.715 1009.35 131.715C1009.35 131.715 1008.92 133.615 1006.73 133.323C1005.27 133.176 1004.83 131.715 1004.98 130.838Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.52 127.183L1010.08 131.422",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.71 129.376L1012.42 131.715",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.92 127.914L1015.33 132.153",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.11 130.107L1017.81 132.446",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.17 128.499L1020.73 132.738",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.36 130.691L1023.07 133.03",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.76 121.336C1049.76 121.336 1052.82 96.9241 1053.11 94.4391C1053.4 91.954 1050.19 87.7149 1045.82 89.1767C1041.3 90.6384 1017.96 98.6783 1017.96 98.6783L1004.69 97.0703C1004.69 97.0703 1004.4 95.17 1002.35 94.8776C1001.04 94.7314 1000.17 95.7547 1000.02 96.4856C999.875 97.2165 998.708 107.449 998.562 108.618C998.416 109.349 999.145 110.226 1000.46 110.373C1002.35 110.665 1002.94 108.765 1002.94 108.765C1002.94 108.765 1014.17 110.08 1014.75 110.226C1015.33 110.226 1028.9 119.143 1028.9 119.143",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.54 97.0703L1004.1 101.309",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.31 97.3627L1007.02 99.7015",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.52 97.8011L1009.94 102.04",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.15 98.0935L1012.86 100.432",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.55 94.0005C1034.3 94.5852 1040.86 106.279 1040.13 118.12",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.189 234.478C848.189 234.478 852.564 228.485 853.293 227.461C853.585 227.023 854.46 226.877 855.335 227.608C856.502 228.485 855.773 229.8 855.773 229.8C855.773 229.8 875.025 243.98 876.484 245.003C877.942 246.026 878.526 248.365 876.776 250.704C875.025 253.043 872.692 253.043 871.525 252.019C870.212 251.142 850.814 236.817 850.814 236.817C850.814 236.817 849.939 237.986 848.626 236.963C847.605 236.086 847.751 235.063 848.189 234.478Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.148 234.186L851.252 236.817",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.731 236.378L852.71 237.84",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.356 236.525L854.46 239.156",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.94 238.717L855.919 240.179",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.565 238.863L857.669 241.495",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.148 241.202L859.128 242.518",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.568 244.564C880.568 244.564 891.361 229.8 892.382 228.339C893.403 226.877 892.965 222.93 889.611 222.199C886.256 221.468 868.025 218.252 868.025 218.252L860.003 212.405C860.003 212.405 860.44 211.089 859.273 210.212C858.398 209.628 857.523 209.92 857.231 210.359C856.94 210.797 852.418 216.937 851.835 217.667C851.543 218.106 851.689 218.837 852.418 219.422C853.585 220.299 854.606 219.275 854.606 219.275C854.606 219.275 861.315 224.246 861.753 224.538C862.045 224.83 867.733 235.501 867.733 235.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.149 212.551L858.252 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.753 213.721L860.732 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.649 215.182L861.753 217.667",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.253 216.352L864.232 217.668",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.401 220.591C880.276 221.614 880.422 231.554 875.609 239.01",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.06 95.3161L975.663 127.622L982.81 128.937L988.352 96.3393L985.581 88.738L981.06 95.3161Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.352 96.3393C988.352 96.3393 985.143 97.9473 980.914 95.1699",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.538 122.651L983.539 123.967",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.768 306.836L795.099 279.793L789.119 283.886L807.642 311.222L815.08 314.73L813.768 306.836Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.642 311.222C807.642 311.222 808.809 307.86 813.768 306.836",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.016 284.033L792.182 287.833",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.32 345.281L1046.84 294.996L1035.61 295.434L1037.94 346.012L1044.65 356.537L1049.32 345.281Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.94 346.012C1037.94 346.012 1042.17 342.504 1049.32 345.281",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.13 302.89L1036.34 303.036",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.63 46.6387L1038.38 23.1039L1033.27 17.9877L1010.23 41.5224L1008.19 49.416L1015.63 46.6387Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.23 41.5223C1010.23 41.5223 1013.73 41.9609 1015.63 46.6386",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.88 26.7583L1029.92 21.6421",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1207.64 97.5486C1215.26 90.1124 1215.42 77.8961 1208 70.2628C1200.58 62.6294 1188.39 62.4696 1180.77 69.9058C1173.15 77.342 1173 89.5583 1180.41 97.1916C1187.83 104.825 1200.02 104.985 1207.64 97.5486Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.87 83.6218L1167.37 83.3295C1167.23 90.1999 1169.85 97.0703 1174.96 102.333C1185.31 112.858 1202.23 113.15 1212.73 102.771C1217.98 97.655 1220.75 90.7846 1220.75 83.9142H1217.4",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.79 70.0272C1183.56 76.1667 1198.88 83.768 1207.92 70.3196",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.73 92.9773C1183.56 86.3993 1200.33 83.0371 1211.27 92.8311",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.11 107.01L1212.88 102.771",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.15 123.967L1233.88 102.625C1233.88 102.625 1230.38 99.4092 1226.59 103.064C1224.84 101.309 1222.8 101.748 1220.9 103.648C1218.86 105.549 1214.77 109.642 1213.46 110.811C1212.15 112.127 1211.13 114.758 1212.88 116.658C1211.42 118.412 1209.38 121.044 1212.15 123.967Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.53 189.539C1143.25 185.635 1143.92 178.634 1140.03 173.9C1136.13 169.166 1129.14 168.493 1124.42 172.397C1119.7 176.3 1119.03 183.302 1122.92 188.036C1126.82 192.769 1133.8 193.442 1138.53 189.539Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.07 180.977L1116.03 180.831C1116.03 184.777 1117.49 188.724 1120.41 191.794C1126.39 197.933 1136.16 198.08 1142.28 192.086C1145.35 189.163 1146.95 185.216 1146.95 181.269H1145.06",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.76 173.083C1125.37 176.591 1134.26 180.977 1139.51 173.229",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.01 186.239C1125.37 182.439 1135.14 180.538 1141.41 186.093",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.76 194.425L1142.28 191.94",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.85 204.219L1154.39 191.94C1154.39 191.94 1152.35 190.04 1150.16 192.233C1149.14 191.209 1147.97 191.502 1146.81 192.671C1145.64 193.84 1143.31 196.033 1142.58 196.91C1141.85 197.641 1141.26 199.249 1142.28 200.272C1141.41 201.003 1140.24 202.611 1141.85 204.219Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.65 320.577L1055.07 353.467L1062.36 353.76L1063.09 320.723L1059.3 313.561L1055.65 320.577Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.09 320.723C1063.09 320.723 1060.17 322.77 1055.65 320.723",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.21 348.351L1062.21 348.643",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.59 364.285L1096.34 335.195L1067.75 305.813L1066.59 364.285ZM1085.99 334.756L1074.76 345.72L1075.19 323.647L1085.99 334.756Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.69 314.438L1072.71 313.561",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.15 317.946L1075.05 316.046",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.36 319.262L1077.38 318.385",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.82 322.77L1079.71 320.87",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.03 324.085L1081.9 323.208",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.49 327.594L1084.38 325.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.69 328.763L1086.57 327.886",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.15 332.418L1089.05 330.371",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.36 333.587L1091.24 332.71",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.12 195.595L1161.25 210.212L1176.41 181.561L1205.44 166.944L1190.12 195.595Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.19 177.615L1214.92 192.671C1214.92 192.671 1215.5 200.126 1205 210.359C1194.5 220.591 1186.92 220.006 1186.92 220.006L1172.18 204.95",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.75 209.043L1183.12 227.9",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.21 228.046C1188.37 229.216 1188.37 231.262 1187.21 232.432C1186.04 233.601 1184 233.601 1182.83 232.432C1181.66 231.262 1181.66 229.216 1182.83 228.046C1184.14 226.731 1186.04 226.731 1187.21 228.046Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.37 235.209C1188.37 235.209 1189.1 239.156 1191.44 241.495C1192.6 240.325 1196.69 236.378 1196.69 236.378C1196.69 236.378 1193.04 233.455 1190.42 233.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.57 134.346L1066.3 163.874L1060.17 132.007L1073.3 102.479L1079.57 134.346Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.92 114.027L1096.78 116.366C1096.78 116.366 1102.03 121.774 1100.43 136.392C1098.82 151.01 1092.4 155.249 1092.4 155.249L1071.55 152.91",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.34 160.804L1094.45 163.728",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.8 161.243C1099.55 161.389 1100.72 162.997 1100.43 164.605C1100.28 166.359 1098.68 167.528 1097.07 167.236C1095.32 167.09 1094.15 165.482 1094.45 163.874C1094.59 162.266 1096.05 160.95 1097.8 161.243Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.2 166.067C1103.2 166.067 1106.26 168.698 1109.47 168.99C1109.61 167.382 1110.34 161.681 1110.34 161.681C1110.34 161.681 1105.68 161.681 1103.49 163.143",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.76 109.499L1123.43 135.204L1158.34 171.119L1184.67 145.414L1149.76 109.499Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.83 111.103L1155.85 109.934L1190.85 145.894L1164.45 171.767L1163.29 170.452",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.41 126.375L1129.22 135.351L1137.97 144.356L1147.16 135.38L1138.41 126.375Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.7 123.529L1149.14 116.22",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.91 126.744L1152.35 119.582",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.18 149.987L1163.43 131.276",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.83 153.787L1166.93 135.077",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.47 157.442L1170.58 138.731",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.97 15.6046L1125.21 15.401L1124.94 65.5402L1161.69 65.7438L1161.97 15.6046Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.45 20.1803H1166.06L1165.77 70.3195L1128.87 70.1733V68.4192",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.17 19.6319L1129.34 19.5608L1129.27 32.1321L1142.11 32.2032L1142.17 19.6319Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.51 19.8879H1156.87",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.37 24.4194L1156.87 24.5656",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.74 40.4991L1156.43 40.6453",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.74 45.7616L1156.43 45.9078",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.6 50.8778L1156.43 51.024",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.25 116.684L1208.36 143.919L1245.1 181.718L1272.99 154.483L1236.25 116.684Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.67 123.676L1215.61 143.26L1219.99 147.763L1240.05 128.178L1235.67 123.676Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.62 134.959L1226.36 154.747L1245.29 174.223L1265.55 154.434L1246.62 134.959Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8 145.163L1255.32 164.166",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.51 154.811L1250.36 168.99",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.9 140.047L1260.42 159.196",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.4 159.635L1251.24 140.193",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.21 164.459L1256.05 145.163",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.03 169.429L1260.72 150.133",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.15 184.064L1058.28 186.486L1061.55 239.156L1100.42 236.734L1097.15 184.064Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.18 189.031L1064.23 190.773L1064.62 197.047L1092.57 195.305L1092.18 189.031Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.14 204.692L1064.89 206.452L1066.58 233.59L1094.82 231.83L1093.14 204.692Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.99 205.973L1080.74 232.578",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.57 212.99L1073.73 232.87",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.28 205.535L1087.88 231.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.57 213.428L1093.13 211.674",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 220.299L1093.57 218.545",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.44 227.169L1094.01 225.415",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.63 81.8677L1259.84 90.1999L1261.74 106.864L1277.78 113.588L1291.05 103.356L1288.72 86.5454L1276.91 81.4292",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.74 78.2133C1276.76 79.5289 1276.47 81.5754 1275.16 82.5987C1273.84 83.6219 1271.8 83.3296 1270.78 82.014C1269.76 80.6984 1270.05 78.6519 1271.36 77.6286C1272.68 76.6054 1274.57 76.7515 1275.74 78.2133Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.32 86.3992C1256.2 87.4225 1255.9 89.0304 1254.88 89.9075C1253.86 90.7846 1252.26 90.4922 1251.38 89.469C1250.51 88.4457 1250.8 86.8378 1251.82 85.9607C1252.99 85.0836 1254.59 85.2298 1255.32 86.3992Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.01 124.26C1283.18 125.868 1282.89 128.06 1281.28 129.23C1279.68 130.399 1277.49 130.107 1276.32 128.499C1275.16 126.891 1275.45 124.698 1277.05 123.529C1278.66 122.359 1280.84 122.652 1282.01 124.26Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.29 115.343C1310.16 116.512 1310.01 118.12 1308.85 119.143C1307.68 120.02 1306.08 119.874 1305.06 118.705C1304.18 117.535 1304.33 115.927 1305.49 114.904C1306.66 113.881 1308.41 114.173 1309.29 115.343Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.72 62.1337C1303.89 63.5955 1303.6 65.7882 1302.14 66.8114C1300.68 67.9808 1298.49 67.6885 1297.47 66.2267C1296.3 64.7649 1296.6 62.5722 1298.05 61.549C1299.51 60.3796 1301.56 60.6719 1302.72 62.1337Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.14 97.6551C1324.45 99.4092 1324.16 101.894 1322.41 103.21C1320.66 104.525 1318.18 104.233 1316.87 102.479C1315.56 100.725 1315.85 98.2398 1317.6 96.9242C1319.35 95.6086 1321.83 95.9009 1323.14 97.6551Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.72 86.5455L1301.85 76.6053L1317.74 82.891L1319.06 95.7547",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.05 103.356L1306.51 109.934L1316.58 102.187",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.53 67.5422L1301.85 76.6053",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.9 88.738L1259.84 90.1998",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.51 122.944L1277.78 113.588",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.51 109.934L1306.66 114.027",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.62 34.0674L1177.87 42.2534L1185.46 49.2699L1195.52 46.2002L1197.85 35.9677L1190.12 29.0973L1182.54 31.29",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.64 30.2666C1181.66 30.559 1182.39 31.5822 1182.1 32.6055C1181.81 33.6287 1180.79 34.3596 1179.77 34.0673C1178.75 33.7749 1178.02 32.7516 1178.31 31.7284C1178.6 30.7051 1179.62 30.1204 1180.64 30.2666Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.23 42.2533C1175.1 42.3995 1175.54 43.2765 1175.39 44.0074C1175.25 44.8845 1174.37 45.323 1173.64 45.1769C1172.77 45.0307 1172.33 44.1536 1172.48 43.4227C1172.62 42.5457 1173.5 41.9609 1174.23 42.2533Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.79 49.4161C1202.96 49.7085 1203.69 50.8779 1203.4 52.0473C1203.11 53.2168 1201.94 53.9477 1200.77 53.6553C1199.6 53.363 1198.88 52.1935 1199.17 51.0241C1199.46 50.0008 1200.63 49.1238 1201.79 49.4161Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.13 34.5059C1212 34.652 1212.59 35.5291 1212.29 36.4062C1212.15 37.2833 1211.27 37.868 1210.4 37.5756C1209.52 37.4294 1208.94 36.5524 1209.23 35.6753C1209.23 34.7982 1210.11 34.2135 1211.13 34.5059Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.06 11.9944C1188.23 12.2868 1188.81 13.31 1188.67 14.4794C1188.37 15.6489 1187.35 16.2336 1186.19 16.0874C1185.02 15.795 1184.44 14.7718 1184.58 13.6024C1184.73 12.4329 1185.89 11.702 1187.06 11.9944Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.54 20.619C1211.86 20.9113 1212.73 22.2269 1212.44 23.5425C1212.15 24.8581 1210.84 25.7352 1209.52 25.4428C1208.21 25.1505 1207.33 23.8349 1207.63 22.5193C1208.06 21.2037 1209.23 20.3266 1210.54 20.619Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.12 29.0973L1192.31 19.1571L1202.23 15.795L1208.06 21.3498",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.85 35.9678L1207.63 33.0442L1209.38 25.2968",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.08 15.3566L1192.31 19.1572",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.54 43.1304L1177.87 42.2533",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.6 50.1469L1195.52 46.2001",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.63 33.0442L1209.38 34.7983",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.31 219.714L1124.05 215.036L1111.36 225.123L1114.14 241.787L1129.16 247.488L1141.7 236.963L1139.95 224.684",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.85 221.907C1141.26 223.515 1139.51 224.246 1137.91 223.661C1136.31 223.076 1135.58 221.322 1136.16 219.714C1136.74 218.106 1138.49 217.375 1140.1 217.96C1141.7 218.691 1142.43 220.445 1141.85 221.907Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.93 209.482C1124.49 210.651 1123.03 211.382 1121.87 210.797C1120.7 210.359 1119.97 208.897 1120.55 207.727C1120.99 206.558 1122.45 205.827 1123.62 206.412C1124.78 206.85 1125.37 208.312 1124.93 209.482Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.57 250.704C1106.84 252.458 1104.95 253.335 1103.2 252.75C1101.45 252.019 1100.57 250.119 1101.15 248.365C1101.88 246.611 1103.78 245.734 1105.53 246.318C1107.28 246.903 1108.16 248.95 1107.57 250.704Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.72 268.391C1128.28 269.707 1126.68 270.438 1125.37 269.853C1124.05 269.415 1123.32 267.807 1123.91 266.491C1124.35 265.176 1125.95 264.445 1127.26 265.029C1128.57 265.614 1129.3 267.076 1128.72 268.391Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.83 235.94C1168.25 237.694 1166.35 238.425 1164.6 237.84C1162.85 237.255 1162.12 235.355 1162.7 233.601C1163.29 231.847 1165.18 231.116 1166.93 231.701C1168.68 232.432 1169.41 234.332 1168.83 235.94Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.07 273.189C1149.15 272.959 1150.65 271.082 1150.42 268.995C1150.19 266.909 1148.32 265.404 1146.24 265.633C1144.16 265.862 1142.66 267.74 1142.88 269.826C1143.11 271.913 1144.99 273.418 1147.07 273.189Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.7 236.963L1156.58 242.664L1159.5 258.89L1149.72 266.637",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.16 247.488L1131.78 263.421L1143.16 267.807",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.29 236.963L1156.58 242.664",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.18 211.236L1124.05 215.036",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.84 247.196L1114.14 241.787",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.78 263.421L1128.43 265.614",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.87 22.6654C1295.87 22.6654 1280.84 22.9578 1279.24 22.9578C1277.64 22.9578 1275.74 22.2269 1273.55 20.6189C1271.36 19.0109 1264.51 14.6256 1257.07 14.7718C1249.78 14.9179 1235.92 23.6886 1236.21 40.7915C1236.51 58.0406 1250.36 60.818 1254.74 60.6718C1259.11 60.6718 1262.32 58.7715 1264.95 60.5256C1267.57 62.2798 1270.49 65.2033 1271.8 65.2033C1273.11 65.2033 1272.68 60.9642 1273.99 60.818C1275.3 60.6718 1281.43 59.5024 1283.18 59.21C1284.93 58.9177 1285.8 57.8944 1285.8 54.9708C1285.8 52.0473 1286.39 46.3463 1289.16 46.3463C1291.93 46.3463 1297.03 46.2001 1297.03 46.2001",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.53 67.9808L1241.9 61.8413",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.38 60.9642L1235.63 56.725",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 50.5856L1230.53 47.662",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.65 38.599L1229.94 38.3066",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.69 26.6122L1231.25 29.0972",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.38 15.9412L1235.92 20.0342",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.84 8.33997L1242.34 13.6024",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.28 48.9775C1264.8 49.1236 1264.65 52.6319 1262.61 52.3396C1260.57 52.0472 1258.53 54.0937 1256.92 53.3628C1255.32 52.6319 1251.82 54.3861 1250.65 52.1934C1249.49 50.0007 1246.42 51.901 1245.99 48.6851C1245.69 45.4692 1243.07 46.2001 1243.07 43.1303C1243.07 40.0606 1240.73 38.5988 1242.63 36.6985C1244.38 34.7981 1241.76 31.1437 1244.82 30.559C1247.88 29.9742 1245.55 26.9045 1247.59 26.6121C1249.63 26.3198 1251.97 22.373 1255.03 23.5424C1258.09 24.7118 1259.84 21.7883 1261.15 23.9809C1262.47 26.1736 1265.53 22.9577 1266.99 26.0274C1268.45 29.0972 1271.8 28.2201 1271.36 31.436C1271.07 34.7981 1274.28 36.4061 1272.82 38.745C1271.36 41.0838 1273.26 43.8612 1271.22 45.0306C1269.47 46.0539 1271.51 48.6851 1267.28 48.9775Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.45 48.2466C1261.59 45.0307 1260.28 44.1536 1257.95 43.8613C1255.47 43.5689 1254.3 43.2765 1253.57 40.6453C1252.84 37.8679 1252.69 35.2367 1250.51 33.9211C1248.47 32.6055 1245.84 30.4128 1245.84 30.4128",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.13 40.6454C1248.17 40.0606 1249.92 35.3829 1251.82 35.3829",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.47 45.0307C1250.94 45.1769 1253.86 41.8148 1253.86 41.8148",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.15 48.3928C1256.2 47.9543 1256.49 46.2001 1257.95 44.5922",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.01 38.5989C1263.2 39.6222 1257.8 36.2601 1259.84 30.4129C1261.74 24.5658 1255.9 23.3964 1255.9 23.3964",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.61 42.6919C1255.9 40.9378 1257.95 36.6986 1260.57 36.6986",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.65 38.745C1263.93 40.6453 1264.8 44.0074 1266.55 46.0539",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.78 26.0276C1250.36 28.6588 1252.26 31.29 1256.49 32.0209",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.36 32.3132C1268.59 34.2135 1265.53 35.0906 1264.8 31.7285",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.05 47.6619C1117.05 47.6619 1106.99 38.1603 1105.97 37.1371C1104.8 36.1138 1104.07 34.3597 1103.78 32.0208C1103.49 29.682 1101.59 22.2269 1096.78 17.6953C1091.82 13.0176 1077.23 10.0941 1066.59 21.496C1055.79 32.8979 1063.09 43.7151 1066 46.3463C1068.92 49.1237 1072.28 50.0008 1072.86 52.7782C1073.44 55.7017 1073.59 59.3562 1074.46 60.2333C1075.34 60.9642 1077.67 58.0406 1078.69 58.7715C1079.71 59.5024 1084.38 62.5721 1085.69 63.5954C1087.01 64.6186 1088.17 64.4724 1090.07 62.5721C1091.97 60.6718 1095.9 57.3097 1097.8 59.0639C1099.7 60.818 1103.05 64.0339 1103.05 64.0339",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.96 40.0607L1056.82 38.8912",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.81 30.9976L1055.94 31.4361",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.44 20.1804L1058.42 22.2269",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059 11.4097L1063.82 15.795",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.05 4.68542L1070.67 10.5326",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.4 1.32336L1079.57 7.60904",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.76 1.76184L1087.74 7.60898",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.61 46.6387C1079.86 45.1769 1077.53 47.5158 1076.51 45.9078C1075.34 44.2998 1072.71 44.446 1072.13 42.8381C1071.55 41.3763 1068.05 40.2068 1068.78 38.1603C1069.5 35.9677 1066.15 35.2368 1068.05 32.8979C1069.8 30.5591 1067.75 29.3896 1069.65 27.3431C1071.55 25.2966 1070.96 22.9578 1073.44 22.8116C1075.92 22.6654 1076.36 18.5724 1078.84 20.1804C1081.32 21.7884 1081.61 18.2801 1083.21 19.3033C1084.67 20.4728 1088.76 19.3033 1090.07 21.9345C1091.38 24.5657 1094.3 23.8349 1093.72 26.1737C1093.13 28.5126 1097.36 28.3664 1096.2 31.29C1095.17 34.2135 1097.95 35.8215 1095.61 37.7218C1093.28 39.6221 1094.45 42.8381 1091.97 43.4228C1089.49 44.0075 1088.9 47.0772 1086.86 46.4925C1084.97 46.054 1084.67 49.1237 1081.61 46.6387Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.4 42.3995C1080.59 40.4992 1080.3 39.0374 1078.84 37.2832C1077.38 35.5291 1076.8 34.652 1078.11 32.3132C1079.28 29.9743 1081.03 28.074 1080.44 25.8813C1080.01 23.6886 1079.57 20.6189 1079.57 20.6189",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.15 27.6355C1074.9 28.5125 1078.99 26.6122 1080.15 27.7816",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.84 32.0209C1073.3 33.775 1077.38 33.3365 1077.38 33.3365",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.3 37.8679C1074.9 38.8912 1076.21 37.8679 1078.26 37.8679",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.76 40.3529C1084.97 37.8679 1083.65 32.3131 1088.61 29.6819C1093.57 27.1969 1090.51 22.5192 1090.51 22.5192",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.96 35.0905C1079.28 34.0673 1083.36 32.6055 1085.11 34.3596",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.42 38.3064C1084.67 39.1835 1083.21 41.8147 1083.07 44.2997",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.82 20.3265C1083.51 22.373 1083.07 25.2966 1085.4 28.5125",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.88 38.3064C1091.82 37.7217 1089.34 36.4061 1090.8 33.7749",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.61 312.976C1109.61 312.976 1098.82 306.983 1097.65 306.252C1096.49 305.521 1094.88 305.375 1092.7 305.813C1090.51 306.106 1083.8 306.69 1078.4 303.62C1073.15 300.697 1066.44 289.003 1073.3 276.577C1080.15 264.152 1091.38 267.514 1094.45 269.269C1097.65 271.023 1099.26 273.654 1101.88 273.362C1104.51 273.069 1107.72 272.192 1108.74 272.631C1109.61 273.069 1107.72 275.993 1108.74 276.724C1109.61 277.455 1113.55 280.67 1114.86 281.401C1116.03 282.278 1116.18 283.302 1115.16 285.494C1114.14 287.687 1112.24 291.926 1114.28 293.096C1116.32 294.265 1119.97 296.312 1119.97 296.312",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.67 257.282L1085.55 263.421",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.8 259.621L1078.99 264.737",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.34 264.883L1071.84 269.415",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.5 272.923L1067.61 275.847",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.44 282.425L1065.13 283.155",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.3 292.365L1064.98 291.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.65 301.135L1067.17 298.65",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.11 282.717C1097.36 281.547 1098.68 279.062 1097.07 278.478C1095.47 277.893 1094.74 275.554 1093.28 275.554C1091.82 275.554 1089.92 272.777 1088.32 273.946C1086.72 275.116 1085.11 272.484 1083.65 274.677C1082.19 276.87 1080.59 275.408 1079.42 277.601C1078.26 279.793 1076.07 279.94 1076.51 282.132C1077.09 284.325 1073.73 285.787 1075.78 287.541C1077.82 289.149 1074.9 290.464 1076.21 291.488C1077.67 292.511 1077.82 296.312 1080.44 296.604C1083.07 296.896 1083.21 299.674 1085.11 298.65C1086.86 297.481 1087.88 301.135 1090.22 299.381C1092.4 297.627 1094.59 299.674 1095.61 297.189C1096.63 294.704 1099.7 294.85 1099.55 292.511C1099.4 290.172 1101.74 288.856 1100.72 287.395C1099.4 285.64 1102.03 284.617 1099.11 282.717Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.45 280.963C1093.42 283.302 1091.97 283.594 1090.22 282.863C1088.32 282.132 1087.44 281.84 1085.69 283.594C1084.09 285.202 1082.92 287.248 1080.88 287.395C1078.84 287.541 1076.21 288.126 1076.21 288.126",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.3 280.524C1081.61 281.694 1081.03 285.933 1082.34 286.518",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.8 278.185C1085.69 279.062 1086.42 282.571 1086.42 282.571",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.19 278.039C1090.51 279.062 1090.07 280.524 1090.51 282.278",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.61 290.464C1092.55 287.833 1087.3 288.272 1086.42 293.242C1085.55 298.212 1080.88 296.896 1080.88 296.896",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.03 282.717C1087.44 284.033 1087.3 287.979 1089.34 289.003",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.13 289.149C1093.42 287.395 1095.32 285.348 1097.36 284.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.38 292.657C1078.84 290.903 1081.17 289.88 1084.53 290.903",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.47 296.458C1094.15 293.973 1092.26 292.218 1090.51 294.265",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.45 53.3629C1317.45 53.3629 1322.27 42.6919 1323 40.9377C1323.43 40.0607 1324.6 39.6221 1326.2 40.4992C1328.1 41.3763 1327.66 43.5689 1327.66 43.5689C1327.66 43.5689 1361.35 58.7715 1363.83 59.9409C1366.31 61.1104 1367.92 64.3263 1366.02 68.5655C1364.13 72.6585 1360.63 73.3894 1358.44 72.3661C1356.25 71.3429 1321.97 55.8479 1321.97 55.8479C1321.97 55.8479 1320.95 57.8944 1318.62 56.725C1317.02 55.9941 1317.02 54.24 1317.45 53.3629Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.89 51.3163L1322.85 55.7016",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.5 54.3861L1325.33 56.8711",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.43 53.8014L1328.39 58.3329",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.18 57.0173L1331.02 59.5024",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.12 56.2864L1334.08 60.8179",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.73 59.5023L1336.56 61.9874",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.96 58.1868C1369.96 58.1868 1381.63 32.3132 1382.79 29.682C1383.96 27.0508 1381.92 21.3498 1376.52 21.3498C1371.13 21.3498 1342.54 22.2269 1342.54 22.2269L1328.54 15.9412C1328.54 15.9412 1328.83 13.7485 1326.64 12.7253C1325.18 11.9944 1323.87 12.8714 1323.58 13.6023C1323.29 14.3332 1318.33 25.1504 1317.89 26.3199C1317.45 27.1969 1318.04 28.2202 1319.35 28.8049C1321.39 29.682 1322.7 27.7816 1322.7 27.7816C1322.7 27.7816 1334.52 33.1903 1335.1 33.3364C1335.68 33.6288 1347.64 47.9543 1347.64 47.9543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.54 16.0873L1326.5 20.4726",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.31 17.2568L1330.29 19.7419",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.66 18.8647L1332.77 23.3963",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.58 20.1803L1336.56 22.5192",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.33 22.2268C1361.94 23.5424 1365.29 38.5988 1360.48 51.4625",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.15 97.2165C1094.15 97.2165 1098.53 91.2232 1099.26 90.1999C1099.55 89.7614 1100.43 89.6152 1101.3 90.3461C1102.47 91.2232 1101.74 92.5388 1101.74 92.5388C1101.74 92.5388 1120.99 106.718 1122.45 107.741C1123.91 108.765 1124.49 111.103 1122.74 113.442C1120.99 115.781 1118.66 115.781 1117.49 114.758C1116.18 113.881 1096.78 99.5553 1096.78 99.5553C1096.78 99.5553 1095.9 100.725 1094.59 99.7015C1093.57 98.8245 1093.86 97.8012 1094.15 97.2165Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.11 96.9241L1097.22 99.5553",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.7 99.1167L1098.68 100.578",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.32 99.2629L1100.43 101.894",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.9 101.456L1101.88 102.917",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.53 101.602L1103.63 104.233",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 103.794L1105.09 105.256",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.53 107.303C1126.53 107.303 1137.33 92.5386 1138.35 91.0769C1139.37 89.6151 1138.93 85.6683 1135.58 84.9374C1132.22 84.2065 1113.99 80.9905 1113.99 80.9905L1105.97 75.1434C1105.97 75.1434 1106.41 73.8278 1105.24 72.9507C1104.36 72.366 1103.49 72.6584 1103.2 73.0969C1102.9 73.5354 1098.38 79.6749 1097.8 80.4058C1097.51 80.8444 1097.65 81.5753 1098.38 82.16C1099.55 83.037 1100.57 82.0138 1100.57 82.0138C1100.57 82.0138 1107.28 86.9839 1107.72 87.2762C1108.01 87.5686 1113.7 98.2396 1113.7 98.2396",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.11 75.2897L1104.22 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.72 76.4591L1106.7 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.61 77.9208L1107.86 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.36 79.0902L1110.34 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.37 83.3295C1126.24 84.3527 1126.39 94.2929 1121.57 101.748",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.67 69.8811L1080.3 98.0936L1086.57 94.5853L1070.09 65.9343L1062.94 61.8413L1063.67 69.8811Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.09 65.9343C1070.09 65.9343 1068.78 69.2964 1063.67 69.735",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.67 93.7082L1083.94 90.3461",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.37 207.581C1348.81 215.182 1348.67 227.315 1341.08 234.77C1333.5 242.225 1321.39 242.079 1313.95 234.478C1306.51 226.877 1306.66 214.744 1314.24 207.289C1321.83 199.834 1333.93 199.98 1341.37 207.581Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.33 220.883L1300.83 220.591C1300.68 227.461 1303.31 234.332 1308.41 239.594C1318.77 250.119 1335.68 250.411 1346.19 240.033C1351.44 234.916 1354.21 228.046 1354.21 221.176H1350.85",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.24 207.289C1317.02 213.428 1332.33 221.03 1341.37 207.581",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.18 230.239C1317.02 223.661 1333.79 220.299 1344.73 230.093",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.42 244.272L1346.33 240.033",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.6 261.229L1367.33 239.887C1367.33 239.887 1363.83 236.671 1360.04 240.325C1358.29 238.571 1356.25 239.01 1354.35 240.91C1352.31 242.81 1348.23 246.903 1346.92 248.073C1345.6 249.388 1344.58 252.019 1346.33 253.92C1344.73 255.674 1342.69 258.305 1345.6 261.229Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.55 325.138C1277.37 320.351 1276.61 313.36 1271.83 309.522C1267.05 305.684 1260.08 306.453 1256.25 311.24C1252.42 316.027 1253.19 323.019 1257.96 326.857C1262.74 330.695 1269.72 329.926 1273.55 325.138Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.38 318.238L1249.34 318.092C1249.34 322.039 1250.8 325.986 1253.72 329.055C1259.7 335.195 1269.47 335.341 1275.59 329.348C1278.66 326.424 1280.26 322.477 1280.26 318.531H1278.36",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.07 310.345C1258.67 313.853 1267.57 318.238 1272.82 310.491",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.32 323.501C1258.67 319.7 1268.45 317.8 1274.72 323.354",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.07 331.687L1275.74 329.348",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.3 341.481L1287.85 329.202C1287.85 329.202 1285.8 327.301 1283.62 329.494C1282.59 328.471 1281.43 328.763 1280.26 329.933C1279.09 331.102 1276.76 333.295 1276.03 334.172C1275.3 335.049 1274.72 336.511 1275.74 337.534C1274.86 338.265 1273.7 339.873 1275.3 341.481Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.84 75.7281H1428.45V25.7351L1377.84 75.7281ZM1419.84 66.6651H1400.73L1419.84 47.8081V66.6651Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 36.8447H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 41.0839H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 44.8845H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 49.1238H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 53.0706H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 57.3097H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 61.2565H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.76 65.4957H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.51 69.2963H1426.11",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.53 383.434H1121.14V333.441L1070.53 383.434ZM1112.53 374.225H1093.42L1112.53 355.368V374.225Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 344.404H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 348.643H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 352.444H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 356.829H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 360.63H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 364.869H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 368.816H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.59 373.055H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.34 376.856H1118.8",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.58 332.856L1294.55 347.474L1309.87 318.823L1338.89 304.205L1323.58 332.856Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.64 314.876L1348.37 329.933C1348.37 329.933 1348.96 337.388 1338.46 347.62C1327.95 357.853 1320.37 357.268 1320.37 357.268L1305.64 342.212",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.2 346.305L1316.43 365.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.66 365.308C1321.83 366.477 1321.83 368.524 1320.66 369.693C1319.49 370.863 1317.45 370.863 1316.29 369.693C1315.12 368.524 1315.12 366.477 1316.29 365.308C1317.6 363.992 1319.49 363.992 1320.66 365.308Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.83 372.47C1321.83 372.47 1322.56 376.417 1324.89 378.756C1326.06 377.587 1330.14 373.64 1330.14 373.64C1330.14 373.64 1326.5 370.716 1323.87 370.424",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.02 271.607L1199.75 301.135L1193.48 269.415L1206.75 239.74L1213.02 271.607Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.38 251.289L1230.23 253.627C1230.23 253.627 1235.48 259.036 1233.88 273.654C1232.28 288.272 1225.86 292.511 1225.86 292.511L1205 290.172",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.79 298.066L1227.9 300.989",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.11 298.504C1232.86 298.65 1234.03 300.258 1233.73 301.866C1233.59 303.62 1231.98 304.79 1230.38 304.498C1228.63 304.351 1227.46 302.743 1227.75 301.135C1227.9 299.527 1229.5 298.212 1231.11 298.504Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.65 303.328C1236.65 303.328 1239.71 305.959 1242.92 306.252C1243.07 304.644 1243.8 298.943 1243.8 298.943C1243.8 298.943 1239.13 298.943 1236.94 300.405",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.2 246.724L1256.87 272.429L1291.78 308.344L1318.11 282.639L1283.2 246.724Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.14 248.365L1289.3 247.196L1324.16 283.155L1297.91 309.029L1296.74 307.713",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.85 263.6L1262.66 272.577L1271.41 281.581L1280.6 272.605L1271.85 263.6Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.16 260.79L1282.59 253.481",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.36 264.152L1285.8 256.843",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.64 287.249L1296.74 268.538",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.28 291.049L1300.39 272.338",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.93 294.704L1304.03 275.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.87 181.692L1288.72 162.588L1262.79 195.521L1286.95 214.626L1312.87 181.692Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.2 186.093L1313.22 186.824L1287.26 219.86L1263.05 200.711L1263.93 199.541",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.64 174.152L1289.28 167.542L1282.78 175.804L1291.14 182.414L1297.64 174.152Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.39 176.591L1307.24 182",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.05 179.515L1304.91 184.924",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.8 181.561L1296.3 195.448",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.03 184.924L1293.68 198.811",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.41 188.432L1290.91 202.319",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.69 253.909L1341.79 281.144L1378.53 318.943L1406.43 291.708L1369.69 253.909Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.11 261.107L1349.05 280.692L1353.43 285.194L1373.48 265.61L1369.11 261.107Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.06 272.184L1359.79 291.973L1378.72 311.448L1398.99 291.66L1380.06 272.184Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.11 282.425L1388.63 301.428",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.81 292.072L1383.67 306.252",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.36 277.308L1393.88 296.458",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.85 296.896L1384.54 277.454",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.52 301.72L1389.36 282.425",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.34 306.69L1394.17 287.395",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.61 321.327L1191.74 323.748L1195.01 376.419L1233.88 373.997L1230.61 321.327Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.49 326.303L1197.54 328.045L1197.93 334.318L1225.88 332.577L1225.49 326.303Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.59 341.955L1198.35 343.715L1200.03 370.852L1228.28 369.093L1226.59 341.955Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.44 343.235L1214.04 369.839",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.02 350.398L1207.19 370.278",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.73 342.796L1221.34 369.401",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.02 350.69L1226.59 348.936",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.46 357.56L1227.02 355.806",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.9 364.431L1227.46 362.677",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.48 250.265L1412.11 255.089L1423.34 247.78L1422.47 233.893L1410.51 227.9L1399.42 235.501L1399.86 245.88",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.96 247.926C1398.55 246.757 1400.01 246.172 1401.32 246.757C1402.48 247.342 1403.07 248.803 1402.48 250.119C1401.9 251.288 1400.44 251.873 1399.13 251.288C1397.82 250.558 1397.38 249.096 1397.96 247.926Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.94 259.621C1411.38 258.597 1412.55 258.305 1413.57 258.744C1414.59 259.182 1414.88 260.352 1414.44 261.375C1414.01 262.398 1412.84 262.69 1411.82 262.252C1410.8 261.667 1410.36 260.498 1410.94 259.621Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.59 227.169C1429.32 225.707 1431.07 225.123 1432.38 225.853C1433.84 226.584 1434.43 228.338 1433.7 229.654C1432.97 231.116 1431.22 231.701 1429.9 230.97C1428.45 230.239 1428.01 228.485 1428.59 227.169Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.69 210.797C1413.28 209.774 1414.44 209.335 1415.61 209.774C1416.63 210.359 1417.07 211.528 1416.63 212.697C1416.05 213.721 1414.88 214.159 1413.72 213.721C1412.55 213.136 1412.11 211.82 1412.69 210.797Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.96 234.039C1377.69 232.724 1379.29 232.139 1380.61 232.87C1381.92 233.601 1382.5 235.209 1381.77 236.525C1381.04 237.84 1379.44 238.425 1378.13 237.694C1376.81 237.109 1376.38 235.501 1376.96 234.039Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.19 206.996C1395.92 205.389 1397.82 204.804 1399.42 205.535C1401.03 206.266 1401.61 208.166 1400.88 209.774C1400.15 211.382 1398.26 211.967 1396.65 211.236C1395.05 210.505 1394.46 208.604 1395.19 206.996Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.42 235.501L1387.61 229.654L1386.59 216.06L1395.34 210.505",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.51 227.9L1409.78 214.598L1400.73 210.066",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.63 233.747L1387.61 229.654",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.4 258.305L1412.11 255.089",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.88 230.093L1422.47 233.893",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.78 214.598L1412.69 212.99",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.99 151.156L1313.08 160.219L1320.95 169.136L1332.77 166.651L1336.56 155.395L1328.39 146.625L1319.5 148.379",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.6 146.917C1318.77 147.356 1319.35 148.525 1319.06 149.695C1318.62 150.864 1317.45 151.449 1316.29 151.156C1315.12 150.718 1314.54 149.548 1314.83 148.379C1315.12 147.21 1316.43 146.625 1317.6 146.917Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.99 159.781C1309.87 160.073 1310.45 161.096 1310.16 161.974C1309.87 162.851 1308.85 163.435 1307.97 163.143C1307.1 162.851 1306.51 161.827 1306.81 160.95C1307.1 160.073 1308.12 159.489 1308.99 159.781Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.62 171.037C1340.94 171.475 1341.66 172.937 1341.23 174.253C1340.79 175.568 1339.33 176.299 1338.02 175.86C1336.71 175.422 1335.98 173.96 1336.41 172.645C1336.85 171.329 1338.31 170.598 1339.62 171.037Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.73 154.957C1352.75 155.249 1353.19 156.273 1352.9 157.296C1352.6 158.319 1351.58 158.758 1350.56 158.465C1349.54 158.173 1349.1 157.15 1349.39 156.126C1349.69 155.249 1350.71 154.665 1351.73 154.957Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.79 126.891C1328.1 127.329 1328.68 128.645 1328.25 129.814C1327.81 131.13 1326.5 131.715 1325.33 131.276C1324.02 130.838 1323.43 129.522 1323.87 128.353C1324.16 127.183 1325.47 126.452 1326.79 126.891Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.75 139.316C1354.21 139.754 1354.94 141.362 1354.5 142.824C1354.06 144.286 1352.46 145.017 1351 144.578C1349.54 144.14 1348.81 142.532 1349.25 141.07C1349.69 139.608 1351.29 138.877 1352.75 139.316Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.39 146.625L1332.04 135.661L1343.71 132.884L1349.69 139.754",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.56 155.395L1347.94 153.057L1350.71 144.432",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.66 130.838L1332.04 135.661",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.31 160.95L1313.08 160.219",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337 171.621L1332.77 166.651",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.94 153.057L1349.69 155.249",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.11 351.275L1248.03 354.198L1243.94 367.939L1254.3 378.464L1268.16 374.809L1271.8 360.922L1264.22 353.029",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.36 350.105C1264.8 351.567 1263.93 353.029 1262.47 353.321C1261.01 353.76 1259.55 352.883 1259.26 351.421C1258.82 349.959 1259.7 348.497 1261.15 348.205C1262.47 347.766 1263.93 348.643 1264.36 350.105Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.84 349.667C1246.13 350.836 1245.4 351.859 1244.38 352.152C1243.21 352.444 1242.19 351.713 1241.9 350.69C1241.61 349.667 1242.34 348.497 1243.36 348.205C1244.38 347.912 1245.55 348.643 1245.84 349.667Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.15 388.258C1254.59 389.866 1253.57 391.474 1251.97 391.912C1250.36 392.351 1248.76 391.328 1248.32 389.72C1247.88 388.112 1248.9 386.504 1250.51 386.065C1252.11 385.627 1253.72 386.65 1254.15 388.258Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.36 390.158C1278.66 391.328 1277.93 392.643 1276.76 392.935C1275.59 393.228 1274.28 392.497 1273.99 391.328C1273.7 390.158 1274.43 388.842 1275.59 388.55C1276.91 388.258 1278.07 388.989 1278.36 390.158Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.76 346.451C1291.2 348.059 1290.18 349.52 1288.72 349.959C1287.12 350.398 1285.66 349.374 1285.22 347.912C1284.78 346.305 1285.8 344.843 1287.26 344.404C1288.87 343.966 1290.47 344.843 1290.76 346.451Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.99 380.949C1295.43 382.703 1294.41 384.603 1292.66 385.042C1290.91 385.48 1289.01 384.457 1288.57 382.703C1288.14 380.949 1289.16 379.048 1290.91 378.61C1292.8 378.025 1294.55 379.195 1294.99 380.949Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.8 360.922L1285.37 357.414L1295.72 367.647L1292.51 378.171",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.16 374.809L1278.07 385.042L1288.43 382.264",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.41 349.959L1285.37 357.414",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.4 351.859L1248.03 354.198",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.97 386.065L1254.3 378.464",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.07 385.042L1276.76 388.258",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.68 157.588C1425.68 157.588 1411.53 157.734 1409.92 157.88C1408.32 157.88 1406.57 157.15 1404.53 155.688C1402.48 154.226 1395.92 149.987 1388.92 150.133C1381.92 150.279 1368.94 158.465 1369.23 174.691C1369.52 190.917 1382.65 193.548 1386.73 193.548C1390.82 193.548 1393.88 191.648 1396.5 193.402C1398.98 195.156 1401.76 197.787 1402.92 197.787C1404.09 197.787 1403.8 193.84 1405.11 193.694C1406.42 193.548 1412.11 192.379 1413.86 192.232C1415.47 192.086 1416.34 191.063 1416.34 188.286C1416.34 185.508 1416.92 180.1 1419.55 180.1C1422.17 180.1 1426.99 179.953 1426.99 179.953",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.54 200.418L1374.77 194.571",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.83 193.84L1368.79 189.747",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358 183.9L1363.98 181.123",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.54 172.645L1363.25 172.352",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.44 161.243L1364.56 163.581",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.69 151.156L1368.94 155.103",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.71 144.14L1375.06 149.11",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.69 182.585C1396.36 182.731 1396.21 186.093 1394.32 185.801C1392.42 185.508 1390.38 187.409 1388.92 186.678C1387.46 185.947 1384.11 187.701 1383.09 185.508C1382.07 183.462 1379 185.216 1378.71 182.146C1378.42 179.076 1376.09 179.807 1375.94 176.884C1375.94 173.96 1373.75 172.644 1375.5 170.744C1377.25 168.844 1374.63 165.482 1377.54 164.897C1380.46 164.312 1378.27 161.389 1380.17 161.243C1382.07 161.096 1384.25 157.296 1387.17 158.319C1390.09 159.342 1391.69 156.711 1393 158.758C1394.32 160.804 1397.23 157.734 1398.55 160.658C1399.86 163.581 1403.07 162.704 1402.78 165.774C1402.48 168.844 1405.55 170.452 1404.09 172.645C1402.63 174.837 1404.38 177.468 1402.48 178.492C1400.73 179.661 1402.78 182.146 1398.69 182.585Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.15 181.708C1393.3 178.638 1392.13 177.761 1389.8 177.468C1387.46 177.176 1386.44 176.884 1385.71 174.399C1384.98 171.767 1384.84 169.282 1382.79 167.967C1380.9 166.651 1378.42 164.751 1378.42 164.751",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.71 174.545C1380.61 173.96 1382.21 169.575 1383.96 169.575",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.9 178.784C1383.23 178.93 1386 175.714 1386 175.714",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.15 182C1388.05 181.561 1388.34 179.953 1389.8 178.345",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.42 172.645C1394.9 173.522 1389.8 170.452 1391.69 164.897C1393.59 159.342 1387.9 158.173 1387.9 158.173",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.61 176.591C1387.75 174.983 1389.8 170.89 1392.28 170.89",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.21 172.791C1395.48 174.691 1396.36 177.761 1397.96 179.661",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.21 160.658C1382.65 163.143 1384.54 165.628 1388.48 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.48 166.651C1399.86 168.405 1396.94 169.282 1396.21 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 372.909C1177 372.909 1174.96 359.022 1174.66 357.414C1174.37 355.952 1174.96 354.052 1176.12 351.859C1177.29 349.667 1180.5 342.65 1179.48 335.78C1178.46 328.909 1168.68 317.215 1152.79 319.554C1136.89 321.893 1136.01 335.195 1136.6 339.142C1137.18 343.235 1139.37 346.012 1138.06 348.643C1136.74 351.275 1134.41 354.344 1134.55 355.514C1134.7 356.683 1138.49 355.806 1138.93 357.122C1139.22 358.291 1141.12 363.846 1141.56 365.454C1141.99 367.062 1143.01 367.647 1145.79 367.354C1148.56 367.062 1153.81 366.77 1154.24 369.401C1154.68 372.032 1155.27 376.71 1155.27 376.71",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.99 324.232L1134.26 327.594",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.53 316.776L1138.2 321.162",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.43 309.906L1145.93 315.315",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.37 306.836L1154.39 313.561",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.75 307.275L1163.14 313.707",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.25 311.222L1172.18 316.776",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.27 318.092L1178.75 322.039",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.14 349.667C1148.7 347.328 1145.35 347.766 1145.49 345.866C1145.64 343.966 1143.45 342.212 1143.89 340.75C1144.33 339.142 1142.28 336.072 1144.18 334.903C1146.08 333.587 1143.89 330.956 1146.81 330.225C1149.72 329.494 1148.7 327.301 1151.62 326.863C1154.54 326.424 1155.56 324.232 1157.6 325.547C1159.64 327.009 1162.56 324.085 1163.58 326.863C1164.6 329.64 1167.08 327.009 1167.52 328.909C1167.95 330.81 1172.04 332.418 1171.31 335.341C1170.58 338.265 1173.5 339.58 1171.6 341.042C1169.71 342.504 1173.06 344.989 1170.43 346.743C1167.81 348.497 1168.98 351.421 1165.91 351.567C1162.85 351.713 1161.68 354.929 1159.35 353.76C1157.02 352.59 1154.68 354.783 1153.37 353.029C1152.2 351.128 1150.02 353.467 1149.14 349.667Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.14 344.112C1152.06 343.966 1152.79 342.504 1152.79 340.311C1152.79 337.972 1152.93 336.949 1155.27 335.78C1157.75 334.756 1160.22 334.172 1161.1 332.125C1162.12 330.079 1163.73 327.448 1163.73 327.448",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.39 328.909C1155.12 330.663 1159.79 331.687 1159.93 333.441",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.45 331.687C1150.6 334.026 1154.1 336.218 1154.1 336.218",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.12 337.242C1148.7 338.996 1150.45 339.142 1152.2 340.311",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.77 348.936C1157.31 344.55 1159.79 339.142 1165.33 340.311C1170.87 341.481 1171.46 335.78 1171.46 335.78",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.52 337.972C1155.12 337.972 1159.35 339.288 1159.64 341.919",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.33 345.866C1156.43 345.427 1153.52 346.597 1151.77 348.497",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.39 330.517C1166.06 331.394 1163.87 333.441 1163.73 337.388",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.18 351.275C1163.14 348.936 1161.97 346.158 1164.89 344.989",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.82 386.942C1404.82 386.942 1393 380.364 1391.69 379.633C1390.38 378.902 1388.63 378.756 1386.3 379.049C1383.96 379.487 1376.52 379.926 1370.83 376.71C1365 373.494 1357.85 360.776 1365.29 347.328C1372.73 333.879 1384.84 337.534 1388.34 339.434C1391.69 341.335 1393.59 344.258 1396.36 343.966C1399.28 343.673 1402.78 342.65 1403.8 343.235C1404.82 343.82 1402.78 346.889 1403.8 347.62C1404.82 348.351 1409.05 351.859 1410.36 352.737C1411.67 353.614 1411.82 354.929 1410.65 357.122C1409.49 359.461 1407.44 364.138 1409.63 365.454C1411.82 366.623 1415.9 368.962 1415.9 368.962",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.84 326.278L1378.71 333.149",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.23 328.909L1371.56 334.61",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.04 334.61L1363.69 339.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.77 343.381L1359.31 346.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.27 353.76L1356.4 354.491",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.12 364.577L1356.25 363.7",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.77 374.079L1358.73 371.447",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.44 354.052C1391.55 352.883 1393 349.959 1391.25 349.374C1389.5 348.79 1388.63 346.305 1387.17 346.158C1385.57 346.158 1383.52 343.235 1381.77 344.404C1380.02 345.72 1378.27 342.796 1376.67 345.281C1375.06 347.62 1373.31 346.012 1372 348.497C1370.69 350.982 1368.21 351.128 1368.94 353.467C1369.52 355.806 1365.88 357.414 1368.06 359.314C1370.25 361.069 1367.04 362.53 1368.65 363.554C1370.11 364.577 1370.4 368.816 1373.17 369.108C1376.09 369.547 1376.23 372.471 1378.27 371.301C1380.17 370.132 1381.34 373.932 1383.82 372.178C1386.3 370.278 1388.48 372.471 1389.65 369.693C1390.82 366.916 1394.03 367.062 1393.88 364.577C1393.73 362.092 1396.36 360.63 1395.19 358.876C1393.73 357.268 1396.65 356.099 1393.44 354.052Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.34 352.152C1387.17 354.783 1385.71 354.929 1383.67 354.198C1381.63 353.321 1380.61 353.175 1378.86 354.929C1377.11 356.683 1375.79 358.876 1373.61 359.022C1371.42 359.168 1368.5 359.753 1368.5 359.753",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.02 351.713C1374.34 353.029 1373.75 357.56 1375.21 358.291",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.81 349.082C1378.86 349.959 1379.73 353.906 1379.73 353.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.65 348.936C1384.11 350.105 1383.52 351.713 1384.11 353.613",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.5 362.53C1386.15 359.753 1380.46 360.045 1379.59 365.6C1378.71 371.009 1373.46 369.547 1373.46 369.547",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.48 354.052C1380.9 355.514 1380.75 359.753 1382.94 360.922",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.88 361.069C1387.17 359.168 1389.21 356.976 1391.4 356.099",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.81 364.869C1371.42 362.969 1374.04 361.8 1377.54 362.969",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.5 368.962C1388.19 366.331 1386 364.285 1383.96 366.623",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.4 130.838C1384.4 130.838 1385.57 120.751 1385.86 119.143C1386 118.412 1386.88 117.681 1388.34 117.828C1390.23 118.12 1390.23 120.02 1390.23 120.02C1390.23 120.02 1422.17 123.967 1424.51 124.26C1426.84 124.552 1429.03 126.891 1428.59 130.838C1428.15 134.784 1425.38 136.1 1423.2 135.954C1421.15 135.661 1388.77 131.715 1388.77 131.715C1388.77 131.715 1388.34 133.615 1386.15 133.323C1384.69 133.176 1384.25 131.715 1384.4 130.838Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.94 127.183L1389.5 131.422",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.13 129.376L1391.84 131.715",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.34 127.914L1394.75 132.153",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.53 130.107L1397.23 132.446",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.59 128.499L1400.15 132.738",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.78 130.691L1402.48 133.03",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.18 121.336C1429.18 121.336 1432.24 96.9241 1432.53 94.4391C1432.82 91.954 1429.61 87.7149 1425.24 89.1767C1420.72 90.6384 1397.38 98.6783 1397.38 98.6783L1384.11 97.0703C1384.11 97.0703 1383.82 95.17 1381.77 94.8776C1380.46 94.7314 1379.59 95.7547 1379.44 96.4856C1379.29 97.2165 1378.13 107.449 1377.98 108.618C1377.84 109.349 1378.56 110.226 1379.88 110.373C1381.77 110.665 1382.36 108.765 1382.36 108.765C1382.36 108.765 1393.59 110.08 1394.17 110.226C1394.75 110.226 1408.32 119.143 1408.32 119.143",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.96 97.0703L1383.52 101.309",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.73 97.3627L1386.44 99.7015",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.94 97.8011L1389.36 102.04",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.57 98.0935L1392.28 100.432",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.97 94.0005C1413.72 94.5852 1420.28 106.279 1419.55 118.12",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.61 234.478C1227.61 234.478 1231.98 228.485 1232.71 227.461C1233 227.023 1233.88 226.877 1234.76 227.608C1235.92 228.485 1235.19 229.8 1235.19 229.8C1235.19 229.8 1254.45 243.98 1255.9 245.003C1257.36 246.026 1257.95 248.365 1256.2 250.704C1254.45 253.043 1252.11 253.043 1250.94 252.019C1249.63 251.142 1230.23 236.817 1230.23 236.817C1230.23 236.817 1229.36 237.986 1228.05 236.963C1227.02 236.086 1227.17 235.063 1227.61 234.478Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.57 234.186L1230.67 236.817",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.15 236.378L1232.13 237.84",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.78 236.525L1233.88 239.156",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.36 238.717L1235.34 240.179",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.98 238.863L1237.09 241.495",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.57 241.202L1238.55 242.518",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.99 244.564C1259.99 244.564 1270.78 229.8 1271.8 228.339C1272.82 226.877 1272.38 222.93 1269.03 222.199C1265.68 221.468 1247.44 218.252 1247.44 218.252L1239.42 212.405C1239.42 212.405 1239.86 211.089 1238.69 210.212C1237.82 209.628 1236.94 209.92 1236.65 210.359C1236.36 210.797 1231.84 216.937 1231.25 217.667C1230.96 218.106 1231.11 218.837 1231.84 219.422C1233 220.299 1234.03 219.275 1234.03 219.275C1234.03 219.275 1240.73 224.246 1241.17 224.538C1241.46 224.83 1247.15 235.501 1247.15 235.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.57 212.551L1237.67 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.17 213.721L1240.15 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.07 215.182L1241.17 217.667",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.67 216.352L1243.65 217.668",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 220.591C1259.7 221.614 1259.84 231.554 1255.03 239.01",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.48 95.3161L1355.08 127.622L1362.23 128.937L1367.77 96.3393L1365 88.738L1360.48 95.3161Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.77 96.3393C1367.77 96.3393 1364.56 97.9473 1360.33 95.1699",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355.96 122.651L1362.96 123.967",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.19 306.836L1174.52 279.793L1168.54 283.886L1187.06 311.222L1194.5 314.73L1193.19 306.836Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.06 311.222C1187.06 311.222 1188.23 307.86 1193.19 306.836",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.44 284.033L1171.6 287.833",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.74 345.281L1426.26 294.996L1415.03 295.434L1417.36 346.012L1424.07 356.537L1428.74 345.281Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.36 346.012C1417.36 346.012 1421.59 342.504 1428.74 345.281",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.55 302.89L1415.76 303.036",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.05 46.6387L1417.8 23.1039L1412.69 17.9877L1389.65 41.5224L1387.61 49.416L1395.05 46.6387Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.65 41.5223C1389.65 41.5223 1393.15 41.9609 1395.05 46.6386",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.3 26.7583L1409.34 21.6421",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1587.06 97.5486C1594.68 90.1124 1594.84 77.8961 1587.42 70.2628C1580 62.6294 1567.81 62.4696 1560.19 69.9058C1552.57 77.342 1552.42 89.5583 1559.83 97.1916C1567.25 104.825 1579.44 104.985 1587.06 97.5486Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550.29 83.6218L1546.79 83.3295C1546.65 90.1999 1549.27 97.0703 1554.38 102.333C1564.73 112.858 1581.65 113.15 1592.15 102.771C1597.4 97.655 1600.17 90.7846 1600.17 83.9142H1596.82",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.21 70.0272C1562.98 76.1667 1578.3 83.768 1587.34 70.3196",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.15 92.9773C1562.98 86.3993 1579.75 83.0371 1590.69 92.8311",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.53 107.01L1592.3 102.771",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.57 123.967L1613.3 102.625C1613.3 102.625 1609.8 99.4092 1606.01 103.064C1604.26 101.309 1602.21 101.748 1600.32 103.648C1598.28 105.549 1594.19 109.642 1592.88 110.811C1591.57 112.127 1590.55 114.758 1592.3 116.658C1590.84 118.412 1588.8 121.044 1591.57 123.967Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.95 189.539C1522.67 185.635 1523.34 178.634 1519.44 173.9C1515.55 169.166 1508.56 168.493 1503.84 172.397C1499.12 176.3 1498.45 183.302 1502.34 188.036C1506.24 192.769 1513.22 193.442 1517.95 189.539Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.49 180.977L1495.45 180.831C1495.45 184.777 1496.91 188.724 1499.83 191.794C1505.81 197.933 1515.58 198.08 1521.7 192.086C1524.77 189.163 1526.37 185.216 1526.37 181.269H1524.48",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1503.18 173.083C1504.79 176.591 1513.68 180.977 1518.93 173.229",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.43 186.239C1504.79 182.439 1514.56 180.538 1520.83 186.093",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.18 194.425L1521.7 191.94",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.27 204.219L1533.81 191.94C1533.81 191.94 1531.77 190.04 1529.58 192.233C1528.56 191.209 1527.39 191.502 1526.23 192.671C1525.06 193.84 1522.73 196.033 1522 196.91C1521.27 197.641 1520.68 199.249 1521.7 200.272C1520.83 201.003 1519.66 202.611 1521.27 204.219Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.07 320.577L1434.49 353.467L1441.78 353.76L1442.51 320.723L1438.71 313.561L1435.07 320.577Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.51 320.723C1442.51 320.723 1439.59 322.77 1435.07 320.723",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.63 348.351L1441.63 348.643",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.01 364.285L1475.76 335.195L1447.17 305.813L1446.01 364.285ZM1465.41 334.756L1454.18 345.72L1454.61 323.647L1465.41 334.756Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.11 314.438L1452.13 313.561",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.57 317.946L1454.47 316.046",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.78 319.262L1456.8 318.385",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.24 322.77L1459.13 320.87",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.45 324.085L1461.32 323.208",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.91 327.594L1463.8 325.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.11 328.763L1465.99 327.886",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.57 332.418L1468.47 330.371",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.78 333.587L1470.66 332.71",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.54 195.595L1540.67 210.212L1555.83 181.561L1584.86 166.944L1569.54 195.595Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.61 177.615L1594.34 192.671C1594.34 192.671 1594.92 200.126 1584.42 210.359C1573.92 220.591 1566.34 220.006 1566.34 220.006L1551.6 204.95",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.17 209.043L1562.54 227.9",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.63 228.046C1567.79 229.216 1567.79 231.262 1566.63 232.432C1565.46 233.601 1563.42 233.601 1562.25 232.432C1561.08 231.262 1561.08 229.216 1562.25 228.046C1563.56 226.731 1565.46 226.731 1566.63 228.046Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.79 235.209C1567.79 235.209 1568.52 239.156 1570.86 241.495C1572.02 240.325 1576.11 236.378 1576.11 236.378C1576.11 236.378 1572.46 233.455 1569.84 233.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.99 134.346L1445.72 163.874L1439.59 132.007L1452.72 102.479L1458.99 134.346Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.34 114.027L1476.2 116.366C1476.2 116.366 1481.45 121.774 1479.85 136.392C1478.24 151.01 1471.82 155.249 1471.82 155.249L1450.97 152.91",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.76 160.804L1473.87 163.728",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.22 161.243C1478.97 161.389 1480.14 162.997 1479.85 164.605C1479.7 166.359 1478.09 167.528 1476.49 167.236C1474.74 167.09 1473.57 165.482 1473.87 163.874C1474.01 162.266 1475.47 160.95 1477.22 161.243Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.62 166.067C1482.62 166.067 1485.68 168.698 1488.89 168.99C1489.03 167.382 1489.76 161.681 1489.76 161.681C1489.76 161.681 1485.1 161.681 1482.91 163.143",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529.18 109.499L1502.85 135.204L1537.76 171.119L1564.09 145.414L1529.18 109.499Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.25 111.103L1535.27 109.934L1570.27 145.894L1543.87 171.767L1542.71 170.452",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.83 126.375L1508.64 135.351L1517.39 144.356L1526.58 135.38L1517.83 126.375Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.12 123.529L1528.56 116.22",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.33 126.744L1531.77 119.582",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.6 149.987L1542.85 131.276",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527.25 153.787L1546.35 135.077",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.89 157.442L1550 138.731",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.39 15.6046L1504.63 15.401L1504.36 65.5402L1541.11 65.7438L1541.39 15.6046Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.87 20.1803H1545.48L1545.19 70.3195L1508.29 70.1733V68.4192",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.59 19.6319L1508.76 19.5608L1508.69 32.1321L1521.53 32.2032L1521.59 19.6319Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525.93 19.8879H1536.29",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525.79 24.4194L1536.29 24.5656",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.16 40.4991L1535.85 40.6453",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.16 45.7616L1535.85 45.9078",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.02 50.8778L1535.85 51.024",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.67 116.684L1587.78 143.919L1624.52 181.718L1652.41 154.483L1615.67 116.684Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.09 123.676L1595.03 143.26L1599.41 147.763L1619.47 128.178L1615.09 123.676Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1626.04 134.959L1605.77 154.747L1624.71 174.223L1644.97 154.434L1626.04 134.959Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.22 145.163L1634.74 164.166",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.92 154.811L1629.78 168.99",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.32 140.047L1639.84 159.196",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.82 159.635L1630.66 140.193",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.63 164.459L1635.47 145.163",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.45 169.429L1640.14 150.133",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.57 184.064L1437.7 186.486L1440.97 239.156L1479.84 236.734L1476.57 184.064Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.6 189.031L1443.65 190.773L1444.04 197.047L1471.99 195.305L1471.6 189.031Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.56 204.692L1444.31 206.452L1446 233.59L1474.24 231.83L1472.56 204.692Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.4 205.973L1460.16 232.578",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.99 212.99L1453.15 232.87",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.7 205.535L1467.3 231.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.99 213.428L1472.55 211.674",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.42 220.299L1472.99 218.545",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.86 227.169L1473.43 225.415",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.05 81.8677L1639.26 90.1999L1641.16 106.864L1657.2 113.588L1670.47 103.356L1668.14 86.5454L1656.33 81.4292",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.16 78.2133C1656.18 79.5289 1655.89 81.5754 1654.58 82.5987C1653.26 83.6219 1651.22 83.3296 1650.2 82.014C1649.18 80.6984 1649.47 78.6519 1650.78 77.6286C1652.1 76.6054 1653.99 76.7515 1655.16 78.2133Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.74 86.3992C1635.61 87.4225 1635.32 89.0304 1634.3 89.9075C1633.28 90.7846 1631.68 90.4922 1630.8 89.469C1629.93 88.4457 1630.22 86.8378 1631.24 85.9607C1632.41 85.0836 1634.01 85.2298 1634.74 86.3992Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.43 124.26C1662.6 125.868 1662.31 128.06 1660.7 129.23C1659.1 130.399 1656.91 130.107 1655.74 128.499C1654.58 126.891 1654.87 124.698 1656.47 123.529C1658.08 122.359 1660.26 122.652 1661.43 124.26Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.71 115.343C1689.58 116.512 1689.43 118.12 1688.27 119.143C1687.1 120.02 1685.5 119.874 1684.48 118.705C1683.6 117.535 1683.75 115.927 1684.91 114.904C1686.08 113.881 1687.83 114.173 1688.71 115.343Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.14 62.1337C1683.31 63.5955 1683.02 65.7882 1681.56 66.8114C1680.1 67.9808 1677.91 67.6885 1676.89 66.2267C1675.72 64.7649 1676.02 62.5722 1677.47 61.549C1678.93 60.3796 1680.97 60.6719 1682.14 62.1337Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.56 97.6551C1703.87 99.4092 1703.58 101.894 1701.83 103.21C1700.08 104.525 1697.6 104.233 1696.29 102.479C1694.98 100.725 1695.27 98.2398 1697.02 96.9242C1698.77 95.6086 1701.25 95.9009 1702.56 97.6551Z",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.14 86.5455L1681.27 76.6053L1697.16 82.891L1698.48 95.7547",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.47 103.356L1685.93 109.934L1696 102.187",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679.95 67.5422L1681.27 76.6053",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.32 88.738L1639.26 90.1998",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.93 122.944L1657.2 113.588",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.93 109.934L1686.08 114.027",
    stroke: "black",
    strokeWidth: 1.1853,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.04 34.0674L1557.29 42.2534L1564.88 49.2699L1574.94 46.2002L1577.27 35.9677L1569.54 29.0973L1561.96 31.29",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.06 30.2666C1561.08 30.559 1561.81 31.5822 1561.52 32.6055C1561.23 33.6287 1560.21 34.3596 1559.19 34.0673C1558.17 33.7749 1557.44 32.7516 1557.73 31.7284C1558.02 30.7051 1559.04 30.1204 1560.06 30.2666Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.65 42.2533C1554.52 42.3995 1554.96 43.2765 1554.81 44.0074C1554.67 44.8845 1553.79 45.323 1553.06 45.1769C1552.19 45.0307 1551.75 44.1536 1551.9 43.4227C1552.04 42.5457 1552.92 41.9609 1553.65 42.2533Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.21 49.4161C1582.38 49.7085 1583.11 50.8779 1582.82 52.0473C1582.52 53.2168 1581.36 53.9477 1580.19 53.6553C1579.02 53.363 1578.3 52.1935 1578.59 51.0241C1578.88 50.0008 1580.05 49.1238 1581.21 49.4161Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590.55 34.5059C1591.42 34.652 1592.01 35.5291 1591.71 36.4062C1591.57 37.2833 1590.69 37.868 1589.82 37.5756C1588.94 37.4294 1588.36 36.5524 1588.65 35.6753C1588.65 34.7982 1589.53 34.2135 1590.55 34.5059Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.48 11.9944C1567.65 12.2868 1568.23 13.31 1568.09 14.4794C1567.79 15.6489 1566.77 16.2336 1565.61 16.0874C1564.44 15.795 1563.86 14.7718 1564 13.6024C1564.15 12.4329 1565.31 11.702 1566.48 11.9944Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.96 20.619C1591.28 20.9113 1592.15 22.2269 1591.86 23.5425C1591.57 24.8581 1590.26 25.7352 1588.94 25.4428C1587.63 25.1505 1586.75 23.8349 1587.05 22.5193C1587.48 21.2037 1588.65 20.3266 1589.96 20.619Z",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.54 29.0973L1571.73 19.1571L1581.65 15.795L1587.48 21.3498",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.27 35.9678L1587.05 33.0442L1588.8 25.2968",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.5 15.3566L1571.73 19.1572",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.96 43.1304L1557.29 42.2533",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.02 50.1469L1574.94 46.2001",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.05 33.0442L1588.8 34.7983",
    stroke: "black",
    strokeWidth: 0.7288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.72 219.714L1503.47 215.036L1490.78 225.123L1493.56 241.787L1508.58 247.488L1521.12 236.963L1519.37 224.684",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.27 221.907C1520.68 223.515 1518.93 224.246 1517.33 223.661C1515.72 223.076 1515 221.322 1515.58 219.714C1516.16 218.106 1517.91 217.375 1519.52 217.96C1521.12 218.691 1521.85 220.445 1521.27 221.907Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.35 209.482C1503.91 210.651 1502.45 211.382 1501.29 210.797C1500.12 210.359 1499.39 208.897 1499.97 207.727C1500.41 206.558 1501.87 205.827 1503.04 206.412C1504.2 206.85 1504.79 208.312 1504.35 209.482Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.99 250.704C1486.26 252.458 1484.37 253.335 1482.62 252.75C1480.87 252.019 1479.99 250.119 1480.57 248.365C1481.3 246.611 1483.2 245.734 1484.95 246.318C1486.7 246.903 1487.58 248.95 1486.99 250.704Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.14 268.391C1507.7 269.707 1506.1 270.438 1504.79 269.853C1503.47 269.415 1502.74 267.807 1503.33 266.491C1503.76 265.176 1505.37 264.445 1506.68 265.029C1507.99 265.614 1508.72 267.076 1508.14 268.391Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.25 235.94C1547.67 237.694 1545.77 238.425 1544.02 237.84C1542.27 237.255 1541.54 235.355 1542.12 233.601C1542.71 231.847 1544.6 231.116 1546.35 231.701C1548.1 232.432 1548.83 234.332 1548.25 235.94Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.49 273.189C1528.57 272.959 1530.07 271.082 1529.84 268.995C1529.61 266.909 1527.74 265.404 1525.66 265.633C1523.58 265.862 1522.08 267.74 1522.3 269.826C1522.53 271.913 1524.41 273.418 1526.49 273.189Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.12 236.963L1536 242.664L1538.92 258.89L1529.14 266.637",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.58 247.488L1511.2 263.421L1522.58 267.807",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.71 236.963L1536 242.664",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502.6 211.236L1503.47 215.036",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.26 247.196L1493.56 241.787",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.2 263.421L1507.85 265.614",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.29 22.6654C1675.29 22.6654 1660.26 22.9578 1658.66 22.9578C1657.06 22.9578 1655.16 22.2269 1652.97 20.6189C1650.78 19.0109 1643.93 14.6256 1636.49 14.7718C1629.2 14.9179 1615.34 23.6886 1615.63 40.7915C1615.93 58.0406 1629.78 60.818 1634.16 60.6718C1638.53 60.6718 1641.74 58.7715 1644.37 60.5256C1646.99 62.2798 1649.91 65.2033 1651.22 65.2033C1652.53 65.2033 1652.1 60.9642 1653.41 60.818C1654.72 60.6718 1660.85 59.5024 1662.6 59.21C1664.35 58.9177 1665.22 57.8944 1665.22 54.9708C1665.22 52.0473 1665.81 46.3463 1668.58 46.3463C1671.35 46.3463 1676.45 46.2001 1676.45 46.2001",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.95 67.9808L1621.32 61.8413",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.8 60.9642L1615.05 56.725",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.82 50.5856L1609.95 47.662",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.07 38.599L1609.36 38.3066",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.11 26.6122L1610.67 29.0972",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.8 15.9412L1615.34 20.0342",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.26 8.33997L1621.76 13.6024",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.7 48.9775C1644.22 49.1236 1644.07 52.6319 1642.03 52.3396C1639.99 52.0472 1637.95 54.0937 1636.34 53.3628C1634.74 52.6319 1631.24 54.3861 1630.07 52.1934C1628.91 50.0007 1625.84 51.901 1625.41 48.6851C1625.11 45.4692 1622.49 46.2001 1622.49 43.1303C1622.49 40.0606 1620.15 38.5988 1622.05 36.6985C1623.8 34.7981 1621.18 31.1437 1624.24 30.559C1627.3 29.9742 1624.97 26.9045 1627.01 26.6121C1629.05 26.3198 1631.39 22.373 1634.45 23.5424C1637.51 24.7118 1639.26 21.7883 1640.57 23.9809C1641.89 26.1736 1644.95 22.9577 1646.41 26.0274C1647.87 29.0972 1651.22 28.2201 1650.78 31.436C1650.49 34.7981 1653.7 36.4061 1652.24 38.745C1650.78 41.0838 1652.68 43.8612 1650.64 45.0306C1648.89 46.0539 1650.93 48.6851 1646.7 48.9775Z",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.87 48.2466C1641.01 45.0307 1639.7 44.1536 1637.37 43.8613C1634.89 43.5689 1633.72 43.2765 1632.99 40.6453C1632.26 37.8679 1632.11 35.2367 1629.93 33.9211C1627.88 32.6055 1625.26 30.4128 1625.26 30.4128",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.55 40.6454C1627.59 40.0606 1629.34 35.3829 1631.24 35.3829",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.88 45.0307C1630.36 45.1769 1633.28 41.8148 1633.28 41.8148",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.57 48.3928C1635.62 47.9543 1635.91 46.2001 1637.37 44.5922",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.43 38.5989C1642.62 39.6222 1637.22 36.2601 1639.26 30.4129C1641.16 24.5658 1635.32 23.3964 1635.32 23.3964",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.03 42.6919C1635.32 40.9378 1637.37 36.6986 1639.99 36.6986",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.07 38.745C1643.35 40.6453 1644.22 44.0074 1645.97 46.0539",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.2 26.0276C1629.78 28.6588 1631.68 31.29 1635.91 32.0209",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.78 32.3132C1648.01 34.2135 1644.95 35.0906 1644.22 31.7285",
    stroke: "black",
    strokeWidth: 1.4648,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.47 47.6619C1496.47 47.6619 1486.41 38.1603 1485.39 37.1371C1484.22 36.1138 1483.49 34.3597 1483.2 32.0208C1482.91 29.682 1481.01 22.2269 1476.2 17.6953C1471.24 13.0176 1456.65 10.0941 1446.01 21.496C1435.21 32.8979 1442.51 43.7151 1445.42 46.3463C1448.34 49.1237 1451.7 50.0008 1452.28 52.7782C1452.86 55.7017 1453.01 59.3562 1453.88 60.2333C1454.76 60.9642 1457.09 58.0406 1458.11 58.7715C1459.13 59.5024 1463.8 62.5721 1465.11 63.5954C1466.43 64.6186 1467.59 64.4724 1469.49 62.5721C1471.39 60.6718 1475.32 57.3097 1477.22 59.0639C1479.12 60.818 1482.47 64.0339 1482.47 64.0339",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.38 40.0607L1436.24 38.8912",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.23 30.9976L1435.36 31.4361",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431.86 20.1804L1437.84 22.2269",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.42 11.4097L1443.24 15.795",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.47 4.68542L1450.09 10.5326",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.82 1.32336L1458.99 7.60904",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.18 1.76184L1467.16 7.60898",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.03 46.6387C1459.28 45.1769 1456.95 47.5158 1455.93 45.9078C1454.76 44.2998 1452.13 44.446 1451.55 42.8381C1450.97 41.3763 1447.47 40.2068 1448.2 38.1603C1448.92 35.9677 1445.57 35.2368 1447.47 32.8979C1449.22 30.5591 1447.17 29.3896 1449.07 27.3431C1450.97 25.2966 1450.38 22.9578 1452.86 22.8116C1455.34 22.6654 1455.78 18.5724 1458.26 20.1804C1460.74 21.7884 1461.03 18.2801 1462.63 19.3033C1464.09 20.4728 1468.18 19.3033 1469.49 21.9345C1470.8 24.5657 1473.72 23.8349 1473.14 26.1737C1472.55 28.5126 1476.78 28.3664 1475.62 31.29C1474.59 34.2135 1477.37 35.8215 1475.03 37.7218C1472.7 39.6221 1473.87 42.8381 1471.39 43.4228C1468.91 44.0075 1468.32 47.0772 1466.28 46.4925C1464.38 46.054 1464.09 49.1237 1461.03 46.6387Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.82 42.3995C1460.01 40.4992 1459.72 39.0374 1458.26 37.2832C1456.8 35.5291 1456.22 34.652 1457.53 32.3132C1458.7 29.9743 1460.45 28.074 1459.86 25.8813C1459.43 23.6886 1458.99 20.6189 1458.99 20.6189",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.57 27.6355C1454.32 28.5125 1458.4 26.6122 1459.57 27.7816",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.26 32.0209C1452.72 33.775 1456.8 33.3365 1456.8 33.3365",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.72 37.8679C1454.32 38.8912 1455.63 37.8679 1457.68 37.8679",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.18 40.3529C1464.38 37.8679 1463.07 32.3131 1468.03 29.6819C1472.99 27.1969 1469.93 22.5192 1469.93 22.5192",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.38 35.0905C1458.7 34.0673 1462.78 32.6055 1464.53 34.3596",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.84 38.3064C1464.09 39.1835 1462.63 41.8147 1462.49 44.2997",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.24 20.3265C1462.93 22.373 1462.49 25.2966 1464.82 28.5125",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.3 38.3064C1471.24 37.7217 1468.76 36.4061 1470.22 33.7749",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.03 312.976C1489.03 312.976 1478.24 306.983 1477.07 306.252C1475.91 305.521 1474.3 305.375 1472.12 305.813C1469.93 306.106 1463.22 306.69 1457.82 303.62C1452.57 300.697 1445.86 289.003 1452.72 276.577C1459.57 264.152 1470.8 267.514 1473.87 269.269C1477.07 271.023 1478.68 273.654 1481.3 273.362C1483.93 273.069 1487.14 272.192 1488.16 272.631C1489.03 273.069 1487.14 275.993 1488.16 276.724C1489.03 277.455 1492.97 280.67 1494.28 281.401C1495.45 282.278 1495.6 283.302 1494.58 285.494C1493.56 287.687 1491.66 291.926 1493.7 293.096C1495.74 294.265 1499.39 296.312 1499.39 296.312",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.09 257.282L1464.97 263.421",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.22 259.621L1458.41 264.737",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.76 264.883L1451.26 269.415",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.92 272.923L1447.03 275.847",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.86 282.425L1444.55 283.155",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.71 292.365L1444.4 291.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.07 301.135L1446.59 298.65",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.53 282.717C1476.78 281.547 1478.1 279.062 1476.49 278.478C1474.89 277.893 1474.16 275.554 1472.7 275.554C1471.24 275.554 1469.34 272.777 1467.74 273.946C1466.14 275.116 1464.53 272.484 1463.07 274.677C1461.61 276.87 1460.01 275.408 1458.84 277.601C1457.68 279.793 1455.49 279.94 1455.93 282.132C1456.51 284.325 1453.15 285.787 1455.2 287.541C1457.24 289.149 1454.32 290.464 1455.63 291.488C1457.09 292.511 1457.24 296.312 1459.86 296.604C1462.49 296.896 1462.63 299.674 1464.53 298.65C1466.28 297.481 1467.3 301.135 1469.64 299.381C1471.82 297.627 1474.01 299.674 1475.03 297.189C1476.05 294.704 1479.12 294.85 1478.97 292.511C1478.82 290.172 1481.16 288.856 1480.14 287.395C1478.82 285.64 1481.45 284.617 1478.53 282.717Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.87 280.963C1472.84 283.302 1471.39 283.594 1469.64 282.863C1467.74 282.132 1466.86 281.84 1465.11 283.594C1463.51 285.202 1462.34 287.248 1460.3 287.395C1458.26 287.541 1455.63 288.126 1455.63 288.126",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1459.72 280.524C1461.03 281.694 1460.45 285.933 1461.76 286.518",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.22 278.185C1465.11 279.062 1465.84 282.571 1465.84 282.571",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.61 278.039C1469.93 279.062 1469.49 280.524 1469.93 282.278",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.03 290.464C1471.97 287.833 1466.72 288.272 1465.84 293.242C1464.97 298.212 1460.3 296.896 1460.3 296.896",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.45 282.717C1466.86 284.033 1466.72 287.979 1468.76 289.003",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.55 289.149C1472.84 287.395 1474.74 285.348 1476.78 284.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.8 292.657C1458.26 290.903 1460.59 289.88 1463.95 290.903",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.89 296.458C1473.57 293.973 1471.68 292.218 1469.93 294.265",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.87 53.3629C1696.87 53.3629 1701.69 42.6919 1702.42 40.9377C1702.85 40.0607 1704.02 39.6221 1705.62 40.4992C1707.52 41.3763 1707.08 43.5689 1707.08 43.5689C1707.08 43.5689 1740.77 58.7715 1743.25 59.9409C1745.73 61.1104 1747.34 64.3263 1745.44 68.5655C1743.55 72.6585 1740.04 73.3894 1737.86 72.3661C1735.67 71.3429 1701.39 55.8479 1701.39 55.8479C1701.39 55.8479 1700.37 57.8944 1698.04 56.725C1696.44 55.9941 1696.44 54.24 1696.87 53.3629Z",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.31 51.3163L1702.27 55.7016",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.92 54.3861L1704.75 56.8711",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.85 53.8014L1707.81 58.3329",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.6 57.0173L1710.44 59.5024",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.54 56.2864L1713.5 60.8179",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.15 59.5023L1715.98 61.9874",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.38 58.1868C1749.38 58.1868 1761.05 32.3132 1762.21 29.682C1763.38 27.0508 1761.34 21.3498 1755.94 21.3498C1750.55 21.3498 1721.96 22.2269 1721.96 22.2269L1707.96 15.9412C1707.96 15.9412 1708.25 13.7485 1706.06 12.7253C1704.6 11.9944 1703.29 12.8714 1703 13.6023C1702.71 14.3332 1697.75 25.1504 1697.31 26.3199C1696.87 27.1969 1697.46 28.2202 1698.77 28.8049C1700.81 29.682 1702.12 27.7816 1702.12 27.7816C1702.12 27.7816 1713.94 33.1903 1714.52 33.3364C1715.1 33.6288 1727.06 47.9543 1727.06 47.9543",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.96 16.0873L1705.92 20.4726",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.73 17.2568L1709.71 19.7419",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714.08 18.8647L1712.19 23.3963",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717 20.1803L1715.98 22.5192",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.75 22.2268C1741.36 23.5424 1744.71 38.5988 1739.9 51.4625",
    stroke: "black",
    strokeWidth: 1.2158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.57 97.2165C1473.57 97.2165 1477.95 91.2232 1478.68 90.1999C1478.97 89.7614 1479.85 89.6152 1480.72 90.3461C1481.89 91.2232 1481.16 92.5388 1481.16 92.5388C1481.16 92.5388 1500.41 106.718 1501.87 107.741C1503.33 108.765 1503.91 111.103 1502.16 113.442C1500.41 115.781 1498.08 115.781 1496.91 114.758C1495.6 113.881 1476.2 99.5553 1476.2 99.5553C1476.2 99.5553 1475.32 100.725 1474.01 99.7015C1472.99 98.8245 1473.28 97.8012 1473.57 97.2165Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.53 96.9241L1476.64 99.5553",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.12 99.1167L1478.09 100.578",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.74 99.2629L1479.85 101.894",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.32 101.456L1481.3 102.917",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.95 101.602L1483.05 104.233",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.53 103.794L1484.51 105.256",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.95 107.303C1505.95 107.303 1516.75 92.5386 1517.77 91.0769C1518.79 89.6151 1518.35 85.6683 1515 84.9374C1511.64 84.2065 1493.41 80.9905 1493.41 80.9905L1485.39 75.1434C1485.39 75.1434 1485.83 73.8278 1484.66 72.9507C1483.78 72.366 1482.91 72.6584 1482.62 73.0969C1482.32 73.5354 1477.8 79.6749 1477.22 80.4058C1476.93 80.8444 1477.07 81.5753 1477.8 82.16C1478.97 83.037 1479.99 82.0138 1479.99 82.0138C1479.99 82.0138 1486.7 86.9839 1487.14 87.2762C1487.43 87.5686 1493.12 98.2396 1493.12 98.2396",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.53 75.2897L1483.64 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1487.14 76.4591L1486.12 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.03 77.9208L1487.28 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.78 79.0902L1489.76 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.79 83.3295C1505.66 84.3527 1505.81 94.2929 1500.99 101.748",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.09 69.8811L1459.72 98.0936L1465.99 94.5853L1449.51 65.9343L1442.36 61.8413L1443.09 69.8811Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.51 65.9343C1449.51 65.9343 1448.2 69.2964 1443.09 69.735",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.09 93.7082L1463.36 90.3461",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.79 207.581C1728.23 215.182 1728.09 227.315 1720.5 234.77C1712.92 242.225 1700.81 242.079 1693.37 234.478C1685.93 226.877 1686.08 214.744 1693.66 207.289C1701.25 199.834 1713.35 199.98 1720.79 207.581Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.75 220.883L1680.25 220.591C1680.1 227.461 1682.73 234.332 1687.83 239.594C1698.19 250.119 1715.1 250.411 1725.61 240.033C1730.86 234.916 1733.63 228.046 1733.63 221.176H1730.27",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.66 207.289C1696.44 213.428 1711.75 221.03 1720.79 207.581",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690.6 230.239C1696.44 223.661 1713.21 220.299 1724.15 230.093",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.84 244.272L1725.75 240.033",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.02 261.229L1746.75 239.887C1746.75 239.887 1743.25 236.671 1739.46 240.325C1737.71 238.571 1735.67 239.01 1733.77 240.91C1731.73 242.81 1727.65 246.903 1726.33 248.073C1725.02 249.388 1724 252.019 1725.75 253.92C1724.15 255.674 1722.11 258.305 1725.02 261.229Z",
    stroke: "black",
    strokeWidth: 1.2118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.97 325.138C1656.79 320.351 1656.03 313.36 1651.25 309.522C1646.47 305.684 1639.5 306.453 1635.67 311.24C1631.84 316.027 1632.61 323.019 1637.38 326.857C1642.16 330.695 1649.14 329.926 1652.97 325.138Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.8 318.238L1628.76 318.092C1628.76 322.039 1630.22 325.986 1633.14 329.055C1639.12 335.195 1648.89 335.341 1655.01 329.348C1658.08 326.424 1659.68 322.477 1659.68 318.531H1657.78",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1636.49 310.345C1638.09 313.853 1646.99 318.238 1652.24 310.491",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.74 323.501C1638.09 319.7 1647.87 317.8 1654.14 323.354",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.49 331.687L1655.16 329.348",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.72 341.481L1667.26 329.202C1667.26 329.202 1665.22 327.301 1663.04 329.494C1662.01 328.471 1660.85 328.763 1659.68 329.933C1658.51 331.102 1656.18 333.295 1655.45 334.172C1654.72 335.049 1654.14 336.511 1655.16 337.534C1654.28 338.265 1653.12 339.873 1654.72 341.481Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.26 75.7281H1807.87V25.7351L1757.26 75.7281ZM1799.26 66.6651H1780.15L1799.26 47.8081V66.6651Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 36.8447H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 41.0839H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 44.8845H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 49.1238H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 53.0706H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 57.3097H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 61.2565H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.18 65.4957H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.93 69.2963H1805.53",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.95 383.434H1500.56V333.441L1449.95 383.434ZM1491.95 374.225H1472.84L1491.95 355.368V374.225Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 344.404H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 348.643H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 352.444H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 356.829H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 360.63H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 364.869H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 368.816H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.01 373.055H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.76 376.856H1498.22",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703 332.856L1673.97 347.474L1689.29 318.823L1718.31 304.205L1703 332.856Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.06 314.876L1727.79 329.933C1727.79 329.933 1728.38 337.388 1717.88 347.62C1707.37 357.853 1699.79 357.268 1699.79 357.268L1685.06 342.212",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.62 346.305L1695.85 365.162",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.08 365.308C1701.25 366.477 1701.25 368.524 1700.08 369.693C1698.91 370.863 1696.87 370.863 1695.71 369.693C1694.54 368.524 1694.54 366.477 1695.71 365.308C1697.02 363.992 1698.91 363.992 1700.08 365.308Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.25 372.47C1701.25 372.47 1701.98 376.417 1704.31 378.756C1705.48 377.587 1709.56 373.64 1709.56 373.64C1709.56 373.64 1705.92 370.716 1703.29 370.424",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592.44 271.607L1579.17 301.135L1572.9 269.415L1586.17 239.74L1592.44 271.607Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.8 251.289L1609.65 253.627C1609.65 253.627 1614.9 259.036 1613.3 273.654C1611.7 288.272 1605.28 292.511 1605.28 292.511L1584.42 290.172",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.21 298.066L1607.32 300.989",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.53 298.504C1612.28 298.65 1613.45 300.258 1613.15 301.866C1613.01 303.62 1611.4 304.79 1609.8 304.498C1608.05 304.351 1606.88 302.743 1607.17 301.135C1607.32 299.527 1608.92 298.212 1610.53 298.504Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.07 303.328C1616.07 303.328 1619.13 305.959 1622.34 306.252C1622.49 304.644 1623.22 298.943 1623.22 298.943C1623.22 298.943 1618.55 298.943 1616.36 300.405",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.62 246.724L1636.29 272.429L1671.2 308.344L1697.53 282.639L1662.62 246.724Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.56 248.365L1668.72 247.196L1703.58 283.155L1677.33 309.029L1676.16 307.713",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.27 263.6L1642.08 272.577L1650.83 281.581L1660.02 272.605L1651.27 263.6Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.58 260.79L1662.01 253.481",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.78 264.152L1665.22 256.843",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.06 287.249L1676.16 268.538",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.7 291.049L1679.81 272.338",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664.35 294.704L1683.45 275.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.29 181.692L1668.14 162.588L1642.21 195.521L1666.37 214.626L1692.29 181.692Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.62 186.093L1692.64 186.824L1666.68 219.86L1642.47 200.711L1643.35 199.541",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.06 174.152L1668.7 167.542L1662.2 175.804L1670.56 182.414L1677.06 174.152Z",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679.81 176.591L1686.66 182",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.47 179.515L1684.33 184.924",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.22 181.561L1675.72 195.448",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.45 184.924L1673.1 198.811",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.83 188.432L1670.33 202.319",
    stroke: "black",
    strokeWidth: 0.9038,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.11 253.909L1721.21 281.144L1757.95 318.943L1785.85 291.708L1749.11 253.909Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.53 261.107L1728.47 280.692L1732.85 285.194L1752.9 265.61L1748.53 261.107Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.48 272.184L1739.21 291.973L1758.14 311.448L1778.41 291.66L1759.48 272.184Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.53 282.425L1768.05 301.428",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.23 292.072L1763.09 306.252",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.78 277.308L1773.3 296.458",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.27 296.896L1763.96 277.454",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.94 301.72L1768.78 282.425",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753.76 306.69L1773.59 287.395",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.03 321.327L1571.16 323.748L1574.43 376.419L1613.3 373.997L1610.03 321.327Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.91 326.303L1576.96 328.045L1577.35 334.318L1605.3 332.577L1604.91 326.303Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.01 341.955L1577.77 343.715L1579.45 370.852L1607.7 369.093L1606.01 341.955Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.86 343.235L1593.46 369.839",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.44 350.398L1586.61 370.278",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.15 342.796L1600.76 369.401",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.44 350.69L1606.01 348.936",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.88 357.56L1606.44 355.806",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.32 364.431L1606.88 362.677",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.9 250.265L1791.53 255.089L1802.76 247.78L1801.89 233.893L1789.93 227.9L1778.84 235.501L1779.28 245.88",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.38 247.926C1777.97 246.757 1779.42 246.172 1780.74 246.757C1781.9 247.342 1782.49 248.803 1781.9 250.119C1781.32 251.288 1779.86 251.873 1778.55 251.288C1777.24 250.558 1776.8 249.096 1777.38 247.926Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.36 259.621C1790.8 258.597 1791.97 258.305 1792.99 258.744C1794.01 259.182 1794.3 260.352 1793.86 261.375C1793.43 262.398 1792.26 262.69 1791.24 262.252C1790.22 261.667 1789.78 260.498 1790.36 259.621Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.01 227.169C1808.74 225.707 1810.49 225.123 1811.8 225.853C1813.26 226.584 1813.85 228.338 1813.12 229.654C1812.39 231.116 1810.64 231.701 1809.32 230.97C1807.87 230.239 1807.43 228.485 1808.01 227.169Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.11 210.797C1792.7 209.774 1793.86 209.335 1795.03 209.774C1796.05 210.359 1796.49 211.528 1796.05 212.697C1795.47 213.721 1794.3 214.159 1793.14 213.721C1791.97 213.136 1791.53 211.82 1792.11 210.797Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.38 234.039C1757.11 232.724 1758.71 232.139 1760.03 232.87C1761.34 233.601 1761.92 235.209 1761.19 236.525C1760.46 237.84 1758.86 238.425 1757.55 237.694C1756.23 237.109 1755.8 235.501 1756.38 234.039Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.61 206.996C1775.34 205.389 1777.24 204.804 1778.84 205.535C1780.45 206.266 1781.03 208.166 1780.3 209.774C1779.57 211.382 1777.67 211.967 1776.07 211.236C1774.47 210.505 1773.88 208.604 1774.61 206.996Z",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.84 235.501L1767.03 229.654L1766.01 216.06L1774.76 210.505",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.93 227.9L1789.2 214.598L1780.15 210.066",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.05 233.747L1767.03 229.654",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.82 258.305L1791.53 255.089",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.3 230.093L1801.89 233.893",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.2 214.598L1792.11 212.99",
    stroke: "black",
    strokeWidth: 0.9457,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.41 151.156L1692.5 160.219L1700.37 169.136L1712.19 166.651L1715.98 155.395L1707.81 146.625L1698.91 148.379",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.02 146.917C1698.19 147.356 1698.77 148.525 1698.48 149.695C1698.04 150.864 1696.87 151.449 1695.71 151.156C1694.54 150.718 1693.96 149.548 1694.25 148.379C1694.54 147.21 1695.85 146.625 1697.02 146.917Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.41 159.781C1689.29 160.073 1689.87 161.096 1689.58 161.974C1689.29 162.851 1688.27 163.435 1687.39 163.143C1686.52 162.851 1685.93 161.827 1686.23 160.95C1686.52 160.073 1687.54 159.489 1688.41 159.781Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.04 171.037C1720.35 171.475 1721.08 172.937 1720.65 174.253C1720.21 175.568 1718.75 176.299 1717.44 175.86C1716.13 175.422 1715.4 173.96 1715.83 172.645C1716.27 171.329 1717.73 170.598 1719.04 171.037Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.15 154.957C1732.17 155.249 1732.61 156.273 1732.31 157.296C1732.02 158.319 1731 158.758 1729.98 158.465C1728.96 158.173 1728.52 157.15 1728.81 156.126C1729.11 155.249 1730.13 154.665 1731.15 154.957Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.21 126.891C1707.52 127.329 1708.1 128.645 1707.67 129.814C1707.23 131.13 1705.92 131.715 1704.75 131.276C1703.44 130.838 1702.85 129.522 1703.29 128.353C1703.58 127.183 1704.89 126.452 1706.21 126.891Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.17 139.316C1733.63 139.754 1734.36 141.362 1733.92 142.824C1733.48 144.286 1731.88 145.017 1730.42 144.578C1728.96 144.14 1728.23 142.532 1728.67 141.07C1729.11 139.608 1730.71 138.877 1732.17 139.316Z",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.81 146.625L1711.46 135.661L1723.13 132.884L1729.11 139.754",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.98 155.395L1727.36 153.057L1730.13 144.432",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.08 130.838L1711.46 135.661",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.73 160.95L1692.5 160.219",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.42 171.621L1712.19 166.651",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.36 153.057L1729.11 155.249",
    stroke: "black",
    strokeWidth: 0.8328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.53 351.275L1627.45 354.198L1623.36 367.939L1633.72 378.464L1647.57 374.809L1651.22 360.922L1643.64 353.029",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.78 350.105C1644.22 351.567 1643.35 353.029 1641.89 353.321C1640.43 353.76 1638.97 352.883 1638.68 351.421C1638.24 349.959 1639.12 348.497 1640.57 348.205C1641.89 347.766 1643.35 348.643 1643.78 350.105Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.26 349.667C1625.55 350.836 1624.82 351.859 1623.8 352.152C1622.63 352.444 1621.61 351.713 1621.32 350.69C1621.03 349.667 1621.76 348.497 1622.78 348.205C1623.8 347.912 1624.97 348.643 1625.26 349.667Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.57 388.258C1634.01 389.866 1632.99 391.474 1631.39 391.912C1629.78 392.351 1628.18 391.328 1627.74 389.72C1627.3 388.112 1628.32 386.504 1629.93 386.065C1631.53 385.627 1633.14 386.65 1633.57 388.258Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.78 390.158C1658.08 391.328 1657.35 392.643 1656.18 392.935C1655.01 393.228 1653.7 392.497 1653.41 391.328C1653.12 390.158 1653.85 388.842 1655.01 388.55C1656.33 388.258 1657.49 388.989 1657.78 390.158Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.18 346.451C1670.62 348.059 1669.6 349.52 1668.14 349.959C1666.54 350.398 1665.08 349.374 1664.64 347.912C1664.2 346.305 1665.22 344.843 1666.68 344.404C1668.29 343.966 1669.89 344.843 1670.18 346.451Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.41 380.949C1674.85 382.703 1673.83 384.603 1672.08 385.042C1670.33 385.48 1668.43 384.457 1667.99 382.703C1667.56 380.949 1668.58 379.048 1670.33 378.61C1672.22 378.025 1673.97 379.195 1674.41 380.949Z",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.22 360.922L1664.79 357.414L1675.14 367.647L1671.93 378.171",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.57 374.809L1657.49 385.042L1667.85 382.264",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.83 349.959L1664.79 357.414",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.82 351.859L1627.45 354.198",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.39 386.065L1633.72 378.464",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.49 385.042L1656.18 388.258",
    stroke: "black",
    strokeWidth: 1.0069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.09 157.588C1805.09 157.588 1790.95 157.734 1789.34 157.88C1787.74 157.88 1785.99 157.15 1783.95 155.688C1781.9 154.226 1775.34 149.987 1768.34 150.133C1761.34 150.279 1748.36 158.465 1748.65 174.691C1748.94 190.917 1762.07 193.548 1766.15 193.548C1770.24 193.548 1773.3 191.648 1775.92 193.402C1778.4 195.156 1781.18 197.787 1782.34 197.787C1783.51 197.787 1783.22 193.84 1784.53 193.694C1785.84 193.548 1791.53 192.379 1793.28 192.232C1794.89 192.086 1795.76 191.063 1795.76 188.286C1795.76 185.508 1796.34 180.1 1798.97 180.1C1801.59 180.1 1806.41 179.953 1806.41 179.953",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.96 200.418L1754.19 194.571",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.25 193.84L1748.21 189.747",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.42 183.9L1743.4 181.123",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.96 172.645L1742.67 172.352",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.86 161.243L1743.98 163.581",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.11 151.156L1748.36 155.103",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.13 144.14L1754.48 149.11",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.11 182.585C1775.78 182.731 1775.63 186.093 1773.74 185.801C1771.84 185.508 1769.8 187.409 1768.34 186.678C1766.88 185.947 1763.53 187.701 1762.51 185.508C1761.49 183.462 1758.42 185.216 1758.13 182.146C1757.84 179.076 1755.51 179.807 1755.36 176.884C1755.36 173.96 1753.17 172.644 1754.92 170.744C1756.67 168.844 1754.05 165.482 1756.96 164.897C1759.88 164.312 1757.69 161.389 1759.59 161.243C1761.49 161.096 1763.67 157.296 1766.59 158.319C1769.51 159.342 1771.11 156.711 1772.42 158.758C1773.74 160.804 1776.65 157.734 1777.97 160.658C1779.28 163.581 1782.49 162.704 1782.2 165.774C1781.9 168.844 1784.97 170.452 1783.51 172.645C1782.05 174.837 1783.8 177.468 1781.9 178.492C1780.15 179.661 1782.2 182.146 1778.11 182.585Z",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.57 181.708C1772.72 178.638 1771.55 177.761 1769.22 177.468C1766.88 177.176 1765.86 176.884 1765.13 174.399C1764.4 171.767 1764.26 169.282 1762.21 167.967C1760.32 166.651 1757.84 164.751 1757.84 164.751",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.13 174.545C1760.03 173.96 1761.63 169.575 1763.38 169.575",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.32 178.784C1762.65 178.93 1765.42 175.714 1765.42 175.714",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.57 182C1767.47 181.561 1767.76 179.953 1769.22 178.345",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.84 172.645C1774.32 173.522 1769.22 170.452 1771.11 164.897C1773.01 159.342 1767.32 158.173 1767.32 158.173",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.03 176.591C1767.17 174.983 1769.22 170.89 1771.69 170.89",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.63 172.791C1774.9 174.691 1775.78 177.761 1777.38 179.661",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.63 160.658C1762.07 163.143 1763.96 165.628 1767.9 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.9 166.651C1779.28 168.405 1776.36 169.282 1775.63 166.213",
    stroke: "black",
    strokeWidth: 1.3852,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.42 372.909C1556.42 372.909 1554.38 359.022 1554.08 357.414C1553.79 355.952 1554.38 354.052 1555.54 351.859C1556.71 349.667 1559.92 342.65 1558.9 335.78C1557.88 328.909 1548.1 317.215 1532.21 319.554C1516.31 321.893 1515.43 335.195 1516.02 339.142C1516.6 343.235 1518.79 346.012 1517.47 348.643C1516.16 351.275 1513.83 354.344 1513.97 355.514C1514.12 356.683 1517.91 355.806 1518.35 357.122C1518.64 358.291 1520.54 363.846 1520.98 365.454C1521.41 367.062 1522.43 367.647 1525.21 367.354C1527.98 367.062 1533.23 366.77 1533.66 369.401C1534.1 372.032 1534.69 376.71 1534.69 376.71",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.41 324.232L1513.68 327.594",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.95 316.776L1517.62 321.162",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.85 309.906L1525.35 315.315",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.79 306.836L1533.81 313.561",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.17 307.275L1542.56 313.707",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.67 311.222L1551.6 316.776",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.69 318.092L1558.17 322.039",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.56 349.667C1528.12 347.328 1524.77 347.766 1524.91 345.866C1525.06 343.966 1522.87 342.212 1523.31 340.75C1523.75 339.142 1521.7 336.072 1523.6 334.903C1525.5 333.587 1523.31 330.956 1526.23 330.225C1529.14 329.494 1528.12 327.301 1531.04 326.863C1533.96 326.424 1534.98 324.232 1537.02 325.547C1539.06 327.009 1541.98 324.085 1543 326.863C1544.02 329.64 1546.5 327.009 1546.94 328.909C1547.37 330.81 1551.46 332.418 1550.73 335.341C1550 338.265 1552.92 339.58 1551.02 341.042C1549.12 342.504 1552.48 344.989 1549.85 346.743C1547.23 348.497 1548.4 351.421 1545.33 351.567C1542.27 351.713 1541.1 354.929 1538.77 353.76C1536.44 352.59 1534.1 354.783 1532.79 353.029C1531.62 351.128 1529.43 353.467 1528.56 349.667Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.56 344.112C1531.48 343.966 1532.21 342.504 1532.21 340.311C1532.21 337.972 1532.35 336.949 1534.69 335.78C1537.16 334.756 1539.64 334.172 1540.52 332.125C1541.54 330.079 1543.14 327.448 1543.14 327.448",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.81 328.909C1534.54 330.663 1539.21 331.687 1539.35 333.441",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529.87 331.687C1530.02 334.026 1533.52 336.218 1533.52 336.218",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527.54 337.242C1528.12 338.996 1529.87 339.142 1531.62 340.311",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.19 348.936C1536.73 344.55 1539.21 339.142 1544.75 340.311C1550.29 341.481 1550.88 335.78 1550.88 335.78",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.94 337.972C1534.54 337.972 1538.77 339.288 1539.06 341.919",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.75 345.866C1535.85 345.427 1532.94 346.597 1531.18 348.497",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.81 330.517C1545.48 331.394 1543.29 333.441 1543.14 337.388",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.6 351.275C1542.56 348.936 1541.39 346.158 1544.31 344.989",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.24 386.942C1784.24 386.942 1772.42 380.364 1771.11 379.633C1769.8 378.902 1768.05 378.756 1765.71 379.049C1763.38 379.487 1755.94 379.926 1750.25 376.71C1744.42 373.494 1737.27 360.776 1744.71 347.328C1752.15 333.879 1764.26 337.534 1767.76 339.434C1771.11 341.335 1773.01 344.258 1775.78 343.966C1778.7 343.673 1782.2 342.65 1783.22 343.235C1784.24 343.82 1782.2 346.889 1783.22 347.62C1784.24 348.351 1788.47 351.859 1789.78 352.737C1791.09 353.614 1791.24 354.929 1790.07 357.122C1788.91 359.461 1786.86 364.138 1789.05 365.454C1791.24 366.623 1795.32 368.962 1795.32 368.962",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.26 326.278L1758.13 333.149",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.65 328.909L1750.98 334.61",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.46 334.61L1743.11 339.58",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.19 343.381L1738.73 346.597",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.69 353.76L1735.82 354.491",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.54 364.577L1735.67 363.7",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.19 374.079L1738.15 371.447",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.86 354.052C1770.97 352.883 1772.42 349.959 1770.67 349.374C1768.92 348.79 1768.05 346.305 1766.59 346.158C1764.99 346.158 1762.94 343.235 1761.19 344.404C1759.44 345.72 1757.69 342.796 1756.09 345.281C1754.48 347.62 1752.73 346.012 1751.42 348.497C1750.11 350.982 1747.63 351.128 1748.36 353.467C1748.94 355.806 1745.3 357.414 1747.48 359.314C1749.67 361.069 1746.46 362.53 1748.07 363.554C1749.53 364.577 1749.82 368.816 1752.59 369.108C1755.51 369.547 1755.65 372.471 1757.69 371.301C1759.59 370.132 1760.76 373.932 1763.24 372.178C1765.71 370.278 1767.9 372.471 1769.07 369.693C1770.24 366.916 1773.44 367.062 1773.3 364.577C1773.15 362.092 1775.78 360.63 1774.61 358.876C1773.15 357.268 1776.07 356.099 1772.86 354.052Z",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.76 352.152C1766.59 354.783 1765.13 354.929 1763.09 354.198C1761.05 353.321 1760.03 353.175 1758.28 354.929C1756.53 356.683 1755.21 358.876 1753.03 359.022C1750.84 359.168 1747.92 359.753 1747.92 359.753",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.44 351.713C1753.75 353.029 1753.17 357.56 1754.63 358.291",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.23 349.082C1758.28 349.959 1759.15 353.906 1759.15 353.906",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.07 348.936C1763.53 350.105 1762.94 351.713 1763.53 353.613",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.92 362.53C1765.57 359.753 1759.88 360.045 1759.01 365.6C1758.13 371.009 1752.88 369.547 1752.88 369.547",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.9 354.052C1760.32 355.514 1760.17 359.753 1762.36 360.922",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.3 361.069C1766.59 359.168 1768.63 356.976 1770.82 356.099",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.23 364.869C1750.84 362.969 1753.46 361.8 1756.96 362.969",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.92 368.962C1767.61 366.331 1765.42 364.285 1763.38 366.623",
    stroke: "black",
    strokeWidth: 1.3137,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.82 130.838C1763.82 130.838 1764.99 120.751 1765.28 119.143C1765.42 118.412 1766.3 117.681 1767.76 117.828C1769.65 118.12 1769.65 120.02 1769.65 120.02C1769.65 120.02 1801.59 123.967 1803.93 124.26C1806.26 124.552 1808.45 126.891 1808.01 130.838C1807.57 134.784 1804.8 136.1 1802.62 135.954C1800.57 135.661 1768.19 131.715 1768.19 131.715C1768.19 131.715 1767.76 133.615 1765.57 133.323C1764.11 133.176 1763.67 131.715 1763.82 130.838Z",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.36 127.183L1768.92 131.422",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.55 129.376L1771.26 131.715",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.76 127.914L1774.17 132.153",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.95 130.107L1776.65 132.446",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.01 128.499L1779.57 132.738",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.2 130.691L1781.9 133.03",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.6 121.336C1808.6 121.336 1811.66 96.9241 1811.95 94.4391C1812.24 91.954 1809.03 87.7149 1804.66 89.1767C1800.14 90.6384 1776.8 98.6783 1776.8 98.6783L1763.53 97.0703C1763.53 97.0703 1763.24 95.17 1761.19 94.8776C1759.88 94.7314 1759.01 95.7547 1758.86 96.4856C1758.71 97.2165 1757.55 107.449 1757.4 108.618C1757.26 109.349 1757.98 110.226 1759.3 110.373C1761.19 110.665 1761.78 108.765 1761.78 108.765C1761.78 108.765 1773.01 110.08 1773.59 110.226C1774.17 110.226 1787.74 119.143 1787.74 119.143",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.38 97.0703L1762.94 101.309",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.15 97.3627L1765.86 99.7015",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.36 97.8011L1768.78 102.04",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.99 98.0935L1771.69 100.432",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.38 94.0005C1793.14 94.5852 1799.7 106.279 1798.97 118.12",
    stroke: "black",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.03 234.478C1607.03 234.478 1611.4 228.485 1612.13 227.461C1612.42 227.023 1613.3 226.877 1614.17 227.608C1615.34 228.485 1614.61 229.8 1614.61 229.8C1614.61 229.8 1633.86 243.98 1635.32 245.003C1636.78 246.026 1637.37 248.365 1635.61 250.704C1633.86 253.043 1631.53 253.043 1630.36 252.019C1629.05 251.142 1609.65 236.817 1609.65 236.817C1609.65 236.817 1608.78 237.986 1607.47 236.963C1606.44 236.086 1606.59 235.063 1607.03 234.478Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.99 234.186L1610.09 236.817",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.57 236.378L1611.55 237.84",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.2 236.525L1613.3 239.156",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.78 238.717L1614.76 240.179",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.4 238.863L1616.51 241.495",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.99 241.202L1617.97 242.518",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.41 244.564C1639.41 244.564 1650.2 229.8 1651.22 228.339C1652.24 226.877 1651.8 222.93 1648.45 222.199C1645.1 221.468 1626.86 218.252 1626.86 218.252L1618.84 212.405C1618.84 212.405 1619.28 211.089 1618.11 210.212C1617.24 209.628 1616.36 209.92 1616.07 210.359C1615.78 210.797 1611.26 216.937 1610.67 217.667C1610.38 218.106 1610.53 218.837 1611.26 219.422C1612.42 220.299 1613.45 219.275 1613.45 219.275C1613.45 219.275 1620.15 224.246 1620.59 224.538C1620.88 224.83 1626.57 235.501 1626.57 235.501",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.99 212.551L1617.09 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.59 213.721L1619.57 215.036",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.49 215.182L1620.59 217.667",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.09 216.352L1623.07 217.668",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.24 220.591C1639.12 221.614 1639.26 231.554 1634.45 239.01",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.9 95.3161L1734.5 127.622L1741.65 128.937L1747.19 96.3393L1744.42 88.738L1739.9 95.3161Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.19 96.3393C1747.19 96.3393 1743.98 97.9473 1739.75 95.1699",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.38 122.651L1742.38 123.967",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.61 306.836L1553.94 279.793L1547.96 283.886L1566.48 311.222L1573.92 314.73L1572.61 306.836Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.48 311.222C1566.48 311.222 1567.65 307.86 1572.61 306.836",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.85 284.033L1551.02 287.833",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.16 345.281L1805.68 294.996L1794.45 295.434L1796.78 346.012L1803.49 356.537L1808.16 345.281Z",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.78 346.012C1796.78 346.012 1801.01 342.504 1808.16 345.281",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.97 302.89L1795.18 303.036",
    stroke: "black",
    strokeWidth: 1.2749,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.47 46.6387L1797.22 23.1039L1792.11 17.9877L1769.07 41.5224L1767.03 49.416L1774.47 46.6387Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.07 41.5223C1769.07 41.5223 1772.57 41.9609 1774.47 46.6386",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.72 26.7583L1788.76 21.6421",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1897.36 189.539C1902.09 185.635 1902.76 178.634 1898.86 173.9C1894.97 169.166 1887.98 168.493 1883.26 172.397C1878.54 176.3 1877.87 183.302 1881.76 188.036C1885.66 192.769 1892.64 193.442 1897.36 189.539Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.91 180.977L1874.87 180.831C1874.87 184.777 1876.33 188.724 1879.25 191.794C1885.23 197.933 1895 198.08 1901.12 192.086C1904.19 189.163 1905.79 185.216 1905.79 181.269H1903.9",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.6 173.083C1884.21 176.591 1893.1 180.977 1898.35 173.229",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.85 186.239C1884.21 182.439 1893.98 180.538 1900.25 186.093",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.6 194.425L1901.12 191.94",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.69 204.219L1913.23 191.94C1913.23 191.94 1911.19 190.04 1909 192.233C1907.98 191.209 1906.81 191.502 1905.65 192.671C1904.48 193.84 1902.15 196.033 1901.42 196.91C1900.69 197.641 1900.1 199.249 1901.12 200.272C1900.25 201.003 1899.08 202.611 1900.69 204.219Z",
    stroke: "black",
    strokeWidth: 0.701,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.49 320.577L1813.9 353.467L1821.2 353.76L1821.93 320.723L1818.13 313.561L1814.49 320.577Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.93 320.723C1821.93 320.723 1819.01 322.77 1814.49 320.723",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.05 348.351L1821.05 348.643",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.43 364.285L1855.18 335.195L1826.59 305.813L1825.43 364.285ZM1844.83 334.756L1833.59 345.72L1834.03 323.647L1844.83 334.756Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.53 314.438L1831.55 313.561",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.99 317.946L1833.89 316.046",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.2 319.262L1836.22 318.385",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.66 322.77L1838.55 320.87",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.87 324.085L1840.74 323.208",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.33 327.594L1843.22 325.693",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.53 328.763L1845.41 327.886",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.99 332.418L1847.89 330.371",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.2 333.587L1850.08 332.71",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948.96 195.595L1920.09 210.212L1935.25 181.561L1964.28 166.944L1948.96 195.595Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.41 134.346L1825.14 163.874L1819.01 132.007L1832.14 102.479L1838.41 134.346Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.76 114.027L1855.62 116.366C1855.62 116.366 1860.87 121.774 1859.26 136.392C1857.66 151.01 1851.24 155.249 1851.24 155.249L1830.39 152.91",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.18 160.804L1853.29 163.728",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1856.64 161.243C1858.39 161.389 1859.56 162.997 1859.26 164.605C1859.12 166.359 1857.51 167.528 1855.91 167.236C1854.16 167.09 1852.99 165.482 1853.29 163.874C1853.43 162.266 1854.89 160.95 1856.64 161.243Z",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1862.04 166.067C1862.04 166.067 1865.1 168.698 1868.31 168.99C1868.45 167.382 1869.18 161.681 1869.18 161.681C1869.18 161.681 1864.52 161.681 1862.33 163.143",
    stroke: "black",
    strokeWidth: 1.2213,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1908.6 109.499L1882.27 135.204L1917.18 171.119L1943.51 145.414L1908.6 109.499Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.67 111.103L1914.69 109.934L1949.69 145.894L1923.29 171.767L1922.13 170.452",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.25 126.375L1888.06 135.351L1896.81 144.356L1906 135.38L1897.25 126.375Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.54 123.529L1907.98 116.22",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.75 126.744L1911.19 119.582",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.02 149.987L1922.27 131.276",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1906.67 153.787L1925.77 135.077",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910.31 157.442L1929.42 138.731",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.81 15.6046L1884.05 15.401L1883.78 65.5402L1920.53 65.7438L1920.81 15.6046Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.29 20.1803H1924.9L1924.61 70.3195L1887.71 70.1733V68.4192",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.01 19.6319L1888.18 19.5608L1888.11 32.1321L1900.94 32.2032L1901.01 19.6319Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.35 19.8879H1915.71",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.21 24.4194L1915.71 24.5656",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.58 40.4991L1915.27 40.6453",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.58 45.7616L1915.27 45.9078",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.44 50.8778L1915.27 51.024",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.99 184.064L1817.12 186.486L1820.39 239.156L1859.26 236.734L1855.99 184.064Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.02 189.031L1823.07 190.773L1823.46 197.047L1851.41 195.305L1851.02 189.031Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.98 204.692L1823.73 206.452L1825.42 233.59L1853.66 231.83L1851.98 204.692Z",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.82 205.973L1839.57 232.578",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.41 212.99L1832.57 232.87",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.12 205.535L1846.72 231.993",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.41 213.428L1851.97 211.674",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.84 220.299L1852.41 218.545",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825.28 227.169L1852.85 225.415",
    stroke: "black",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.14 219.714L1882.89 215.036L1870.2 225.123L1872.98 241.787L1888 247.488L1900.54 236.963L1898.79 224.684",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.69 221.907C1900.1 223.515 1898.35 224.246 1896.75 223.661C1895.14 223.076 1894.42 221.322 1895 219.714C1895.58 218.106 1897.33 217.375 1898.94 217.96C1900.54 218.691 1901.27 220.445 1900.69 221.907Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883.77 209.482C1883.33 210.651 1881.87 211.382 1880.71 210.797C1879.54 210.359 1878.81 208.897 1879.39 207.727C1879.83 206.558 1881.29 205.827 1882.46 206.412C1883.62 206.85 1884.21 208.312 1883.77 209.482Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.41 250.704C1865.68 252.458 1863.79 253.335 1862.04 252.75C1860.29 252.019 1859.41 250.119 1859.99 248.365C1860.72 246.611 1862.62 245.734 1864.37 246.318C1866.12 246.903 1867 248.95 1866.41 250.704Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1887.56 268.391C1887.12 269.707 1885.52 270.438 1884.21 269.853C1882.89 269.415 1882.16 267.807 1882.75 266.491C1883.18 265.176 1884.79 264.445 1886.1 265.029C1887.41 265.614 1888.14 267.076 1887.56 268.391Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.91 273.189C1907.99 272.959 1909.49 271.082 1909.26 268.995C1909.03 266.909 1907.16 265.404 1905.08 265.633C1903 265.862 1901.5 267.74 1901.72 269.826C1901.95 271.913 1903.83 273.418 1905.91 273.189Z",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900.54 236.963L1915.42 242.664L1918.33 258.89L1908.56 266.637",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888 247.488L1890.62 263.421L1902 267.807",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922.13 236.963L1915.42 242.664",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.02 211.236L1882.89 215.036",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.68 247.196L1872.98 241.787",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.62 263.421L1887.27 265.614",
    stroke: "black",
    strokeWidth: 1.143,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.89 47.6619C1875.89 47.6619 1865.83 38.1603 1864.81 37.1371C1863.64 36.1138 1862.91 34.3597 1862.62 32.0208C1862.33 29.682 1860.43 22.2269 1855.62 17.6953C1850.66 13.0176 1836.07 10.0941 1825.43 21.496C1814.63 32.8979 1821.93 43.7151 1824.84 46.3463C1827.76 49.1237 1831.12 50.0008 1831.7 52.7782C1832.28 55.7017 1832.43 59.3562 1833.3 60.2333C1834.18 60.9642 1836.51 58.0406 1837.53 58.7715C1838.55 59.5024 1843.22 62.5721 1844.53 63.5954C1845.85 64.6186 1847.01 64.4724 1848.91 62.5721C1850.81 60.6718 1854.74 57.3097 1856.64 59.0639C1858.54 60.818 1861.89 64.0339 1861.89 64.0339",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.8 40.0607L1815.66 38.8912",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.65 30.9976L1814.78 31.4361",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.28 20.1804L1817.26 22.2269",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1817.84 11.4097L1822.66 15.795",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.89 4.68542L1829.51 10.5326",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.24 1.32336L1838.41 7.60904",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.6 1.76184L1846.58 7.60898",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.45 46.6387C1838.7 45.1769 1836.37 47.5158 1835.35 45.9078C1834.18 44.2998 1831.55 44.446 1830.97 42.8381C1830.39 41.3763 1826.89 40.2068 1827.62 38.1603C1828.34 35.9677 1824.99 35.2368 1826.89 32.8979C1828.64 30.5591 1826.59 29.3896 1828.49 27.3431C1830.39 25.2966 1829.8 22.9578 1832.28 22.8116C1834.76 22.6654 1835.2 18.5724 1837.68 20.1804C1840.16 21.7884 1840.45 18.2801 1842.05 19.3033C1843.51 20.4728 1847.6 19.3033 1848.91 21.9345C1850.22 24.5657 1853.14 23.8349 1852.56 26.1737C1851.97 28.5126 1856.2 28.3664 1855.04 31.29C1854.01 34.2135 1856.79 35.8215 1854.45 37.7218C1852.12 39.6221 1853.28 42.8381 1850.81 43.4228C1848.33 44.0075 1847.74 47.0772 1845.7 46.4925C1843.8 46.054 1843.51 49.1237 1840.45 46.6387Z",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.24 42.3995C1839.43 40.4992 1839.14 39.0374 1837.68 37.2832C1836.22 35.5291 1835.64 34.652 1836.95 32.3132C1838.12 29.9743 1839.87 28.074 1839.28 25.8813C1838.85 23.6886 1838.41 20.6189 1838.41 20.6189",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.99 27.6355C1833.74 28.5125 1837.82 26.6122 1838.99 27.7816",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.68 32.0209C1832.14 33.775 1836.22 33.3365 1836.22 33.3365",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1832.14 37.8679C1833.74 38.8912 1835.05 37.8679 1837.1 37.8679",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.6 40.3529C1843.8 37.8679 1842.49 32.3131 1847.45 29.6819C1852.41 27.1969 1849.35 22.5192 1849.35 22.5192",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.8 35.0905C1838.12 34.0673 1842.2 32.6055 1843.95 34.3596",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.26 38.3064C1843.51 39.1835 1842.05 41.8147 1841.91 44.2997",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.66 20.3265C1842.35 22.373 1841.91 25.2966 1844.24 28.5125",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.72 38.3064C1850.66 37.7217 1848.18 36.4061 1849.64 33.7749",
    stroke: "black",
    strokeWidth: 1.3411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.45 312.976C1868.45 312.976 1857.66 306.983 1856.49 306.252C1855.33 305.521 1853.72 305.375 1851.53 305.813C1849.35 306.106 1842.64 306.69 1837.24 303.62C1831.99 300.697 1825.28 289.003 1832.14 276.577C1838.99 264.152 1850.22 267.514 1853.28 269.269C1856.49 271.023 1858.1 273.654 1860.72 273.362C1863.35 273.069 1866.56 272.192 1867.58 272.631C1868.45 273.069 1866.56 275.993 1867.58 276.724C1868.45 277.455 1872.39 280.67 1873.7 281.401C1874.87 282.278 1875.02 283.302 1874 285.494C1872.97 287.687 1871.08 291.926 1873.12 293.096C1875.16 294.265 1878.81 296.312 1878.81 296.312",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.51 257.282L1844.39 263.421",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.64 259.621L1837.82 264.737",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.18 264.883L1830.68 269.415",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.34 272.923L1826.45 275.847",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818.28 282.425L1823.97 283.155",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818.13 292.365L1823.82 291.634",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.49 301.135L1826.01 298.65",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.95 282.717C1856.2 281.547 1857.51 279.062 1855.91 278.478C1854.31 277.893 1853.58 275.554 1852.12 275.554C1850.66 275.554 1848.76 272.777 1847.16 273.946C1845.55 275.116 1843.95 272.484 1842.49 274.677C1841.03 276.87 1839.43 275.408 1838.26 277.601C1837.1 279.793 1834.91 279.94 1835.35 282.132C1835.93 284.325 1832.57 285.787 1834.62 287.541C1836.66 289.149 1833.74 290.464 1835.05 291.488C1836.51 292.511 1836.66 296.312 1839.28 296.604C1841.91 296.896 1842.05 299.674 1843.95 298.65C1845.7 297.481 1846.72 301.135 1849.06 299.381C1851.24 297.627 1853.43 299.674 1854.45 297.189C1855.47 294.704 1858.54 294.85 1858.39 292.511C1858.24 290.172 1860.58 288.856 1859.56 287.395C1858.24 285.64 1860.87 284.617 1857.95 282.717Z",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.29 280.963C1852.26 283.302 1850.81 283.594 1849.06 282.863C1847.16 282.132 1846.28 281.84 1844.53 283.594C1842.93 285.202 1841.76 287.248 1839.72 287.395C1837.68 287.541 1835.05 288.126 1835.05 288.126",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.14 280.524C1840.45 281.694 1839.87 285.933 1841.18 286.518",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842.64 278.185C1844.53 279.062 1845.26 282.571 1845.26 282.571",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848.03 278.039C1849.35 279.062 1848.91 280.524 1849.35 282.278",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.45 290.464C1851.39 287.833 1846.14 288.272 1845.26 293.242C1844.39 298.212 1839.72 296.896 1839.72 296.896",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.87 282.717C1846.28 284.033 1846.14 287.979 1848.18 289.003",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.97 289.149C1852.26 287.395 1854.16 285.348 1856.2 284.617",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.22 292.657C1837.68 290.903 1840.01 289.88 1843.37 290.903",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.31 296.458C1852.99 293.973 1851.1 292.218 1849.35 294.265",
    stroke: "black",
    strokeWidth: 1.2077,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852.99 97.2165C1852.99 97.2165 1857.37 91.2232 1858.1 90.1999C1858.39 89.7614 1859.26 89.6152 1860.14 90.3461C1861.31 91.2232 1860.58 92.5388 1860.58 92.5388C1860.58 92.5388 1879.83 106.718 1881.29 107.741C1882.75 108.765 1883.33 111.103 1881.58 113.442C1879.83 115.781 1877.5 115.781 1876.33 114.758C1875.02 113.881 1855.62 99.5553 1855.62 99.5553C1855.62 99.5553 1854.74 100.725 1853.43 99.7015C1852.41 98.8245 1852.7 97.8012 1852.99 97.2165Z",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.95 96.9241L1856.06 99.5553",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.54 99.1167L1857.51 100.578",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.16 99.2629L1859.26 101.894",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.74 101.456L1860.72 102.917",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.37 101.602L1862.47 104.233",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.95 103.794L1863.93 105.256",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.37 107.303C1885.37 107.303 1896.17 92.5386 1897.19 91.0769C1898.21 89.6151 1897.77 85.6683 1894.42 84.9374C1891.06 84.2065 1872.83 80.9905 1872.83 80.9905L1864.81 75.1434C1864.81 75.1434 1865.24 73.8278 1864.08 72.9507C1863.2 72.366 1862.33 72.6584 1862.04 73.0969C1861.74 73.5354 1857.22 79.6749 1856.64 80.4058C1856.35 80.8444 1856.49 81.5753 1857.22 82.16C1858.39 83.037 1859.41 82.0138 1859.41 82.0138C1859.41 82.0138 1866.12 86.9839 1866.56 87.2762C1866.85 87.5686 1872.54 98.2396 1872.54 98.2396",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.95 75.2897L1863.06 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.56 76.4591L1865.54 77.7747",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.45 77.9208L1866.7 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870.2 79.0902L1869.18 80.4058",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.21 83.3295C1885.08 84.3527 1885.23 94.2929 1880.41 101.748",
    stroke: "black",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1822.51 69.8811L1839.14 98.0936L1845.41 94.5853L1828.93 65.9343L1821.78 61.8413L1822.51 69.8811Z",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.93 65.9343C1828.93 65.9343 1827.62 69.2964 1822.51 69.735",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.51 93.7082L1842.78 90.3461",
    stroke: "black",
    strokeWidth: 0.8314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829.37 383.434H1879.98V333.441L1829.37 383.434ZM1871.37 374.225H1852.26L1871.37 355.368V374.225Z",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 344.404H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 348.643H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 352.444H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 356.829H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 360.63H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 364.869H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 368.816H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.43 373.055H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.18 376.856H1877.64",
    stroke: "black",
    strokeWidth: 1.0132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935.84 372.909C1935.84 372.909 1933.8 359.022 1933.5 357.414C1933.21 355.952 1933.8 354.052 1934.96 351.859C1936.13 349.667 1939.34 342.65 1938.32 335.78C1937.3 328.909 1927.52 317.215 1911.63 319.554C1895.73 321.893 1894.85 335.195 1895.44 339.142C1896.02 343.235 1898.21 346.012 1896.89 348.643C1895.58 351.275 1893.25 354.344 1893.39 355.514C1893.54 356.683 1897.33 355.806 1897.77 357.122C1898.06 358.291 1899.96 363.846 1900.4 365.454C1900.83 367.062 1901.85 367.647 1904.62 367.354C1907.4 367.062 1912.65 366.77 1913.08 369.401C1913.52 372.032 1914.11 376.71 1914.11 376.71",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1886.83 324.232L1893.1 327.594",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892.37 316.776L1897.04 321.162",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1901.27 309.906L1904.77 315.315",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.21 306.836L1913.23 313.561",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1907.98 349.667C1907.54 347.328 1904.19 347.766 1904.33 345.866C1904.48 343.966 1902.29 342.212 1902.73 340.75C1903.17 339.142 1901.12 336.072 1903.02 334.903C1904.92 333.587 1902.73 330.956 1905.65 330.225C1908.56 329.494 1907.54 327.301 1910.46 326.863C1913.38 326.424 1914.4 324.232 1916.44 325.547C1918.48 327.009 1921.4 324.085 1922.42 326.863C1923.44 329.64 1925.92 327.009 1926.36 328.909C1926.79 330.81 1930.88 332.418 1930.15 335.341C1929.42 338.265 1932.34 339.58 1930.44 341.042C1928.54 342.504 1931.9 344.989 1929.27 346.743C1926.65 348.497 1927.82 351.421 1924.75 351.567C1921.69 351.713 1920.52 354.929 1918.19 353.76C1915.86 352.59 1913.52 354.783 1912.21 353.029C1911.04 351.128 1908.85 353.467 1907.98 349.667Z",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1907.98 344.112C1910.9 343.966 1911.63 342.504 1911.63 340.311C1911.63 337.972 1911.77 336.949 1914.11 335.78C1916.58 334.756 1919.06 334.172 1919.94 332.125C1920.96 330.079 1922.56 327.448 1922.56 327.448",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.23 328.909C1913.96 330.663 1918.63 331.687 1918.77 333.441",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.29 331.687C1909.44 334.026 1912.94 336.218 1912.94 336.218",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1906.96 337.242C1907.54 338.996 1909.29 339.142 1911.04 340.311",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.61 348.936C1916.15 344.55 1918.63 339.142 1924.17 340.311C1929.71 341.481 1930.29 335.78 1930.29 335.78",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.36 337.972C1913.96 337.972 1918.19 339.288 1918.48 341.919",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.17 345.866C1915.27 345.427 1912.36 346.597 1910.6 348.497",
    stroke: "black",
    strokeWidth: 1.3699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedBg1);
export default __webpack_public_path__ + "static/media/featuredBG1.fca0cb959b800de9b06e2596e660d304.svg";
export { ForwardRef as ReactComponent };